export const values = {
    aumico_reports_side_bar_feedback: 'Feedback',
    aumico_admin_navigation_feedback: 'Feedback',
    aumico_alert_duplicate_prior_year_title:
        "<strong>Important : Données de l'année précédente manquantes pour les comptes en double</strong>",
    aumico_alert_duplicate_prior_year_main_warning:
        "Nous avons détecté que votre fichier contient des comptes qui étaient dupliqués l'année précédente (même numéro/nom) et ne peuvent pas être mappés de manière unique à une valeur d'année précédente.",
    aumico_alert_duplicate_prior_year_action_integrity:
        "Pour garantir que ces comptes reçoivent la valeur correcte de l'année précédente et maintiennent l'intégrité des données, nous exigeons une <strong>correspondance explicite</strong> pour cette valeur.",
    aumico_alert_duplicate_prior_year_action_required:
        "<strong>Action requise :</strong> Veuillez inclure une colonne séparée dans votre fichier de téléchargement qui contient les valeurs correctes de l'année précédente pour ces comptes spécifiques. C'est la seule façon de garantir un mappage précis. Veuillez corriger cela et recommencer le téléchargement.",
    aumico_alert_fixed_balance_sheet:
        'Corrigé avec la colonne <strong>{{priorYearUnmatchableAccountsDetectedBalanceFixedColNo}}</strong> pour le <strong>bilan</strong>.',
    aumico_alert_fixed_income_statement:
        'Corrigé avec la colonne <strong>{{priorYearUnmatchableAccountsDetectedIncomeFixedColNo}}</strong> pour le <strong>compte de résultat</strong>.',
    aumico_templates_account_mapping_child_form_summarize_error_mapped_account:
        'Les comptes ne peuvent pas être résumés car au moins un compte avec le même numéro de compte est déjà mappé. Veuillez supprimer ce mappage et réessayer.',
    aumico_release_slide_1_html: `
        <h2>Intégrations Abacus et Business Central</h2>
        <p>Grâce aux intégrations natives pour Abacus et Microsoft Dynamics 365 Business Central, tu importes le journal comptable de tes mandants directement dans aumico. Pas d'export CSV manuel, pas de détour par Excel. Tu configures la connexion une seule fois, ensuite elle reste active.</p>
        <ul>
            <li><strong>Connexion unique</strong> — Configurer la connexion une seule fois par mandant, ensuite l'import se fait automatiquement</li>
            <li><strong>Import automatique des données</strong> — Journal comptable, soldes de comptes, bilan et compte de résultat sont construits directement dans aumico</li>
            <li><strong>Aucune rupture de médias</strong> — Pas d'export manuel depuis Abacus ou Business Central, pas de traitement dans Excel</li>
        </ul>
    `,

    aumico_release_slide_2_html: `
        <h2>Comparaison pluriannuelle</h2>
        <p>Dans le nouvel onglet Analytics du profil d'entreprise, tu compares les chiffres d'un mandant sur un nombre d'années illimité. aumico applique la structure de rapport la plus récente à toutes les années historiques. Les séries restent ainsi cohérentes, même si le bilan ou le compte de résultat ont changé entre-temps.</p>
        <ul>
            <li><strong>Nombre d'années illimité</strong> — Tu définis la période, trois, cinq ans ou plus</li>
            <li><strong>Structure harmonisée</strong> — La structure la plus récente sert de référence, les anciennes structures y sont automatiquement rattachées</li>
            <li><strong>Sans effort supplémentaire</strong> — Basé sur les données déjà présentes dans aumico. Aucune ressaisie, pas d'Excel</li>
        </ul>
    `,

    aumico_release_slide_3_html: `
        <h2>Reclassifications directement dans le mappage des comptes</h2>
        <p>Tu saisis désormais les reclassifications directement dans le mappage des comptes, dans l'onglet Reclassification / Renommer. Clique sur le montant, choisis le compte cible, définis le montant. aumico comptabilise automatiquement la contrepartie. Les reclassifications commerciales sont ainsi clairement séparées des réserves latentes fiscales.</p>
        <ul>
            <li><strong>Toujours équilibré</strong> — Chaque reclassification a un compte source et un compte cible, les écritures non équilibrées sont exclues</li>
            <li><strong>Exercice courant et exercice précédent</strong> — Les deux périodes dans le même tableau, même logique</li>
            <li><strong>Créer le compte cible directement</strong> — Si le compte manque, tu le crées dans la fenêtre, sans interrompre la reclassification</li>
            <li><strong>Tous les rapports se recalculent immédiatement</strong> — Les montants reclassés alimentent automatiquement le tableau des flux de trésorerie, l'annexe, la proposition d'affectation du bénéfice, le tableau de variation des capitaux propres et le tableau des immobilisations</li>
        </ul>
    `,

    aumico_release_slide_4_html: `
        <h2>Tous les éléments du rapport dans les clôtures intermédiaires</h2>
        <p>Les rapports trimestriels, mensuels et individuels t'offrent désormais les mêmes éléments que le rapport annuel. Bilan, compte de résultat, annexe et tous les autres éléments sont disponibles. Mêmes modèles, quel que soit le type de rapport.</p>
        <ul>
            <li><strong>Tous les éléments disponibles</strong> — Annexe et tous les autres éléments également dans la clôture intermédiaire</li>
            <li><strong>Mêmes modèles</strong> — Le modèle choisi fournit dans chaque type de rapport exactement ce qu'il annonce</li>
        </ul>
    `,
    aumico_annual_report_print_options_show_grouped_and_masked: 'Appliquer le regroupement et le masquage',
    aumico_reports_annualreport_navigation_import_grouping_masking: 'Reclasser / Regrouper',
    aumico_grouping_masking_assets: '(Actifs)',
    aumico_grouping_masking_liabilities: '(Passifs)',
    aumico_grouping_masking_splitted: 'Divisé',
    aumico_grouping_masking_edit_group_name: 'Modifier le nom du groupe',
    aumico_grouping_masking_define_bsa: 'Définir comme compte de bascule de solde',
    aumico_grouping_masking_remove_bsa: 'Supprimer le compte de bascule de solde',
    aumico_grouping_masking_ungroup: 'Dissocier les comptes',
    aumico_grouping_masking_remove_from_group: 'Retirer le compte du groupe',
    aumico_grouping_masking_remove_original_name: "Nom d'origine : {{value}}",
    aumico_grouping_masking_rename_modal_title: 'Masquer les noms de compte',
    aumico_grouping_masking_rename_modal_text:
        "Saisis un nouveau nom d'affichage pour les comptes sélectionnés. Cette modification est uniquement visuelle et n'affectera pas le mappage des comptes.",
    aumico_grouping_masking_rename_modal_label_original: "Compte d'origine",
    aumico_grouping_masking_rename_modal_label_new: "Nouveau nom d'affichage",
    aumico_grouping_masking_rename_modal_label_placeholder: "Saisir le nouveau nom d'affichage",
    aumico_grouping_masking_rename_modal_label_delete: 'Supprimer le masquage',
    aumico_grouping_masking_modal_apply: 'Appliquer',
    aumico_grouping_masking_modal_cancel: 'Annuler',
    aumico_grouping_masking_grouping_modal_title: 'Regrouper les comptes',
    aumico_grouping_masking_grouping_modal_text: 'Nom du groupe',
    aumico_grouping_masking_grouping_modal_label_placeholder: 'Saisir le nom du groupe',
    aumico_grouping_masking_split_modal_title: 'Basculer les comptes',
    aumico_grouping_masking_split_modal_title_start: 'POSITION DE DÉPART',
    aumico_grouping_masking_split_modal_title_output: 'APERÇU',
    aumico_grouping_masking_split_modal_title_counterpart: 'Où veux-tu attribuer le compte ?',
    aumico_grouping_masking_split_modal_title_counterpart_placeholder: 'Choisir le poste financier',
    aumico_grouping_masking_modal_confirm: 'Oui, je suis sûr',
    aumico_grouping_masking_modal_dismiss: 'Non, annuler',
    aumico_grouping_masking_bulk_action_group: 'Regrouper',
    aumico_grouping_masking_bulk_action_rename: 'Renommer',
    aumico_grouping_masking_bulk_action_delete: 'Supprimer',
    aumico_grouping_masking_bulk_action_accounts_selected: 'Comptes sélectionnés',
    aumico_grouping_masking_confirm_ungroup_text: 'Es-tu sûr de vouloir dissocier les comptes du groupe {{value}} ?',
    aumico_grouping_masking_confirm_unsplitt_text: 'Es-tu sûr de vouloir annuler la division du compte {{value}} ?',

    // REV-20899: Reclassification feature
    aumico_grouping_masking_reclass_column_header_cy: 'Reclassement EX',
    aumico_grouping_masking_reclass_column_header_py: 'Reclassement EP',
    aumico_grouping_masking_reclass_py_lock_tooltip: "Verrouiller les reclassements de l'exercice précédent",
    aumico_grouping_masking_reclass_py_unlock_tooltip: "Déverrouiller les reclassements de l'exercice précédent",
    aumico_grouping_masking_reclass_py_lock_state_locked: 'Verrouillé',
    aumico_grouping_masking_reclass_py_lock_state_editable: 'Modifiable',
    aumico_grouping_masking_reclass_modal_title: 'Reclassement',
    aumico_grouping_masking_reclass_modal_subtitle_source: 'Compte source',
    aumico_grouping_masking_reclass_modal_subtitle_balance: 'Solde',
    aumico_grouping_masking_reclass_modal_period_cy: 'Exercice en cours',
    aumico_grouping_masking_reclass_modal_period_py: 'Exercice précédent',
    aumico_grouping_masking_reclass_modal_incoming_section: 'Reclassements entrants',
    aumico_grouping_masking_reclass_modal_outgoing_section: 'Reclassements sortants',
    aumico_grouping_masking_reclass_modal_amount_label: 'Montant',
    aumico_grouping_masking_reclass_modal_amount_placeholder: '0,00',
    aumico_grouping_masking_reclass_modal_target_label: 'Compte cible',
    aumico_grouping_masking_reclass_modal_target_placeholder: 'Sélectionner un compte...',
    aumico_grouping_masking_reclass_account_badge_tooltip: 'Compte de reclassement',
    aumico_grouping_masking_reclass_generated_account_name_prefix: 'Reclassement de',
    aumico_grouping_masking_reclass_generated_account_name_to: 'vers',
    aumico_grouping_masking_reclass_delete_account_confirm_text:
        'Des reclassements existent sur ce compte. Voulez-vous vraiment supprimer le compte, y compris tous les reclassements attribués ?',
    aumico_grouping_masking_reclass_delete_account_confirm_action: 'Supprimer le compte et les reclassements',
    aumico_grouping_masking_reclass_modal_description_label: 'Motif',
    aumico_grouping_masking_reclass_modal_description_optional: 'facultatif',
    aumico_grouping_masking_reclass_modal_description_placeholder: "p. ex. Reclassement selon exigence d'audit",
    aumico_grouping_masking_reclass_modal_add_entry: 'Ajouter un reclassement',
    aumico_grouping_masking_reclass_modal_delete_entry: 'Supprimer',
    aumico_grouping_masking_reclass_modal_new_account_button: 'Créer un nouveau compte',
    aumico_grouping_masking_reclass_validation_amount_required:
        'Veuillez saisir un montant différent de 0. Les montants négatifs sont autorisés.',
    aumico_grouping_masking_reclass_validation_target_required: 'Veuillez sélectionner un compte cible.',
    aumico_grouping_masking_reclass_validation_exceeds_balance:
        '⚠ Le montant total dépasse le solde du compte. Le compte source affichera un solde négatif.',
    aumico_grouping_masking_reclass_validation_cross_side:
        "⚠ Reclassement entre actifs et passifs. Veuillez vérifier s'il s'agit d'un reclassement ou d'une écriture de transfert.",
    aumico_grouping_masking_reclass_validation_duplicate_target: 'Plusieurs reclassements vers le même compte cible.',
    aumico_grouping_masking_reclass_new_account_modal_title: 'Créer un nouveau compte',
    aumico_grouping_masking_reclass_new_account_number_label: 'Numéro de compte',
    aumico_grouping_masking_reclass_new_account_number_placeholder: 'p. ex. 1099',
    aumico_grouping_masking_reclass_new_account_name_label: 'Nom du compte',
    aumico_grouping_masking_reclass_new_account_name_placeholder: 'p. ex. Compte de transfert',
    aumico_grouping_masking_reclass_new_account_fli_label: 'Sélectionner un FLI',
    aumico_grouping_masking_reclass_new_account_fli_placeholder: 'Sélectionner un FLI...',
    aumico_grouping_masking_reclass_new_account_save: 'Créer',
    aumico_grouping_masking_reclass_new_account_number_required: 'Veuillez saisir un numéro de compte.',
    aumico_grouping_masking_reclass_new_account_number_duplicate: 'Un compte avec ce numéro existe déjà.',
    aumico_grouping_masking_reclass_new_account_name_required: 'Veuillez saisir un nom de compte.',
    aumico_grouping_masking_reclass_new_account_fli_required: 'Veuillez sélectionner un FLI.',
    aumico_grouping_masking_reclass_new_target_choice_title: 'Nouvelle cible de reclassement',
    aumico_grouping_masking_reclass_new_target_choice_prompt: 'Que souhaitez-vous créer ?',
    aumico_grouping_masking_reclass_new_target_choice_account: 'Créer un compte',
    aumico_grouping_masking_reclass_new_target_choice_group: 'Créer un groupe',
    aumico_grouping_masking_reclass_new_group_modal_title: 'Créer un nouveau groupe',
    aumico_grouping_masking_reclass_new_group_name_label: 'Nom du groupe',
    aumico_grouping_masking_reclass_new_group_name_placeholder: 'p. ex. Autres dettes',
    aumico_grouping_masking_reclass_new_group_fli_label: 'Sélectionner le FLI',
    aumico_grouping_masking_reclass_new_group_fli_placeholder: 'Choisir un FLI...',
    aumico_grouping_masking_reclass_new_group_save: 'Créer',
    aumico_grouping_masking_reclass_new_group_name_required: 'Veuillez saisir un nom de groupe.',
    aumico_grouping_masking_reclass_new_group_fli_required: 'Veuillez choisir un FLI.',
    aumico_grouping_masking_reclass_new_group_option_suffix: '(nouveau groupe)',
    aumico_grouping_masking_reclass_new_group_name_exists:
        'Ce poste comporte déjà un groupe portant ce nom. Le reclassement sera ajouté à ce groupe.',
    aumico_grouping_masking_reclass_conflicts_banner:
        'Il y a {{count}} conflit(s) de reclassement non résolu(s). Cliquez ici pour les résoudre.',
    aumico_grouping_masking_reclass_conflicts_show: 'Afficher les conflits',
    aumico_grouping_masking_reclass_conflicts_title: 'Conflits',
    aumico_grouping_masking_reclass_conflicts_description:
        'Les comptes suivants ont été supprimés ou modifiés mais ont encore des reclassements ouverts.',
    aumico_grouping_masking_reclass_conflicts_delete: 'Supprimer',
    aumico_grouping_masking_reclass_conflicts_reassign: 'Réaffecter',
    aumico_grouping_masking_reclass_preview_button: 'Tableau des reclassements',
    aumico_grouping_masking_reclass_preview_title: 'Tableau des reclassements',
    aumico_grouping_masking_reclass_preview_col_from: 'DU COMPTE',
    aumico_grouping_masking_reclass_preview_col_to: 'VERS LE COMPTE',
    aumico_grouping_masking_reclass_preview_col_cy: 'EX ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_py: 'EP ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_description: 'DESCRIPTION',
    aumico_grouping_masking_reclass_preview_section_bs: 'Bilan',
    aumico_grouping_masking_reclass_preview_section_is: 'Compte de résultat',
    aumico_grouping_masking_reclass_preview_footer_note: 'Tous les reclassements actifs pour ce rapport annuel',
    aumico_grouping_masking_reclass_preview_close: 'Fermer',
    aumico_grouping_masking_reclass_preview_export_pdf: 'Exporter PDF',
    aumico_grouping_masking_reclass_preview_empty: 'Aucun reclassement disponible.',
    aumico_grouping_masking_reclass_conflicts_back: 'Retour au tableau',
    aumico_grouping_masking_reclass_conflicts_transactions: 'reclassement(s)',
    aumico_grouping_masking_reclass_conflicts_total: 'Montant total',
    aumico_grouping_masking_reclass_conflicts_cy: 'EX',
    aumico_grouping_masking_reclass_conflicts_py: 'EP',
    aumico_grouping_masking_reclass_conflicts_table_amount: 'Montant',
    aumico_grouping_masking_reclass_conflicts_table_source: 'Source',
    aumico_grouping_masking_reclass_conflicts_table_target: 'Destination',
    aumico_grouping_masking_reclass_conflicts_confirm_delete:
        'Tous les reclassements de ce compte seront définitivement supprimés. Cette action est irréversible. Continuer ?',
    aumico_grouping_masking_reclass_tab_indicator_tooltip: '{{count}} conflit(s) de reclassement non résolu(s)',
    aumico_grouping_masking_disambiguation_modal_title: 'Sélectionner le compte',
    aumico_grouping_masking_disambiguation_modal_description:
        'Le compte {{accountNumber}} «{{accountName}}» apparaît plusieurs fois dans les données financières. Veuillez sélectionner l\'instance souhaitée.',
    aumico_grouping_masking_disambiguation_modal_fli_label: 'FLI',
    aumico_grouping_masking_disambiguation_modal_row_no: 'Ligne',
    aumico_grouping_masking_disambiguation_modal_closing_balance: 'Solde final',
    aumico_grouping_masking_disambiguation_modal_opening_balance: 'Solde initial',
    aumico_grouping_masking_disambiguation_modal_select_button: 'Sélectionner',
    aumico_templates_summarized_accounts_unmapped_tooltip_undo: 'Cliquez pour dissocier les comptes résumés',
    aumico_templates_summarized_accounts_unmapped_tooltip:
        'Cliquez pour fusionner les comptes en un seul compte résumé',
    aumico_templates_summarized_accounts_undo_question: 'Êtes-vous sûr de vouloir annuler le résumé de ce compte?',
    aumico_templates_summarized_accounts_undo_yes_button: 'Annuler le résumé',
    aumico_templates_summarized_accounts_mapped_tooltip: 'Une fois dissocié, vous pouvez modifier les comptes résumés',
    aumico_templates_summarized_accounts_modal_title: 'Résumer les comptes sélectionnés',
    aumico_templates_summarized_accounts_modal_title_save_button: 'Résumer les comptes',
    aumico_templates_summarized_accounts_modal_title_cancel_button: 'Garder séparés',
    aumico_templates_summarized_accounts_modal_table_raw_accounts: 'COMPTES',
    aumico_templates_summarized_accounts_modal_table_sum_account: 'COMPTE RÉSUMÉ',
    aumico_alert_new_shareholder_account_title: "<strong>Nouveau compte d'associé détecté</strong>",
    aumico_alert_new_shareholder_account_main_warning:
        "Nous avons détecté un nouveau compte d'associé qui n'était pas présent l'année précédente. Veuillez vérifier les détails ci-dessous.",
    aumico_lib_annualreport_shareholder: 'Associé',
    aumico_alert_duplicate_prior_year_processed_without_fix:
        'Continuer sans correction. Je vais examiner manuellement ces comptes.',
    aumico_components_subscription_tiers_section_title: 'Découvre nos forfaits et leurs avantages',
    aumico_components_subscription_tiers_current_package: 'Forfait actuel',
    aumico_components_subscription_tiers_most_popular: 'Le plus populaire',
    aumico_components_subscription_tiers_switch_to: 'Passer à {{tierName}}',
    aumico_components_subscription_tiers_tier_light: 'aumico Light',
    aumico_components_subscription_tiers_tier_standard: 'aumico',
    aumico_components_subscription_tiers_tier_pro: 'aumico Pro',
    aumico_components_subscription_tiers_feature_report_generation: 'Génération de rapports',
    aumico_components_subscription_tiers_feature_mandate_task_management: 'Gestion des mandats & tâches',
    aumico_components_subscription_tiers_feature_financial_closing_workflow: 'Workflow de clôture financière',
    aumico_components_subscription_tiers_feature_interim_statements: 'États financiers intermédiaires',
    aumico_components_subscription_tiers_feature_individual_reporting_templates: 'Modèles de reporting individualisés',
    aumico_components_subscription_tiers_feature_employee_training: 'Formation des employés',
    aumico_components_subscription_tiers_feature_dedicated_customer_success_manager: 'Customer Success Manager dédié',
    aumico_components_subscription_tiers_help_title: "Tu n'arrives pas à choisir le meilleur forfait?",
    aumico_components_subscription_tiers_help_description: "On peut t'aider à choisir le bon plan",
    aumico_components_subscription_tiers_contact_sales: 'Contacter les ventes',
    aumico_reports_registration_welcome_privacy_policy_error: 'Vous devez accepter la politique de confidentialité',
    aumico_companies_delete_dialog_text_1: 'Confirmer la suppression',
    aumico_companies_inactivate_button: 'Désactiver',
    aumico_companies_inactivate_dialog_ok: 'Oui, désactiver',
    aumico_companies_inactivate_banner_text:
        "Ce mandat est inactif. Il n'est pas possible d'ajouter de nouveaux projets.",
    aumico_companies_inactivate_dialog_cancel: 'Non, annuler',
    aumico_companies_inactivate_dialog_text_1: 'Confirmer la désactivation',
    aumico_companies_inactivate_dialog_text_2:
        'Êtes-vous sûr de vouloir désactiver cette entreprise ? Cette action ne peut pas être annulée.',
    aumico_users_registration_sub_title:
        "<ul> <li> Aucune carte de crédit et aucune installation requise <li> Support gratuit pendant la période d'essai <li> Sans engagement - Votre compte sera automatiquement désactivé après 10 jours </ul>",
    aumico_templates_switch_accounts_tooltip_1: 'Définir le compte de commutation',
    aumico_templates_switch_accounts_tooltip_2: 'Classé comme compte de commutation.',
    aumico_reports_companies_upload_file_upload_error_format: 'Veuillez télécharger le logo au format .png',
    aumico_admin_menu_item_activate_cpmm: 'Activer CPMM',
    aumico_admin_menu_item_deactivate_cpmm: 'Désactiver CPMM',
    aumico_errors_password_not_match: 'Les mots de passe ne correspondent pas',
    aumico_ui_not_applicable: 'N/A',
    aumico_ui_documents: 'Documents',
    aumico_ui_annotations: 'Annotations',
    aumico_ui_new_task: 'Nouvelle tâche',
    aumico_ui_export_docs_as_zip: 'Exporter les documents en ZIP',
    aumico_ui_export: 'Exporter',
    aumico_ui_view_all: 'Tout afficher',
    aumico_ui_view_less: 'Afficher moins',
    aumico_ui_select: 'Sélectionner',
    aumico_pm_tasks_rename_task: 'Renommer',
    aumico_pm_tasks_not_applicable: 'Non applicable',
    aumico_pm_tasks_mark_applicable: 'Marquer comme applicable',
    aumico_pm_tasks_delete: 'Supprimer',
    aumico_cpmm_task_create_success_title: 'Tâche créée avec succès',
    aumico_cpmm_task_create_success_description: 'La nouvelle tâche a été créée avec succès.',
    aumico_cpmm_task_create_failure_title: 'Erreur lors de la création de la tâche',
    aumico_cpmm_task_create_failure_description: "La tâche n'a pas pu être créée. Veuillez réessayer.",
    aumico_cpmm_task_update_success_title: 'Tâche mise à jour avec succès',
    aumico_cpmm_task_update_success_description: 'La tâche a été mise à jour avec succès.',
    aumico_cpmm_task_update_failure_title: 'Erreur lors de la mise à jour de la tâche',
    aumico_cpmm_task_update_failure_description: "La tâche n'a pas pu être mise à jour. Veuillez réessayer.",
    aumico_cpmm_task_delete_success_title: 'Tâche supprimée avec succès',
    aumico_cpmm_task_bulk_delete_success_title: 'Tâches supprimées avec succès',
    aumico_cpmm_task_delete_success_description: 'La tâche a été supprimée avec succès.',
    aumico_cpmm_task_bulk_delete_success_description: 'Les tâches ont été supprimées avec succès.',
    aumico_cpmm_task_delete_failure_title: 'Erreur lors de la suppression de la tâche',
    aumico_cpmm_task_bulk_delete_failure_title: 'Erreur lors de la suppression des tâches',
    aumico_cpmm_task_delete_failure_description: "La tâche n'a pas pu être supprimée.",
    aumico_cpmm_task_bulk_delete_failure_description: "Les tâches n'ont pas pu être supprimées.",
    aumico_cpmm_annotation_create_success_title: 'Annotation créée',
    aumico_cpmm_annotation_create_success_description: "L'annotation a été créée avec succès.",
    aumico_cpmm_annotation_create_failure_title: 'Annotation non créée',
    aumico_cpmm_annotation_create_failure_description: "L'annotation n'a pas pu être créée.",
    aumico_cpmm_annotation_update_success_title: 'Annotation mise à jour',
    aumico_cpmm_annotation_update_success_description: "L'annotation a été mise à jour avec succès.",
    aumico_cpmm_annotation_update_failure_title: 'Annotation non mise à jour',
    aumico_cpmm_annotation_update_failure_description: "L'annotation n'a pas pu être mise à jour.",
    aumico_cpmm_annotation_delete_success_title: 'Annotation supprimée',
    aumico_cpmm_annotation_delete_success_description: "L'annotation a été supprimée avec succès.",
    aumico_cpmm_annotation_delete_failure_title: 'Annotation non supprimée',
    aumico_cpmm_annotation_delete_failure_description: "L'annotation n'a pas pu être supprimée.",
    aumico_reports_annualreport_import_structure_dialog_title: 'La taxonomie a changé',
    aumico_reports_annualreport_import_structure_dialog_text: 'Souhaitez-vous importer la nouvelle taxonomie ?',
    aumico_reports_annualreport_import_structure_dialog_action_button: 'Oui, changer la taxonomie',
    aumico_legacy_reclasses_autofill_warning_title: 'Remarque importante concernant le transfert des données',
    aumico_legacy_reclasses_autofill_warning_text:
        'Le rapport de l’année précédente contient des reclassements provenant de notre ancien système. Ceux-ci ne peuvent pas être transférés automatiquement dans le nouveau masque « Reclasser et regrouper ». Saisis à nouveau les reclassements de l’année précédente dans ce rapport, en une seule fois, en tant que transactions de l’année précédente. Les données seront ensuite automatiquement mises à jour pour les années suivantes.',
    aumico_legacy_reclasses_autofill_warning_ok: 'OK',
    aumico_annual_report_mapping_help_text_select_fli: "Sélectionnez l'élément de ligne financière",
    aumico_annual_report_mapping_transfer_profit_fli_change_help_text:
        'Ici, vous pouvez modifier les positions financières où le bénéfice doit être transféré.',
    aumico_annual_report_mapping_transfer_surplus_fli_change_help_text:
        "Ici, vous pouvez modifier les positions financières où l'excédent doit être transféré.",
    aumico_annual_report_mapping_uncovered_shortfall_assets_fli_help_text:
        'Ici, vous pouvez sélectionner la position financière dans laquelle le déficit non couvert doit figurer du côté actif.',
    aumico_annual_report_mapping_uncovered_shortfall_liabilities_fli_help_text:
        'Ici, vous pouvez sélectionner la position financière dans laquelle le déficit non couvert doit figurer du côté passif.',

    aumico_annual_report_mapping_settings_section: 'Paramètres',
    aumico_annual_report_execute_button: 'Exécuter',
    aumico_annual_report_cancel_button: 'Annuler',
    aumico_annual_report_mapping_reset_fli_button: 'Réinitialiser les désignations',
    aumico_annual_report_mapping_reset_fli_warning:
        'Appuie sur le bouton "Réinitialiser les désignations" si les groupes et les groupes de comptes sont affichés dans une autre langue que le reste du rapport. En utilisant cette fonction, les groupes et groupes de comptes seront rechargés dans la langue de ton profil actuel.  Les groupes, groupes de comptes ou sous-groupes de comptes que tu as ajoutés toi-même doivent être saisis à nouveau. \nIl s\'agit d\'une solution temporaire !',
    aumico_annual_report_mapping_reset_fli_dialog_content:
        "Cette action ne peut pas être annulée après l'enregistrement. Veuillez vérifier soigneusement la structure du bilan et du compte de résultat après avoir utilisé cette fonction. Tu peux à tout moment recharger les groupes et les groupes de comptes dans ta langue de profil actuelle.",
    aumico_admin_add_user_button: "Ajouter l'utilisateur",
    aumico_admin_change_password_current_password_error: 'Le mot de passe actuel est mauvais',
    aumico_admin_change_password_password_length_error:
        'La longueur du mot de passe doit être de 12 caractères ou plus',
    aumico_admin_confirm_password: 'Confirmez le mot de passe',
    aumico_admin_current_password: 'Mot de passe actuel',
    aumico_admin_edit_localization: 'Modifier la traduction',
    aumico_admin_login_errorMessage: "Le nom d'utilisateur ou le mot de passe n'est pas correct!",
    aumico_admin_login_title: 'Connexion de',
    aumico_admin_manageUsers_role: 'rôle',
    aumico_admin_manageUsers_userName: "Nom d'utilisateur",
    aumico_admin_new_password: 'nouveau mot de passe',
    aumico_admin_password: 'mot de passe',
    aumico_admin_password_changed_successfully: 'Le mot de passe a été modifié avec succès',
    aumico_admin_passwords_doesnot_match: "Mot de passe et suivre le mot de passe n'est pas vrai",
    aumico_admin_templates_balance: 'Bilan',
    aumico_admin_templates_income: 'Compte de résultat',
    aumico_admin_user_created_successfully: 'Un nouvel utilisateur a été créé avec succès',
    aumico_admin_weak_password_error:
        'Le mot de passe doit répondre aux critères suivants: au moins 12 caractères, grandes et petites lettres, symboles et chiffres. Les espaces ne sont pas autorisés',
    aumico_admin_filter_translation_by_name: 'Traductions de filtre',
    aumico_annual_report_file_preview: 'Aperçu des fichiers',
    aumico_annual_report_general_information_autofill_btn_text:
        "Remplissez automatiquement les données de l'entreprise",
    aumico_annual_report_general_information_balance_sheet_date: 'Date du bilan',
    aumico_annual_report_general_information_balance_sheet_date_error:
        "La date du bilan doit être plus grande que la pièce de l'année précédente",
    aumico_annual_report_general_information_basis_of_accounting: 'Norme de comptabilité',
    aumico_annual_report_general_information_create_new_company_btn_text: 'Créer une nouvelle entreprise',
    aumico_reports_annualreport_navigation_import_fx: 'Monnaie fonctionnelle',
    aumico_annual_report_fx_rates_dropzone: 'Déposez un fichier Excel ici ou cliquez',
    aumico_annual_report_fx_rates_dropzone_format: 'Excel avec les colonnes «Date» et «Actual Rate» · cours en {{display}} pour 1 {{functional}}',
    aumico_annual_report_fx_table_step: 'Tableau de conversion',
    aumico_annual_report_fx_table_tab_kontrolle: 'Contrôles',
    aumico_annual_report_fx_table_kontrolle_placeholder: 'Les contrôles (actifs = passifs, résultat du bilan = résultat du compte de résultat) seront ajoutés lors d’une prochaine étape.',
    aumico_annual_report_fx_table_position: 'Position',
    aumico_annual_report_fx_table_kurstyp: 'Type de cours',
    aumico_annual_report_fx_table_method_closing: 'Clôture',
    aumico_annual_report_fx_table_method_average: 'Cours moyen',
    aumico_annual_report_fx_table_reserve: 'Réserve de conversion',
    aumico_annual_report_fx_proof_mixed: 'Mixte',
    aumico_annual_report_fx_proof_rate_effective: 'Cours effectif',
    aumico_annual_report_fx_proof_contribution: 'Contribution',
    aumico_annual_report_fx_proof_at_closing: 'au cours de clôture',
    aumico_annual_report_fx_proof_sum: 'Somme des contributions',
    aumico_annual_report_fx_proof_rounding: 'Écart d’arrondi',
    aumico_annual_report_fx_proof_rounding_hint: 'compris dans la réserve de conversion',
    aumico_annual_report_fx_proof_imbalance: 'Le bilan n’est pas équilibré en monnaie fonctionnelle',
    aumico_annual_report_fx_proof_imbalance_banner: 'Le bilan n’est pas équilibré en monnaie fonctionnelle. La conversion ne peut être correcte tant que cela n’est pas corrigé.',
    aumico_annual_report_fx_proof_check_balance: 'Actifs = passifs',
    aumico_annual_report_fx_proof_check_result: 'Résultat bilan = résultat compte de résultat',
    aumico_annual_report_fx_proof_reason_open: 'Conversion pas encore terminée, positions ouvertes',
    aumico_annual_report_fx_proof_reason_imbalance: 'Bilan non équilibré en monnaie fonctionnelle de',
    aumico_annual_report_fx_proof_reason_result: 'Les résultats diffèrent déjà en monnaie fonctionnelle',
    aumico_annual_report_fx_rounding_assign: 'Attribuer l’écart d’arrondi',
    aumico_annual_report_fx_rounding_change: 'Modifier l’attribution',
    aumico_annual_report_fx_rounding_too_large: 'L’écart atteint {{tolerance}} {{currency}} ou plus — ce n’est pas un arrondi et il ne peut être attribué à aucun compte.',
    aumico_annual_report_fx_rounding_account_missing: 'Le compte attribué n’est plus disponible (reclassé, supprimé ou plus au cours moyen). Veuillez l’attribuer à nouveau.',
    aumico_annual_report_fx_rounding_booked: 'Contient {{amount}} d’écart d’arrondi sur {{account}}',
    aumico_annual_report_fx_rounding_cell_hint: 'Contient l’écart d’arrondi attribué (Contrôle) :',
    aumico_annual_report_fx_rounding_dialog_title: 'Attribuer l’écart d’arrondi',
    aumico_annual_report_fx_rounding_dialog_body: 'Chaque compte est converti séparément et arrondi au centime, alors que le bilan n’arrondit le résultat de l’exercice qu’une seule fois. C’est pourquoi les deux résultats diffèrent de quelques centimes. Attribuez l’écart à un compte du compte de résultat : son montant est corrigé de l’écart, son cours reste inchangé.',
    aumico_annual_report_fx_rounding_dialog_difference: 'Écart {{date}}',
    aumico_annual_report_fx_rounding_dialog_account: 'Compte du compte de résultat (au cours moyen)',
    aumico_annual_report_fx_rounding_dialog_assign: 'Attribuer',
    aumico_annual_report_fx_rounding_dialog_remove: 'Supprimer l’attribution',
    aumico_annual_report_fx_rounding_dialog_locked: 'L’exercice précédent est verrouillé — l’attribution provient de la clôture précédente.',
    aumico_annual_report_fx_table_year_result: 'Résultat de l’exercice',
    aumico_annual_report_fx_table_method_historical: 'Historique',
    aumico_annual_report_fx_table_hist_add_movement: 'Saisir un mouvement',
    aumico_annual_report_fx_table_hist_open: 'ouvert',
    aumico_annual_report_fx_table_hist_blocked_hint: 'Saisir d’abord le cours de l’exercice précédent.',
    aumico_annual_report_fx_table_hist_provisional_hint: 'Contient des positions dont les cours historiques ne sont pas encore saisis — le montant n’est pas encore déterminé.',
    aumico_annual_report_fx_table_hist_py_rate_missing: 'Saisir le cours',
    aumico_annual_report_fx_hist_modal_save: 'Appliquer',
    aumico_annual_report_fx_hist_modal_cancel: 'Annuler',
    aumico_annual_report_fx_hist_modal_opening: 'Solde exercice précédent',
    aumico_annual_report_fx_hist_modal_closing: 'Solde exercice courant',
    aumico_annual_report_fx_hist_modal_delta: 'Variation à expliquer',
    aumico_annual_report_fx_hist_modal_explained: 'Expliqué',
    aumico_annual_report_fx_hist_modal_description: 'Désignation',
    aumico_annual_report_fx_hist_modal_date: 'Date',
    aumico_annual_report_fx_hist_modal_date_placeholder: 'JJ.MM.AAAA',
    aumico_annual_report_fx_hist_modal_functional: 'Montant',
    aumico_annual_report_fx_hist_modal_display: 'Montant',
    aumico_annual_report_fx_hist_modal_rate: 'Cours',
    aumico_annual_report_fx_hist_modal_delete: 'Supprimer',
    aumico_annual_report_fx_hist_modal_title: 'Conversion historique',
    aumico_annual_report_fx_hist_modal_title_previous: 'Saisir le cours de l’exercice précédent',
    aumico_annual_report_fx_hist_modal_movements: 'Mouvements',
    aumico_annual_report_fx_hist_modal_history: 'Historique',
    aumico_annual_report_fx_hist_modal_history_opening: 'Solde d’ouverture',
    aumico_annual_report_fx_hist_modal_history_closing: 'Solde de clôture',
    aumico_annual_report_fx_hist_modal_history_more: 'Afficher tous les exercices',
    aumico_annual_report_fx_hist_modal_history_less: 'Afficher moins',
    aumico_annual_report_fx_hist_modal_history_count_one: '{{count}} exercice clôturé',
    aumico_annual_report_fx_hist_modal_history_count_other: '{{count}} exercices clôturés',
    aumico_annual_report_fx_hist_modal_year: 'Exercice',
    aumico_annual_report_fx_hist_modal_weighted: 'pondéré',
    aumico_annual_report_fx_hist_modal_previous_required: 'Saisir d’abord le cours de l’exercice précédent — les mouvements s’appuient sur le solde précédent.',
    aumico_annual_report_fx_hist_modal_locked_note: 'L’exercice précédent est verrouillé. Le déverrouiller à l’étape « Cours de clôture / de période », sur la carte de l’exercice précédent.',
    aumico_annual_report_fx_hist_modal_rate_hint: 'Saisir le cours ou le montant — l’autre valeur est calculée.',
    aumico_annual_report_fx_rates_step_period: 'Cours de clôture / de période',
    aumico_annual_report_fx_rates_estv_hint: 'Cours de clôture et cours moyens annuels officiels de toutes les monnaies :',
    aumico_annual_report_fx_rates_estv_link: 'Liste des cours AFC (ictax.admin.ch)',
    aumico_annual_report_fx_rates_current_year: 'Exercice courant',
    aumico_annual_report_fx_rates_previous_year: 'Exercice précédent',
    aumico_annual_report_fx_rates_closing_rate: 'Cours de clôture',
    aumico_annual_report_fx_rates_average_rate: 'Cours moyen',
    aumico_annual_report_fx_rates_locked: 'Verrouillé',
    aumico_annual_report_fx_rates_unlocked: 'Déverrouillé',
    aumico_annual_report_fx_rates_lock_scope: 'Le verrou couvre tout l’exercice précédent : les cours ici et les cours historiques par compte dans le tableau de conversion.',
    aumico_annual_report_fx_rates_import_label: 'OU calculer automatiquement à partir d’une liste de cours :',
    aumico_annual_report_fx_rates_import_error: "Le fichier n'a pas pu être lu. Aucun cours n'a été repris.",
    aumico_annual_report_fx_rates_import_error_columns: "Le fichier ne contient pas les colonnes «Date» et «Actual Rate». Aucun cours n'a été repris.",
    aumico_annual_report_fx_rates_import_error_period: "La liste ne contient aucun cours pour {{year}} — elle va du {{from}} au {{to}}. Aucun cours n'a été repris.",
    aumico_annual_report_fx_rates_import_error_rows: "Les colonnes «Date» et «Actual Rate» ne contiennent aucune valeur lisible. Aucun cours n'a été repris.",
    aumico_annual_report_fx_rates_import_confirm_title: 'Reprendre les cours ?',
    aumico_annual_report_fx_rates_import_confirm_body: "Veuillez vérifier les cours calculés avant qu'ils ne soient repris.",
    aumico_annual_report_fx_rates_import_confirm_action: 'Reprendre',
    aumico_annual_report_fx_rates_import_no_closing: 'Aucun cours de clôture trouvé — la liste ne se termine pas à la date du bilan. Veuillez le saisir manuellement.',
    aumico_annual_report_fx_rates_import_closing_last_business_day: 'La date du bilan tombe un week-end — le cours du {{date}}, dernier jour ouvrable précédent, est repris.',
    aumico_annual_report_fx_rates_guide_open: 'À quoi doit ressembler le fichier Excel ?',
    aumico_annual_report_fx_rates_guide_title: 'Liste de cours depuis Excel',
    aumico_annual_report_fx_rates_guide_headline: 'Reprendre les cours directement de votre liste',
    aumico_annual_report_fx_rates_guide_lead: 'Téléchargez l’export de cours de votre banque ou de votre système. aumico en lit la date et le cours et calcule automatiquement les cours de clôture et moyen.',
    aumico_annual_report_fx_rates_guide_callout_date: 'Date',
    aumico_annual_report_fx_rates_guide_callout_rate: 'Cours',
    aumico_annual_report_fx_rates_guide_legend_read: 'est lu',
    aumico_annual_report_fx_rates_guide_legend_ignored: 'est ignoré',
    aumico_annual_report_fx_rates_guide_point_file_title: 'Un fichier Excel',
    aumico_annual_report_fx_rates_guide_point_file_text: 'Format .xlsx ou .xls, avec une ligne d’en-tête. Elle peut aussi se trouver plus bas dans la feuille.',
    aumico_annual_report_fx_rates_guide_point_columns_title: 'Deux colonnes comptent',
    aumico_annual_report_fx_rates_guide_point_columns_text: '«Date» et «Actual Rate» — à n’importe quelle position. Toutes les autres colonnes sont ignorées.',
    aumico_annual_report_fx_rates_guide_point_direction_title: 'Cours en {{display}} pour 1 {{functional}}',
    aumico_annual_report_fx_rates_guide_point_direction_text: '0.79270 signifie : 1 {{functional}} = 0.79270 {{display}}.',
    aumico_annual_report_fx_rates_guide_calc_title: 'Mode de calcul',
    aumico_annual_report_fx_rates_guide_calc_closing: 'Cours de clôture = cours à la date du bilan. Si elle tombe un week-end, le cours du dernier jour ouvrable précédent s’applique.',
    aumico_annual_report_fx_rates_guide_calc_average: 'Cours moyen = moyenne de tous les cours de l’année. Les cours d’autres années dans le même fichier ne sont pas pris en compte.',
    aumico_annual_report_fx_rates_guide_close: 'Compris',
    aumico_annual_report_fx_rates_unlock_confirm_title: "Déverrouiller les cours de l'exercice précédent ?",
    aumico_annual_report_fx_rates_unlock_confirm_body: "Les cours de l'exercice précédent proviennent du bouclement précédent. Une fois déverrouillés, ils peuvent être modifiés.",
    aumico_annual_report_fx_rates_unlock_confirm_action: 'Déverrouiller',
    aumico_annual_report_general_information_currency: 'devise',
    aumico_annual_report_general_information_functional_currency: 'Monnaie fonctionnelle',
    aumico_annual_report_general_information_display_currency: 'Monnaie de présentation',
    aumico_annual_report_general_information_please_determine_display_currency: 'Veuillez choisir la monnaie de présentation',
    aumico_annual_report_general_information_previous_sheet_date_error:
        'La date précédente doit être plus petite que la date du bilan',
    aumico_annual_report_general_information_previous_year_reporting_date: "Date de référence de l'année précédente",
    aumico_annual_report_general_information_revision_type: 'Type de révision',
    aumico_annual_report_general_information_select_company: 'Sélectionnez les entreprises',
    aumico_annual_report_general_information_set_specification: 'Informations générales',
    aumico_annual_report_import_definition_click_cell:
        "Veuillez cliquer sur la cellule correspondante dans l'aperçu du fichier.",
    aumico_annual_report_import_definition_click_corresponding_sheet:
        "Veuillez cliquer sur la cellule correspondante dans l'aperçu du fichier.",
    aumico_annual_report_import_definition_fill_manually: 'Remplissez manuellement pour',
    aumico_annual_report_import_definition_specify_titles_line_1: 'Veuillez saisir le numéro de la ligne de titre.',
    aumico_annual_report_import_definition_specify_titles_line_2: 'Tableau',
    aumico_annual_report_import_definition_transfer_entries: 'Appliquer les sélections de bilan pour',
    aumico_annual_report_import_definition_which_spreadsheet_1: 'Dans lequel ExcelSheet',
    aumico_annual_report_import_definition_which_spreadsheet_2: 'affiché?',
    aumico_annual_report_import_form_balance_title: 'Bilan',
    aumico_annual_report_import_form_balance_instruction_label: 'Veuillez charger le bilan',
    aumico_annual_report_import_form_income_title: 'Compte de résultat',
    aumico_annual_report_import_form_income_instruction_label: 'Veuillez charger le compte de résultat',
    aumico_annual_report_import_form_input_placeholder: "Entrez s'il vous plait",
    aumico_annual_report_import_form_upload_label: 'Veuillez charger le solde du haut.',
    aumico_annual_report_import_form_uploaded_label: 'Veuillez télécharger le guide de solde.',
    aumico_annual_report_import_form_version_label: 'Nom de version',
    aumico_annual_report_import_indicate_account_names_column:
        'Entrez la colonne dans laquelle les noms de compte sont définis.',
    aumico_annual_report_import_indicate_account_numbers_column:
        'Entrez la colonne dans laquelle les numéros de compte sont définis.',
    aumico_annual_report_import_indicate_balance_column: 'Entrez la colonne de la période de référence.',
    aumico_annual_report_import_indicate_previous_year_column: 'Entrez la colonne de la période de comparaison.',
    aumico_annual_report_interpretation_account_name: 'Désignation de compte',
    aumico_annual_report_interpretation_account_number: 'Longueur des numéros de compte (Exemple: 4-5 ou 5-5)',
    aumico_annual_report_interpretation_active: 'Actif',
    aumico_annual_report_interpretation_closing_value: 'Valeur finale',
    aumico_annual_report_interpretation_excluded_word: 'Mot exclu',
    aumico_annual_report_interpretation_expense: 'Charge',
    aumico_annual_report_interpretation_included_word: 'Mot contenu',
    aumico_annual_report_interpretation_income: 'Rendement',
    aumico_annual_report_interpretation_negative: 'Négatif',
    aumico_annual_report_interpretation_opening_value: "Valeur d'ouverture",
    aumico_annual_report_interpretation_passive: 'Passif',
    aumico_annual_report_interpretation_positive: 'Positif',
    aumico_annual_report_interpretation_select_signs:
        'Veuillez définir sous quelle forme les soldes proviennent de votre système.',
    aumico_annual_report_interpretation_specify_excluded_word:
        'Veuillez saisir un mot qui peut ne pas se produire dans le nom du compte.  nz.b. Total',
    aumico_annual_report_interpretation_specify_included_word:
        'Veuillez saisir un mot qui doit être inclus dans le nom du compte.',
    aumico_annual_report_interpretation_specify_number_of_characters: 'Critères de filtre facultatif',
    aumico_annual_report_interpretation_title: 'Interprétation du nombre',
    aumico_annual_report_mandatory_field_error: 'Cette entrée est obligatoire',
    aumico_annual_report_not_found_error: 'Pas trouvé',
    aumico_annual_report_print_options_add_metadata: 'Ajouter des métadonnées',
    aumico_annual_report_print_options_caption: '-',
    aumico_annual_report_print_options_collective_signature: 'Signature collective',
    aumico_annual_report_print_options_custom_page_numbers: 'numéros page pers.',
    aumico_annual_report_print_options_dont_show_name: "Les noms ne s'affichent pas (peuvent être entrés manuellement)",
    aumico_annual_report_print_options_show_decimal_places: 'Les décimales',
    aumico_annual_report_print_options_place_of_signing: 'Lieu de signature (facultatif)',
    aumico_annual_report_print_options_print: 'Presse',
    aumico_annual_report_print_options_print_only_greyscale: 'Imprimer uniquement en niveaux de gris',
    aumico_annual_report_print_options_show_empty_lines: 'afficher lignes vides',
    aumico_annual_report_print_options_show_company_info: 'Nom organisationnel',
    aumico_annual_report_print_options_show_cover_sheet: 'Page couverture',
    aumico_annual_report_print_options_show_table_of_contents: 'Table des matières',
    aumico_annual_report_print_options_show_uid: 'UID',
    aumico_annual_report_print_options_signatory_1: 'Signataire 1 (facultatif)',
    aumico_annual_report_print_options_signatory_2: 'Signataire 2 (facultatif)',
    aumico_annual_report_print_options_signature: 'Signature',
    aumico_annual_report_print_options_title: "Options d'impression",
    aumico_annual_report_print_preview_aop: 'Emploi du bénéfice résultant du bilan',
    aumico_annual_report_print_preview_attachement: 'Annexe au compte annuel',
    aumico_annual_report_print_preview_balance: 'Bilan',
    aumico_annual_report_print_preview_income: 'Compte de résultat',
    aumico_annual_report_profit_calculation_annual_profit: 'Bénéfice annuel',
    aumico_annual_report_profit_calculation_annual_result: 'Résultat annuel',
    aumico_annual_report_profit_calculation_annual_loss: 'Perte annuelle',
    aumico_annual_report_profit_calculation_header: 'Résultat du bilan disponible',
    aumico_annual_report_profit_calculation_header_profit: 'Bénéfice disponible',
    aumico_annual_report_profit_calculation_header_loss: 'Perte disponible',
    aumico_annual_report_proposal_add_new_item: 'Ajouter un nouvel élément',
    aumico_annual_report_proposal_available_retained_earnings: 'Bénéfice à disposition de l’assemblée générale',
    aumico_annual_report_proposal_available_retained_earnings_profit:
        'Bénéfice à disposition de l’assemblée générale - bénéfice',
    aumico_annual_report_proposal_available_retained_earnings_loss:
        'Bénéfice à disposition de l’assemblée générale - perte',
    aumico_annual_report_proposal_carried_forward_to_new_account: 'Report à nouveau',
    aumico_annual_report_proposal_carried_forward_to_new_account_profit: 'Report à nouveau - bénéfice',
    aumico_annual_report_proposal_carried_forward_to_new_account_loss: 'Report à nouveau - perte',
    aumico_annual_report_table_label_accounting_basis: 'Norme de comptabilité',
    aumico_annual_report_table_label_company: 'entreprise',
    aumico_annual_report_table_label_created_on: 'Créé sur',
    aumico_annual_report_table_label_language: 'Langue',
    aumico_annual_report_table_label_currency: 'devise',
    aumico_annual_report_table_label_last_change: 'Dernière mise à jour',
    aumico_button_cancel: 'Annuler',
    aumico_button_companies_form_cancel: 'Annuler',
    aumico_button_companies_form_save: 'Sauvegarder et continuer',
    aumico_button_confirm: 'Confirmer',
    aumico_button_delete: 'Supprimer',
    aumico_button_download: 'Télécharger',
    aumico_button_edit: 'Modifier',
    aumico_button_copy: 'Copie',
    aumico_button_preview: 'Aperçu',
    aumico_button_save: 'Sauvegarder',
    aumico_button_submit: 'Envoyer',
    aumico_button_update: 'Mise à jour',
    aumico_button_add: 'Ajouter',
    aumico_companies_form_label_addition_to_address: 'Adresse additive (c/o)',
    aumico_companies_form_label_address: 'adresse',
    aumico_tags_box_title: 'Tag',
    aumico_companies_form_section_linked_persons: 'Personnes liées',
    aumico_tags_box_new_tag_placeholder: 'Créer un nouveau tag',
    aumico_tags_box_create: 'Créer',
    aumico_tags_box_cancel: 'Annuler',
    aumico_tags_box_delete: 'Supprimer',
    aumico_tags_box_delete_warning: 'est utilisé par {{companies}} entreprises et {{persons}} personnes et y sera supprimé. Vraiment supprimer ?',
    aumico_tags_box_delete_aria: 'Supprimer le tag',
    aumico_persons_form_details_text: 'Données de la personne',
    aumico_persons_form_section_personal: 'Données personnelles',
    aumico_persons_form_first_name: 'Prénom',
    aumico_persons_form_last_name: 'Nom',
    aumico_persons_form_assignee: 'Responsable du mandat',
    aumico_persons_form_clerk: 'Collaborateur',
    aumico_persons_form_search: 'Rechercher',
    aumico_persons_form_placeholder: 'Veuillez saisir',
    aumico_persons_form_section_address: 'Adresse',
    aumico_persons_form_street: 'Rue et numéro de maison',
    aumico_persons_form_addition_to_address: 'Complément d\'adresse',
    aumico_persons_form_zip: 'NPA',
    aumico_persons_form_city: 'Localité',
    aumico_persons_form_section_contact: 'Coordonnées',
    aumico_persons_form_email: 'E-mail',
    aumico_persons_form_phone: 'Téléphone',
    aumico_persons_form_email_invalid: 'Adresse e-mail invalide',
    aumico_persons_form_add_contact: 'Ajouter un contact',
    aumico_persons_form_remove_contact_aria: 'Supprimer le contact',
    aumico_persons_form_section_companies: 'Entreprises liées',
    aumico_persons_form_company: 'Entreprise',
    aumico_persons_form_role: 'Rôle',
    aumico_persons_form_please_choose: 'Veuillez choisir',
    aumico_persons_form_link: 'Lier',
    aumico_persons_form_unlink_aria: 'Supprimer le lien',
    aumico_persons_form_company_deleted: 'Entreprise supprimée',
    aumico_persons_form_role_OWNER: 'Propriétaire',
    aumico_persons_form_role_SHAREHOLDER: 'Actionnaire',
    aumico_persons_form_role_MANAGING_DIRECTOR: 'Directeur/trice',
    aumico_persons_form_role_BOARD_MEMBER: 'Conseil d\'administration',
    aumico_persons_form_role_OTHER: 'Autre',
    aumico_persons_form_save: 'Enregistrer',
    aumico_persons_form_delete: 'Supprimer',
    aumico_persons_form_deactivate: 'Désactiver',
    aumico_persons_form_activate: 'Activer',
    aumico_persons_form_dialog_cancel: 'Annuler',
    aumico_person_delete_failed_title: 'Erreur lors de la suppression de la personne',
    aumico_person_delete_failed_has_projects_message:
        "La personne a encore des projets. Tu dois d'abord supprimer les projets existants de cette personne.",
    aumico_persons_form_clerk_change_dialog_text:
        "Tu changes l'employé administratif pour cette personne. Comment les tâches existantes doivent-elles être réassignées ?",
    aumico_persons_form_delete_dialog_title: 'Supprimer la personne ?',
    aumico_persons_form_delete_dialog_text: 'La personne sera supprimée définitivement. Cette action est irréversible.',
    aumico_persons_overview_tab_active: 'Actif',
    aumico_persons_overview_tab_inactive: 'Inactif',
    aumico_persons_overview_search: 'Rechercher',
    aumico_persons_overview_filter_assignee: 'Responsable du mandat',
    aumico_persons_overview_filter_clerk: 'Collaborateur',
    aumico_persons_overview_filter_tag: 'Tag',
    // REV-22155 — person projects
    aumico_projects_toggle_companies: 'Entreprises',
    aumico_projects_toggle_persons: 'Personnes',
    aumico_person_projects_filter_person: 'Personne',
    aumico_person_projects_filter_period: 'Période',
    aumico_person_projects_filter_tag: 'Tag',
    aumico_person_projects_col_person: 'Personne',
    aumico_person_projects_col_period: 'Période',
    aumico_person_projects_col_tag: 'Tag',
    cpmm_projects_overview_col_tag: 'Tag',
    aumico_projects_overview_filter_tag: 'Tag',
    aumico_person_projects_tax_period: 'Période fiscale {{year}}',
    aumico_person_projects_empty: 'Aucun projet de personne',
    aumico_person_projects_empty_instructions: 'Créez un projet pour une personne afin de démarrer la gestion de son mandat.',
    aumico_person_projects_create_failure_title: 'Projet non créé',
    aumico_person_projects_create_failure_description: 'Le projet n\'a pas pu être créé. Veuillez réessayer.',
    aumico_person_projects_create_failure_inactive: 'Ce mandat est inactif. Il n\'est pas possible d\'ajouter de nouveaux projets.',
    aumico_create_person_project_dialog_select_person_title: 'Choisir une personne',
    aumico_create_person_project_dialog_select_person_description: 'Pour quelle personne le projet doit-il être créé ?',
    aumico_create_person_project_dialog_select_person_input_title: 'Personne',
    aumico_create_person_project_dialog_select_person_input_placeholder: 'Rechercher une personne',
    aumico_create_person_project_dialog_select_period_title: 'Choisir la période',
    aumico_create_person_project_dialog_select_period_description: 'Pour quelle période le projet doit-il être créé ?',
    aumico_create_person_project_dialog_select_period_input_label: 'Période',
    aumico_create_person_project_dialog_select_period_input_placeholder: 'Choisir la période',
    aumico_pm_tasks_type_filter_label: 'Type',
    aumico_pm_tasks_type_company: 'Entreprise',
    aumico_pm_tasks_type_person: 'Personne',
    aumico_tasks_col_mandant: 'Mandant',
    aumico_person_projects_next_year_reason_inactive: 'Inactif – aucun nouveau projet possible',
    aumico_person_projects_next_year_reason_no_project: 'Pas encore de projet',
    aumico_person_projects_next_year_reason_not_found: 'Personne introuvable',
    aumico_persons_overview_export: 'Export XLS',
    aumico_persons_overview_new: 'Nouvelle personne',
    aumico_persons_overview_col_name: 'Nom',
    aumico_persons_overview_col_street: 'Rue et numéro de maison',
    aumico_persons_overview_col_zip: 'NPA',
    aumico_persons_overview_col_city: 'Localité',
    aumico_persons_overview_col_tag: 'Tag',
    aumico_persons_overview_col_assignee: 'Responsable du mandat',
    aumico_persons_overview_col_clerk: 'Collaborateur',
    aumico_persons_overview_empty_text1: 'Aucune personne saisie',
    aumico_persons_overview_empty_text2: 'Saisissez la première personne avec « Nouvelle personne ».',
    aumico_persons_overview_bulk_assignee: 'Changer le responsable du mandat',
    aumico_persons_overview_bulk_clerk: 'Changer le collaborateur',
    aumico_persons_overview_bulk_next_financial_year: 'Créer l\'exercice suivant',
    aumico_persons_overview_bulk_deactivate: 'Désactiver les personnes',
    aumico_persons_overview_bulk_deactivate_confirm: 'Voulez-vous vraiment désactiver {{count}} personnes ?',
    aumico_persons_overview_bulk_selected: 'sélectionné(s)',
    aumico_persons_overview_bulk_assignee_title: 'Changer le responsable du mandat pour {{count}} personnes ?',
    aumico_persons_overview_bulk_clerk_title: 'Changer le collaborateur pour {{count}} personnes ?',
    aumico_persons_overview_cancel: 'Annuler',
    aumico_persons_overview_save: 'Enregistrer',
    aumico_persons_overview_please_choose: 'Veuillez choisir',
    aumico_companies_form_label_city: 'Lieu',
    aumico_companies_form_label_country: 'pays',
    aumico_companies_form_label_email: 'e-mail',
    aumico_companies_form_label_first_name: 'First Name',
    aumico_companies_form_label_last_name: 'Last Name',
    aumico_companies_form_label_legal_form: 'forme juridique',
    aumico_companies_form_label_name: "Nom de l'entreprise",
    aumico_companies_form_label_phone: 'Numéro de téléphone.',
    aumico_companies_form_label_street_and_number: 'Rue et numéro de maison',
    aumico_companies_form_label_uid_number: 'Uid',
    aumico_companies_form_label_zip_code: 'Code postal',
    aumico_companies_form_placeholder_optional: 'facultatif',
    aumico_companies_form_placeholder_please_enter: "Entrez s'il vous plait",
    aumico_companies_form_placeholder_please_select: 'Veuillez sélectionner',
    aumico_companies_form_section_name_contact_details: 'détails du contact',
    aumico_companies_form_section_name_legal_information: 'Information légale',
    aumico_companies_fx_section_title: 'Monnaie fonctionnelle',
    aumico_companies_fx_inactive_hint:
        'Pour les clients dont la comptabilité est tenue en devise étrangère. Une fois activée, les nouveaux bouclements peuvent utiliser une monnaie fonctionnelle.',
    aumico_companies_fx_activate_button: 'Activer',
    aumico_companies_fx_deactivate_button: 'Désactiver la monnaie fonctionnelle',
    aumico_companies_fx_pending_chip: 'En attente',
    aumico_companies_fx_pending_hint: 'Sera activé dès que l’entreprise sera enregistrée.',
    aumico_companies_fx_pending_cancel: 'Annuler l’activation',
    aumico_companies_fx_active_chip: 'Actif',
    aumico_companies_fx_activated_on: 'Activé le',
    aumico_companies_fx_minimum_term_until: 'Durée minimale jusqu’au',
    aumico_companies_fx_no_permission_hint:
        'Seul un administrateur de l’organisation peut activer la monnaie fonctionnelle.',
    aumico_companies_fx_modal_title: 'Activer la monnaie fonctionnelle',
    aumico_companies_fx_modal_intro:
        'La monnaie fonctionnelle est une fonction payante. Elle sera disponible pour les bouclements nouvellement créés ; les bouclements existants restent inchangés.',
    aumico_companies_fx_modal_price: 'Coûts supplémentaires',
    aumico_companies_fx_modal_per_year: 'an',
    aumico_companies_fx_modal_term: 'Durée minimale',
    aumico_companies_fx_modal_months: 'mois',
    aumico_companies_fx_modal_consent_checkbox:
        'Je confirme avoir pris connaissance des coûts supplémentaires et de la durée minimale.',
    aumico_companies_fx_modal_confirm: 'Confirmer et activer',
    aumico_companies_fx_modal_cancel: 'Annuler',
    aumico_companies_fx_deactivate_confirm_title: 'Désactiver la monnaie fonctionnelle',
    aumico_companies_fx_deactivate_confirm_body:
        'Les nouveaux bouclements ne pourront plus utiliser de monnaie fonctionnelle. Les bouclements déjà créés restent inchangés. La durée minimale continue de courir.',
    aumico_companies_form_validation_email_invalid: 'Adresse e-mail invalide',
    aumico_companies_form_validation_enter_company_name_exists: "Nom de l'entreprise déjà attribué",
    aumico_companies_form_validation_enter_company_name_required: "Veuillez saisir le nom de l'entreprise",
    aumico_companies_form_validation_legal_form_required: 'Veuillez sélectionner le formulaire juridique',
    aumico_companies_toast_error_something_went_wrong: 'Une erreur est survenue',
    aumico_core_form_invalid_error: "Cette entrée n'est pas valide",
    aumico_core_form_mandatory_error: 'Ce champ est obligatoire',
    aumico_core_search: 'Rechercher',
    aumico_core_search_not_found: 'Pas trouvé',
    aumico_errors_server_error: 'Erreur du serveur',
    aumico_no_read_permission: "Vous n'avez aucun droit de lecture",
    aumico_notes_component_options_add_more: 'ajouter plus',
    aumico_notes_component_options_current_value_title_1: 'Valeur actuelle Titre 1',
    aumico_notes_component_options_current_value_title_2: 'Valeur actuelle Titre 2',
    aumico_notes_component_options_previous_value_title_1: 'Valeur précédente Titre 1',
    aumico_notes_component_options_previous_value_title_2: 'Valeur précédente Titre 2',
    aumico_notes_component_options_selection_option: "Choisissez s'il vous plaît",
    aumico_notes_component_options_text_title: 'Titre de texte',
    aumico_notes_equity: 'Capitaux propres',
    aumico_notes_fli: 'Situation financière',
    aumico_notes_fli_component_add_more: 'ajouter plus situation financière',
    aumico_notes_free_table_with_amounts: 'Tableau libre',
    aumico_notes_information_dialog_title: 'informations générales',
    aumico_notes_mandatory_error: 'Ce champ est obligatoire',
    aumico_notes_name_exist_error: 'Ce nom a déjà été décerné',
    aumico_notes_notespage_notes_not_found:
        "Aucune information d'annexe n'a été trouvée pour ce formulaire juridique et la norme comptable.",
    aumico_notes_notestemplate_form_legal_form_and_accounting_basis_combination_exist:
        'Cette combinaison de forme juridique et de base de compte sélectionnées existe déjà',
    aumico_notes_notestemplate_list_add_new: "Ajouter un nouveau modèle d'annexe",
    aumico_notes_notestype_form_components: 'Composants',
    aumico_notes_notestype_form_information: 'information',
    aumico_notes_notestype_form_min_length_error: 'La longueur minimale est de 5 caractères',
    aumico_notes_notestype_form_name: 'Nom du compte',
    aumico_notes_notestype_form_title: 'Titre de section',
    aumico_notes_notestype_list_add_new: 'Ajouter un nouveau type de fixation',
    aumico_notes_options: 'Options',
    aumico_notes_preview: 'Aperçu',
    aumico_notes_rich_text: 'Texte',
    aumico_notes_select: 'Veuillez sélectionner',
    aumico_notes_server_error: 'Erreur interne du serveur',
    aumico_notes_table_with_form_add_new_item: 'Ajouter un nouvel ligne',
    aumico_notes_table_with_form_no_formfield_defined: 'Pas de champ de forme défini',
    aumico_notes_table_with_form_no_properties_defined: 'Aucune propriété définie',
    aumico_notes_table_with_form_no_properties_error: 'Aucune propriété définie',
    aumico_notes_table_with_form_total: 'Total',
    aumico_notes_template: 'annexe',
    aumico_notes_testing_procedure: 'Procédure de test',
    aumico_notes_testing_procedure_comment: 'commentaire',
    aumico_notes_testing_procedure_flis: 'Flis',
    aumico_notes_testing_procedure_references: "informations d'identification",
    aumico_notes_text: 'texte',
    aumico_notes_total_row: 'Rangée totale',
    aumico_notes_types: 'annexe',
    aumico_reporting_contentBlocks_addNew: 'Ajouter un nouveau bloc de contenu',
    aumico_reporting_contentBlocks_options_content: 'Contenu Contenu bloqué',
    aumico_reporting_contentBlocks_options_owner: 'Propriétaire du bloc de contenu',
    aumico_reporting_contentBlocks_options_properties: 'Propriétés des blocs de contenu',
    aumico_reporting_report_content: 'Contenu',
    aumico_reporting_report_edit_addNewContent: 'Ajouter un nouveau contenu',
    aumico_reporting_report_edit_addNewFooter: 'Ajouter une nouvelle ligne de pied',
    aumico_reporting_report_edit_addNewHeader: 'Ajouter un nouvel en-tête',
    aumico_reporting_report_footer: 'Bas de page',
    aumico_reporting_report_header: 'Entête',
    aumico_reporting_report_name: 'Nom du rapport',
    aumico_reporting_settings_options_name: 'Nom de famille',
    aumico_reporting_settings_options_owner: 'propriétaire',
    aumico_reporting_templatesPreview_show: "Afficher l'aperçu",
    aumico_reporting_templates_addNew: 'Créer un nouveau modèle de rapport',
    aumico_reporting_templates_edit: 'Modifier le modèle de rapport',
    aumico_reporting_templates_livePreview: 'Aperçu en direct',
    aumico_reporting_templates_options_accountingBasis: 'Norme de comptabilité',
    aumico_reporting_templates_options_legalForm: 'forme juridique',
    aumico_reporting_variables_addNew: 'Ajouter une nouvelle variable de rapport',
    aumico_reporting_variables_edit: 'Modifier la variable du rapport',
    aumico_reporting_variables_options_currentVersion: 'Version actuelle',
    aumico_reporting_variables_options_identifier: 'Identification',
    aumico_reporting_variables_options_property: 'Propriété',
    aumico_reporting_variables_title: 'variables',
    aumico_reports_fs_notes_instruction: 'Instructions de travail',
    aumico_reports_input_please_enter_placeholder: "Entrez s'il vous plait",
    aumico_reports_intro_side_text: 'Fais passer tes rapports annuels au niveau supérieur',
    aumico_reports_login_bottom_button_of_question_register: 'Adhérer maintenant',
    aumico_reports_login_bottom_question: 'Aucun compte encore?',
    aumico_reports_login_credentials_error: "L'identifiant ou le mot de passe est incorrect!",
    aumico_reports_login_credentials_toomany_requests_error:
        "L'accès à ce compte a été temporairement désactivé en raison de nombreuses tentatives d'enregistrement ratées. Vous pouvez le restaurer immédiatement en réinitialisant votre mot de passe ou vous pouvez réessayer plus tard.",
    aumico_reports_login_credentials_network_request_failed: 'Erreur de réseau',
    aumico_reports_login_invalid_role_error: "Votre compte ne dispose pas d'un rôle valide pour accéder à cette application.",
    aumico_reports_login_forgot_password: 'Mot de passe oublié',
    aumico_reports_login_introduction: '',
    aumico_reports_login_login_button: 'Inscription',
    aumico_reports_login_title: 'Inscription',
    aumico_reports_page_not_found: 'Page non trouvée',
    aumico_reports_password: 'mot de passe',
    aumico_reports_placeholder_needs_implementation: "L'espace réservé doit être mis en œuvre ...",
    aumico_reports_registration_bottom_button_of_question_login: 'Connecte-toi maintenant',
    aumico_reports_registration_bottom_question: 'Avez vous déjà un compte?',
    aumico_reports_registration_confirmation_bottom_question: 'Pas de courriel?',
    aumico_reports_registration_confirmation_bottom_question_button: 'Soumettre à nouveau un e-mail',
    aumico_reports_registration_confirmation_introduction: 'Courte introduction et instructions',
    aumico_reports_registration_confirmation_title: 'Merci de confirmer votre adresse e-mail',
    aumico_reports_registration_create_account_button: 'créer un compte',
    aumico_reports_registration_introduction:
        'Accueillir! Inscrivez-vous et créez des factures annuelles pour votre propre entreprise et vos clients.',
    aumico_reports_registration_welcome_button_login_go_dashboard: 'Inscription et plus loin au tableau de bord',
    aumico_reports_registration_welcome_company_name_error: "Le nom de l'entreprise est requis",
    aumico_reports_registration_welcome_company_name_label: "Nom de l'entreprise",
    aumico_reports_registration_welcome_first_name_error: 'Le prénom est requis',
    aumico_reports_registration_welcome_first_name_label: 'Prénom',
    aumico_reports_registration_welcome_last_name_error: 'Le nom de famille est requis',
    aumico_reports_registration_welcome_last_name_label: 'Nom de famille',
    aumico_reports_registration_welcome_market_communication_subscription:
        "Je voudrais recevoir des nouvelles sur les produits, les services et les événements d'aumico.",
    aumico_reports_registration_welcome_password_error: 'Mot de passe requis',
    aumico_reports_registration_welcome_password_label: 'mot de passe',
    aumico_reports_registration_welcome_password_match_error: 'Les mots de passe doivent correspondre',
    aumico_reports_registration_welcome_password_rules:
        'Au moins huit caractères, une grande lettre, une petite lettre, un nombre et un caractère spécial. (@ $!% *? & ._)',
    aumico_reports_registration_welcome_password_validation_error: 'Le mot de passe ne correspond pas aux règles.',
    aumico_reports_registration_welcome_privacy_policy:
        "J'ai lu les règlements sur la protection des données sur le site Web et je suis d'accord avec cela *",
    aumico_reports_registration_welcome_repeat_password_error: 'Répéter le mot de passe est requis',
    aumico_reports_registration_welcome_repeat_password_label: 'Répéter le mot de passe',
    aumico_reports_reset_password_credentials_error: "Le nom d'utilisateur ou le courrier électronique est faux!",
    aumico_reports_reset_password_forgot_email_username: "E-mail (nom d'utilisateur",
    aumico_reports_reset_password_forgot_password_title: 'Mot de passe oublié?',
    aumico_reports_reset_password_forgot_send_instruction_button: 'Envoyez-moi des instructions par e-mail',
    aumico_reports_reset_password_introduction:
        'Après avoir entré votre adresse e-mail, nous vous enverrons des instructions pour réinitialiser votre mot de passe.',
    aumico_reports_signup_title: 'Créer un nouveau compte',
    aumico_reports_welcome_page_footer_about: 'Conditions',
    aumico_reports_welcome_page_footer_imprint: 'imprimer',
    aumico_reports_welcome_page_footer_privacy_policy: 'protection des données',
    aumico_reports_write_permission_error: "Malheureusement, vous n'avez aucune écriture.",
    aumico_reports_referral_invite_title: 'Référence',
    aumico_reports_referral_invite_text: 'Dire à un ami',
    aumico_reports_referral_invite_invite_button: 'Inviter maintenant',
    aumico_reports_referral_invite_dialog_title: 'Dire à un ami',
    aumico_reports_referral_invite_dialog_content: "Dites à un ami d'aumico",
    aumico_reports_referral_invite_dialog_input_label: 'Ajouter une adresse e-mail',
    aumico_reports_referral_invite_dialog_input_placeholder: 'Veuillez saisir les adresses e-mail',
    aumico_reports_referral_invite_dialog_save_button: 'Inviter',
    aumico_settings_accountingBasis: 'Norme de comptabilité',
    aumico_settings_accountingbasis_id: 'IDENTIFIANT',
    aumico_settings_accountingbasis_name: 'Nom de famille',
    aumico_settings_accountingbasis_owner: 'propriétaire',
    aumico_settings_accountingbasis_text: 'texte',
    aumico_settings_accountingbasis_version: 'version',
    aumico_settings_currency_id: 'TBD: ID',
    aumico_settings_currency_name: 'Nom de famille',
    aumico_settings_currency_owner: 'propriétaire',
    aumico_settings_currency_text: 'texte',
    aumico_settings_currency_version: 'version',
    aumico_settings_financialLineItem: 'Situation financière',
    aumico_settings_financialLineItem_cashflow: 'Flux de trésorerie',
    aumico_settings_financialLineItem_description: 'Description',
    aumico_settings_financialLineItem_id: 'IDENTIFIANT',
    aumico_settings_financialLineItem_invalidText: 'Veuillez donner des numéros de 1',
    aumico_settings_financialLineItem_name: 'Nom de famille',
    aumico_settings_financialLineItem_owner: 'propriétaire',
    aumico_settings_financialLineItem_position: 'position',
    aumico_settings_financialLineItem_text: 'texte',
    aumico_settings_financialLineItem_type: 'Taper',
    aumico_settings_financialLineItem_version: 'version',
    aumico_settings_legalForm_id: 'TBD: ID',
    aumico_settings_legalForm_name: 'Nom de famille',
    aumico_settings_legalForm_owner: 'propriétaire',
    aumico_settings_legalForm_text: 'texte',
    aumico_settings_legalForm_version: 'version',
    aumico_templates_cancel: 'Annuler',
    aumico_templates_combination_exist_error:
        'La combinaison de la forme juridique et de la norme comptable existe déjà',
    aumico_templates_description: 'Description',
    aumico_templates_form_account_basis: 'Norme de comptabilité',
    aumico_templates_form_back_to_templates_list: 'Retour à la liste de la liste',
    aumico_templates_form_cash_and_cash_equivalents: 'Liquide',
    aumico_templates_form_create_template: 'Créer un modèle',
    aumico_templates_form_enter_template_name_error: 'Veuillez saisir le nom du modèle',
    aumico_templates_form_legal_form: 'forme juridique',
    aumico_templates_form_profit_of_the_year: 'Bénéfice annuel',
    aumico_templates_form_select_account_basis_error: 'Veuillez sélectionner la norme comptable',
    aumico_templates_form_select_legal_form_error: 'Veuillez sélectionner le formulaire juridique',
    aumico_templates_form_template_name_exists_error: 'La désignation du modèle existe déjà',
    aumico_templates_form_update_template: "Pour mettre à jour l'exampleur",
    aumico_templates_group_form_allow_groups: 'Autoriser les groupes',
    aumico_templates_group_form_allow_items: "Permettre l'entrée",
    aumico_templates_group_form_create_group: 'Créer un groupe',
    aumico_templates_group_form_enter_group_description_error: 'Veuillez saisir la description du groupe',
    aumico_templates_group_form_enter_group_name_error: 'Veuillez saisir un nom de groupe',
    aumico_templates_group_form_hide_total: 'Cacher',
    aumico_templates_group_form_name_already_exists_error: 'Le nom du groupe existe déjà',
    aumico_templates_group_form_select_option: 'Sélectionnez au moins une option:',
    aumico_templates_group_form_update_group: 'Mettre à jour le groupe',
    aumico_templates_group_list_new_group: 'Nouveau groupe',
    aumico_templates_group_view_add_fli: 'Ajouter des éléments financiers',
    aumico_templates_group_view_add_group: 'Ajouter un groupe',
    aumico_templates_group_view_add_subtotal: 'Insérer entre',
    aumico_templates_list_edit: 'Modifier',
    aumico_templates_list_new: 'Nouveau',
    aumico_templates_list_new_template: 'Nouveau modèle',
    aumico_templates_name: 'Nom de famille',
    aumico_templates_save: 'Sauvegarder',
    aumico_templates_subtotal_form_enter_subtotal_description_error:
        'Veuillez saisir un nom pour les morts intermédiaires',
    aumico_templates_subtotal_form_enter_subtotal_name_error: 'Veuillez saisir un nom pour les morts intermédiaires',
    aumico_templates_subtotal_form_name_already_exists_error: "Le nom de l'élément de groupe existe déjà",
    aumico_templates_subtotal_form_subtotal_name: 'Description entre',

    mocked_data: 'Modification des données',
    mocked_data_1: 'Modification des données',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_title: 'Les données ont changé',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_text: 'Les données ont été modifiées.',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_title: 'Les données de mappage ont changé ?',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_text: 'Souhaitez-vous mettre à jour ?',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_action_button: 'Oui',
    aumico_reports_annualreport_navigation_fcp: 'Processus de clôture financière',
    aumico_reports_annualreport_navigation_aop: 'Emploi du bénéfice résultant du bilan',
    aumico_reports_annualreport_navigation_generalinformation: 'informations générales',
    aumico_reports_annualreport_navigation_finish_and_print: 'Finalisation & impression',
    aumico_reports_annualreport_navigation_import: "Solde d'importation",
    aumico_reports_annualreport_navigation_import_upload: 'Téléchargez le bilan',
    aumico_reports_annualreport_navigation_import_mapping: 'Attribution des comptes',
    aumico_reports_annualreport_navigation_notes: 'Annexe',
    aumico_reports_annualreport_navigation_notes_and_aop: 'Tableau des flux de trésorerie | Annexe | GV',
    aumico_reports_main_navigation_company: 'organisation',
    aumico_reports_main_navigation_financialstatements: 'Rapports annuels',
    aumico_reports_main_navigation_logout: 'Se déconnecter',
    aumico_reports_profile_navigation_security: 'Sécurité',
    aumico_reports_profile_navigation_generalinformation: 'informations générales',
    aumico_annual_report_general_information_please_determine_currency: 'Sélectionnez la devise',
    aumico_annual_report_general_information_please_determine_previous_year_date: 'Entrer la date',
    aumico_annual_report_general_information_please_determine_date: 'Entrer la date',
    aumico_annual_report_general_information_please_select_company: "Sélectionner l'entreprise",
    aumico_annual_report_general_information_select_revision_type: 'Sélectionnez le type de révision',
    aumico_annual_report_general_information_select_accounting_basis: 'Sélectionnez le type de comptabilité',
    aumico_annual_report_import_please_select: 'Veuillez sélectionner',
    aumico_annual_report_interpretation_enter_excluded_word: "Entrez s'il vous plait",
    aumico_annual_report_interpretation_enter_included_word: "Entrez s'il vous plait",
    aumico_annual_report_print_options_date_of_signing: 'Date de signature',
    aumico_annual_report_print_options_place_of_signing_placeholder: 'Lieu de signature',
    aumico_annual_report_print_options_start_at_page: 'Démarrer par le côté',
    aumico_annual_report_print_page_content_preview: 'Aperçu du contenu',
    aumico_annual_report_profit_calculation_enter_text: 'Entrez le texte / le montant',
    aumico_annual_report_proposal_enter_text: 'Entrez le texte / le montant',
    aumico_annual_report_print_options_show_aop: 'Emploi du bénéfice résultant du bilan',
    aumico_annual_report_print_options_show_Fcp: 'Documentation du processus',
    aumico_annual_report_proposal_description: "Proposition d'utilisation du résultat du bilan",
    aumico_annual_report_proposal_description_profit: "Proposition d'utilisation du bénéfice",
    aumico_annual_report_proposal_description_loss: "Proposition d'utilisation de la perte",
    aumico_annual_report_label_cover_page: 'Titre du guide de la couverture (ne sera pas visible dans le PDF)',
    aumico_annual_report_print_preview_cashflow: 'Tableau des flux de trésorerie',
    aumico_annual_report_label_table_of_contents: 'Table des matières',
    aumico_annual_report_table_label_previous_year_date: "Date référence l'année précédente",
    aumico_core_data_grid_accounts: 'Comptes',
    aumico_annual_report_table_label_current_year_date: 'Date du bilan',
    aumico_core_data_grid_all: 'tous',
    aumico_core_data_grid_remove: 'Supprimer tous les comptes',
    aumico_core_data_grid_search_placeholder: 'Rechercher',
    aumico_core_empty_data_grid_assigned_all_accounts: 'Fantastique, vous avez attribué tous les comptes!',
    aumico_core_empty_data_grid_information_text: '-',
    aumico_core_empty_data_grid_information_title: '-',
    aumico_core_file_upload_extension_error: 'Veuillez charger un fichier XLSX ou XLS',
    aumico_core_file_upload_instruction_text: 'Glisser-déposer',
    aumico_core_file_upload_instruction_label: 'Téléchargez le bilan',
    aumico_core_form_min_length_error: 'La longueur minimale pour cette entrée est',
    aumico_core_file_upload_title: 'Téléchargez le bilan',
    aumico_reports_action_bar_footer_back_to: 'Retour à',
    aumico_reports_action_bar_footer_proceed_to: 'Enregistrer et continuer à',
    aumico_reports_annualreport_toc_label_balance_sheet: 'Bilan',
    aumico_reports_annualreport_toc_label_cash_flow_statement: 'Tableau des flux de trésorerie',
    aumico_reports_annualreport_toc_label_notes_to_the_financial_statement: 'Annexe',
    aumico_reports_annualreport_toc_label_income_statement: 'Compte de résultat',
    aumico_reports_annualreport_cover_annual_label_title_prefix: 'Rapport annuel pour la période du',
    aumico_reports_annualreport_cover_quarterly_label_title_prefix: 'Rapport financier trimestriel pour la période du',
    aumico_reports_annualreport_cover_monthly_label_title_prefix: 'Rapport financier mensuel pour la période du',
    aumico_reports_annualreport_cover_custom_label_title_prefix: 'Rapport financier pour la période du',
    aumico_templates_account_mapping_child_form_name: 'Nom du compte',
    aumico_templates_account_mapping_form_balance: 'Bilan',
    aumico_templates_sub_fli_form_fli: 'Sélectionner le poste',
    aumico_templates_account_mapping_child_form_number: 'Num.',
    aumico_templates_template_account_mapping_form_expand_all: 'Développer tout',
    aumico_users_edit_user_company_general_information_city: 'Village',
    aumico_users_edit_user_company_general_information_enter_no: "Pas d'entrée",
    aumico_users_edit_user_company_general_information_street: 'Rue',
    aumico_users_edit_user_company_general_information_address_addition: 'Dépendance',
    aumico_users_edit_user_general_information_enter_email_address: 'Registre',
    aumico_reports_annualreport_toc_label_table_of_contents: 'Table des matières',
    aumico_reports_annualreport_print_date_from: 'du',
    aumico_reports_annualreport_print_date_to: 'à',
    aumico_reports_annualreport_print_date_of: 'au',
    aumico_users_edit_user_general_information_name: 'Prénom',
    aumico_users_edit_user_company_general_information_enter_city: 'Sélectionnez le village',
    aumico_users_edit_user_general_information_surname: 'Nom de famille',
    aumico_users_edit_user_company_general_information_name: "Nom de l'entreprise",
    aumico_users_edit_user_security_enable_two_factor_authentication: "Activer l'authentification à 2 facteurs",
    aumico_users_edit_user_general_information_edit_your_profile: 'Editer le profil',
    aumico_templates_template_account_mapping_form_collapse_all: 'Réduire tout',
    aumico_users_edit_user_general_information_enter_surname: 'Nom de famille',
    aumico_templates_caption: 'Nom',
    aumico_templates_subtotal_name: 'Nom du sous-total ',
    aumico_templates_subtotal_scope: 'Sous-total périmètre',
    aumico_templates_subtotal_position_after: 'Position après',
    aumico_templates_subtotal_select_position: 'Choisir la position',
    aumico_templates_subtotal_select_position_as_first_element: 'Premier élément',
    aumico_users_edit_user_general_information_select_salutation: 'Choisir',
    aumico_users_edit_user_company_general_information_choose_country: 'choisissez un pays',
    aumico_users_edit_user_security_confirm_new_password: 'Registre',
    aumico_users_aumico_form_error: "Erreur officielle d'aumico",
    aumico_users_edit_user_security_new_password: 'nouveau mot de passe',
    aumico_users_edit_user_company_general_information_enter_name: "Nom de l'entreprise",
    aumico_users_edit_user_company_general_information_edit_your_profile: 'Editer le profil',
    aumico_users_edit_user_company_general_information_no: 'Non.',
    aumico_users_edit_user_company_general_information_enter_zip: 'Code postal',
    aumico_users_edit_user_general_information_email_address: 'adresse e-mail',
    aumico_users_edit_user_general_information_choose_language: 'Choisir',
    aumico_users_edit_user_general_information_langugage: 'Langue',
    aumico_users_edit_user_general_information_enter_phone_number: 'Registre',
    aumico_users_edit_user_general_information_settings: 'Paramètres',
    aumico_users_edit_user_general_information_salutation: 'discours',
    aumico_users_edit_user_security_current_password: 'Mot de passe actuel',
    aumico_users_edit_user_security_change_password: 'Changer le mot de passe',
    aumico_users_edit_user_security_repeat_new_password: 'Répété le nouveau mot de passe',
    aumico_reports_annualreport_toc_label_proposal_for_the_appropriation_of_profit:
        'Emploi du bénéfice résultant du bilan',
    aumico_users_edit_user_security_enter_new_password: 'entrer un nouveau mot de passe',
    aumico_templates_account_mapping_form_income: 'Compte de résultat',
    aumico_templates_template_account_mapping_form_mapped_accounts: 'Comptes attribués',
    aumico_users_edit_user_company_general_information_country: 'pays',
    aumico_users_edit_user_company_general_information_enter_street: 'Entrer dans la rue',
    aumico_users_edit_user_company_general_information_zip: 'Code postal',
    aumico_users_edit_user_general_information_enter_name: 'Prénom',
    aumico_users_edit_user_general_information_phone: 'Numéro de téléphone.',
    aumico_users_edit_user_security_authentication: 'Authentification',
    aumico_users_edit_user_security_enter_current_password: 'Registre',
    aumico_templates_account_mapping_form_map_sme_account_plan: 'Automapping',
    aumico_templates_account_mapping_form_datev_format_mismatch_warning:
        "La structure des postes importée attend des affectations de compte, le fichier importé n'en contient aucune — l'affectation existante reste inchangée.",
    aumico_templates_account_mapping_form_datev_unknown_purpose_warning: 'Affectation de compte inconnue : {{key}}',
    aumico_templates_account_mapping_form_datev_purpose_shaped_value_warning:
        'Valeur au format affectation dans le chemin par numéro de compte : {{key}}',
    aumico_templates_account_mapping_form_datev_no_candidate_warning: 'Compte {{key}} : le fichier DATEV ne permet aucun poste univoque. Veuillez l\'affecter manuellement.',
    aumico_templates_account_mapping_form_datev_ambiguous_candidates_warning:
        'Compte {{key}} : le fichier DATEV l\'affecte à plusieurs postes ({{candidates}}). Veuillez l\'affecter manuellement.',
    aumico_templates_account_mapping_form_datev_warnings_dismiss: 'Fermer le message',
    aumico_templates_account_mapping_form_datev_unknown_format_warning:
        "Format d'affectation inconnu sur le modèle, chemin par numéro de compte utilisé : {{key}}",
    aumico_annual_report_import_form_balance_end: 'Veuillez indiquer la dernière ligne du bilan',
    aumico_annual_report_import_form_error_invalid_row_input: 'Entrée de ligne non valide',
    aumico_annual_report_import_form_balance_start: 'Veuillez indiquer la première ligne du bilan',
    aumico_annual_report_import_form_error_overlapping: 'Les zones de bilan et les comptes de revenus se chevauchent',
    aumico_annual_report_import_form_income_end: 'Veuillez indiquer la dernière ligne de la facture de réussite',
    aumico_annual_report_import_form_income_start: 'Veuillez indiquer la première ligne de la facture de réussite',
    aumico_annualreport_aop_word_before_currency: 'en',
    aumico_core_form_submit: 'Sauvegarder',
    aumico_notes_word_in: 'en',
    aumico_reports_annualreport_cover_annual_label_title_1st_prefix: 'Rapports annuels',
    aumico_reports_annualreport_cover_quarterly_label_title_1st_prefix: 'Rapport financier trimestriel',
    aumico_reports_annualreport_cover_monthly_label_title_1st_prefix: 'Rapport financier mensuel',
    aumico_reports_annualreport_cover_custom_label_title_1st_prefix: 'Rapport financier',
    aumico_reports_annualreport_page_print_account_mapping_label_total: 'Total',
    aumico_reports_annualreport_page_print_account_mapping_label_word_before_currency: 'en',
    aumico_reports_annualreport_page_print_account_mapping_label_notes: 'Annexe',
    aumico_users_edit_user_general_information_salutations_mr: 'Monsieur',
    aumico_users_edit_user_general_information_salutations_mrs: 'Femme',
    aumico_users_edit_user_general_information_languages_english: 'Anglais',
    aumico_users_edit_user_general_information_languages_english_us: 'Anglais (US)',
    aumico_users_edit_user_general_information_languages_german_switzerland: 'Allemand (Suisse)',
    aumico_users_edit_user_general_information_languages_german_germany: 'Allemand (Allemagne)',
    aumico_users_edit_user_general_information_languages_italian_switzerland: 'Italien (Suisse)',
    aumico_users_edit_user_general_information_languages_french_switzerland: 'Français (Suisse)',
    aumico_templates_group_account_mapping_create_subfli: 'Sous-poste',
    aumico_templates_group_account_mapping_add_more_items: 'Poste',
    aumico_reports_annualreport_cover_label_title_2nd_prefix: 'Pour la période du',
    aumico_users_edit_user_general_information_languages_german: 'Allemand',
    aumico_templates_sub_fli_form_fli_options_label: 'Sélectionner le poste',
    aumico_annual_report_table_menu_option_archive: 'Archive',
    aumico_annual_report_table_menu_option_display_active: 'Montrer activement',
    aumico_annual_report_table_menu_option_delete: 'Supprimer',
    aumico_annual_report_table_menu_option_restore: 'Restaurer',
    aumico_notes_fli_selection_placeholder: 'Sélectionnez la position',
    aumico_notes_fli_drag_disabled_tooltip: 'Toutes les positions doivent être sélectionnées avant de glisser-déposer',
    aumico_annual_report_table_menu_option_display_archived: 'Annonces archivées',
    aumico_notes_rich_text_placeholder: 'Saisie de texte',
    aumico_reports_bexio_error:
        "Soit vous avez refusé d'émettre les autorisations nécessaires, soit une erreur de traitement de votre demande s'est produite",
    aumico_reports_unsaved_changes_warning_dialog_cancel: 'Annuler',
    aumico_notes_table_with_form_enter_placeholder: 'saisir',
    aumico_reports_unsaved_changes_warning_dialog_content:
        'Vous avez des modifications non enregistrées. Souhaitez-vous enregistrer vos données?',
    aumico_reports_unsaved_changes_warning_dialog_discard: 'annuler les modifications',
    aumico_reports_unsaved_changes_warning_dialog_save: 'Sauvegarder',
    aumico_reports_unsaved_changes_warning_dialog_save_unsuccessful: "La sauvegarde n'est pas réussie",
    aumico_annual_report_cash_flow_add_new_item: 'Ajouter une ligne (déplacer par glisser-déposer)',
    aumico_annual_report_cash_flow_financing_activities_title: 'Flux de trésorerie liés aux activités de financement',
    aumico_annual_report_cash_flow_button_recalculate_flis: 'Réinitialiser à la valeur par défaut',
    aumico_annual_report_cash_flow_investing_activities_disinvestments: 'Désinvestissement',
    aumico_annual_report_cash_flow_investing_activities_title: "Flux de trésorerie liés aux activités d'investissement",
    aumico_annual_report_cash_flow_investing_activities_investments: 'Investissement',
    aumico_annual_report_cash_flow_operating_activities_title: "Flux de trésorerie liés aux activités d'exploitation",
    aumico_annual_report_cash_flow_total: 'Variation totale de la trésorerie',
    aumico_annual_report_cash_flow_total_operating_activities:
        'Variation totale de la trésorerie provenant des activités opérationnelles',
    aumico_annual_report_cash_flow_total_investing_activities:
        "Variation totale de la trésorerie provenant des activités d'investissement",
    aumico_annual_report_cash_flow_total_financing_activities:
        'Variation totale de la trésorerie provenant des activités de financement',
    aumico_annual_report_cash_flow_total_cashAndCashEnd: 'Des moyens liquides à la fin de la période',
    aumico_annual_report_cash_flow_total_cashAndCashStart: 'Liquide signifie au début de la période',
    aumico_annual_report_cash_flow_total_total1_name: 'Changement total des moyens liquides',
    aumico_annual_report_cash_flow_total_total2: 'Changement total des moyens liquides',
    aumico_annual_report_print_options_label_show_reclasses_in_sums: 'Incl. Reclassement',
    aumico_annual_report_print_options_mainTitle: 'titre',
    aumico_annual_report_cash_flow_total_total1: 'Changement total des moyens liquides',
    aumico_notes_component_options_movementschedule_column2: 'Colonne 2',
    aumico_notes_component_options_movementschedule_column3: 'Colonne 3',
    aumico_annual_report_print_options_date: 'Période',
    aumico_reports_annualreport_navigation_cfs: 'Tableau des flux de trésorerie',
    aumico_reports_annualreport_navigation_label_balance: 'Bilan',
    aumico_templates_reclass_label_adjustment: 'Réserves latentes',
    aumico_annual_report_cash_flow_total_recapitulation: 'récapitulation',
    aumico_annual_report_interpretation_remove_account_with_zero_balance: 'Supprimer les comptes avec un solde zéro',
    aumico_annual_report_print_options_show_cfs: 'Tableau des flux de trésorerie',
    aumico_templates_reclass_label_change_in_adjustment: '△ Réserves latentes',
    aumico_notes_component_options_movementschedule_column4: 'Colonne 4',
    aumico_templates_reclass_label_reclass: 'Reclass..',
    aumico_reports_annualreport_navigation_label_income: 'Compte de résultat',
    aumico_annual_report_print_options_subTitle: 'Sous-titre',
    aumico_templates_reclass_label_in: 'en',
    aumico_notes_preview_attention:
        "ATTENTION': Cette section pour montrer uniquement à quoi ressemble le composant et tout changement ne réfléchira pas aux données enregistrées",
    aumico_templates_reclass_label_total: 'Inversion totale',
    aumico_annual_report_cash_flow_total_total2_name: 'Changement total des moyens liquides',
    aumico_reports_annualreport_page_adjustments_label_account_number: 'numéro de compte bancaire',
    aumico_annual_report_print_options_label_show_adjustments_in_sums: 'interne ( incl. réserves latentes)',
    aumico_templates_reclass_label_income: 'CR',
    aumico_notes_component_options_movementschedule_column1: 'Colonne 1',
    aumico_reports_annualreport_navigation_adjustments_and_reclasses: 'Reclassements et réserves latentes',
    aumico_templates_reclass_label_account_number: 'numéro de compte bancaire',
    aumico_templates_reclass_label_internal: 'Interne',
    aumico_annual_report_cash_flow_print_preview_notes: 'Annexe',
    aumico_annual_report_print_options_decimal_and_empty_lines_title: 'Dicimaux et lignes vides',
    aumico_annual_report_print_options_reclasses_and_internal_title: 'Valeurs et indice de relation',
    aumico_annual_report_print_options_design_settings_title: 'Paramètres de conception',
    aumico_annual_report_print_options_show_company_logo: 'Print Company Logo',
    aumico_annual_report_print_options_show_organization_logo: 'Organization Logo',
    aumico_annual_report_print_options_show_components_title: 'Composants',
    aumico_annual_report_print_options_show_accounts: 'Afficher les comptes',
    aumico_annual_report_print_options_hide_previous_year: 'Cacher l’année précédente',
    aumico_annual_report_print_options_show_notes: 'Annexe',
    aumico_companies_table_label_company_legal_status: 'forme juridique',
    aumico_companies_table_label_status: 'Status',
    aumico_companies_table_new_button: 'Nouvelle entreprise',
    aumico_companies_table_search_button: 'Rechercher',
    aumico_companies_table_label_company_badge_active: 'Active',
    aumico_companies_table_label_company_badge_inactive: 'Inactive',
    aumico_companies_delete_dialog_ok: 'Supprimer',
    aumico_companies_delete_dialog_cancel: 'Annuler',
    aumico_companies_delete_dialog_text_2: 'Cette action est permanente et ne peut être annulée.',
    aumico_companies_activate_button: 'Activer',
    aumico_companies_activate_state: 'Active',
    aumico_companies_inactivate_state: 'Inactive',
    aumico_companies_changes_saved_successfully_dialog: 'La société a été mise à jour avec succès.',
    aumico_companies_table_label_company_location: 'Emplacement',
    aumico_companies_table_label_company_name: "Nom de l'entreprise",
    aumico_companies_table_label_company_street_and_number: 'Rue et numéro de maison',
    aumico_reports_main_navigation_company_list: 'Entreprises',
    aumico_reports_print_highlight_color_1: 'Contexte 1',
    aumico_reports_print_highlight_color_2: 'Contexte 2',
    aumico_companies_table_label_company_postal_code: 'Code postal',
    aumico_templates_adjustmentAndReclassed_group_form_tooltip: 'Adaptation aux comptes de réussite en-us',
    aumico_templates_income_selection_popup_done_btn: 'Sauvegarder',
    aumico_users_edit_user_company_general_information_upload_logo_label: 'Télécharger la papeterie',
    aumico_templates_income_selection_popup_title: 'Sélectionner le compte de résultat',
    aumico_users_edit_user_company_general_information_upload_logo_text: 'Tirez un PDF avec la papeterie ici',
    aumico_reports_print_text_color: 'Texte',
    aumico_users_edit_user_company_general_information_company_logo:
        'Papeterie de modèle pour la feuille de couverture',
    aumico_reports_main_navigation_edit_company: 'Créer / éditer une entreprise',
    aumico_reports_print_title_color: 'Titre',
    aumico_reports_print_table_header_color: 'En-tête de tableau',
    aumico_reports_print_table_footer_color: 'Pied de page du tableau',
    aumico_reports_design_settings_select_colors_title: 'Sélectionner les couleurs',
    aumico_reports_design_settings_preview_title: 'Avant-première',
    aumico_reports_design_settings_save_button: 'Sauvegarder',
    aumico_reports_design_settings_example_normal_row: 'Voici un exemple de ligne commune',
    aumico_reports_design_settings_example_footer_row: 'Voici un exemple de ligne de bas de page',
    aumico_users_edit_user_company_general_information_upload_logo_extension_error: 'Télécharger le fichier PDF',
    aumico_annual_report_import_balance_and_income_from_separate_files_option:
        'Télécharger le bilan et le compte de résultat séparément',
    aumico_annual_report_import_definition_specify_data_start_line_1:
        'Entrez le numéro de ligne à partir duquel les comptes commencent',
    aumico_annual_report_import_definition_specify_data_start_line_2: 'Tableau',
    aumico_annual_report_import_form_balance_instruction_text: 'Tirez le solde du fichier ici',
    aumico_annual_report_import_form_income_instruction_text: 'Tirez le fichier vers la facture de réussite ici',
    aumico_annual_report_import_optional_settings_title: 'Paramètres additionnels',
    aumico_annual_report_aop_accounts_placeholder: 'Sélectionner le poste',
    aumico_annual_report_general_information_autofill_from_list_btn_text:
        'Sélectionnez le rapport annuel pour le transfert de données',
    aumico_annual_report_general_information_autofill_from_previous_year_btn_text:
        "Rapport annuel Autofill de l'année précédente",
    aumico_annual_report_general_information_balance_sheet: 'Bilan',
    aumico_annual_report_general_information_current_year: 'année actuelle',
    aumico_annual_report_general_information_date_from: 'Depuis',
    aumico_annual_report_general_information_date_to: "Jusqu'à",
    aumico_annual_report_general_information_income_current_date_from_error: 'Actuel',
    aumico_annual_report_general_information_income_current_date_to_error: 'La date de fin est avant la date de début',
    aumico_annual_report_general_information_income_previous_date_from_error: 'précédent',
    aumico_annual_report_general_information_income_previous_date_to_error: 'précédent',
    aumico_annual_report_general_information_income_statement: 'Compte de résultat',
    aumico_annual_report_general_information_no_previous_data: "Pas de données de l'année précédente ( fondation)",
    aumico_annual_report_general_information_optional_or: 'ou',
    aumico_annual_report_general_information_options: 'Options',
    aumico_annual_report_general_information_please_determine_income_date: 'Période actuelle',
    aumico_annual_report_general_information_previous_period: 'Période précédente',
    aumico_annual_report_general_information_take_autofill_from_previous_annual_report:
        "Reprendre la configuration sans les données de l'année précédente (Télécharger les deux années à partir d'Excel)",
    aumico_annual_report_general_information_take_previous_data_from_annual_report:
        "Reprendre les données de l'année précédente (Télécharger uniquement l'année en cours à partir d'Excel)",
    aumico_annual_report_import_choose_annual_report_for_autofill_and_mapping_button: 'Sélectionner le rapport annuel',
    aumico_annual_report_import_select_annual_report_for_autofill_and_mapping:
        "Reprendre la configuration de téléchargement et le mappage des comptes d'un rapport existant",
    aumico_annual_report_selection_list_accounting_basis: 'Norme de comptabilité',
    aumico_annual_report_selection_list_company: 'entreprise',
    aumico_annual_report_selection_list_current_year_date: 'année actuelle',
    aumico_annual_report_selection_list_legal_form: 'forme juridique',
    aumico_new_button: 'Nouveau',
    aumico_reports_annualreport_page_financial_statement_general_information_label_general_information:
        'informations générales',
    aumico_reports_print_page_adjustments_reclasses_warning:
        'Veuillez noter que les modifications apportées manuellement dans le calcul des flux de trésorerie peuvent être écrasées par des valeurs internes.',
    aumico_reports_print_title_establishment: 'Date de fondation',
    aumico_reports_warning_popup_warning_title: 'avertissement',
    aumico_search_placeholder: 'Rechercher',
    aumico_templates_account_mapping_form_map_income_total: 'Bénéfice reporté du CDR',
    aumico_templates_account_mapping_form_transferred_profit_account_name: 'Bénéfice / perte annuel',
    aumico_annual_report_print_options_disable_balance_sheet_page_break: 'Bilan sur une page',
    aumico_annual_report_print_options_place_signature_after_aop: "Signature de l'utilisation des bénéfices",
    aumico_core_data_grid_items: 'Comptes',
    aumico_core_pagination_action_bar_range_text: 'depuis',
    aumico_core_accordion_Information_dialog_title: 'information',
    aumico_core_table_filter_placeholder: 'filtre',
    aumico_users_company_profile_general_information_side_margins: 'Bords latéraux: 1,5 cm de tous les côtés',
    aumico_admin_navigation_accounting_basis: 'Base comptable',
    aumico_admin_navigation_change_password: 'Changer le mot de passe',
    aumico_admin_navigation_aumico_users: "Utilisateurs d'aumico",
    aumico_admin_navigation_home: 'Maison',
    aumico_admin_navigation_legal_form: 'En forme légalement',
    aumico_admin_navigation_financial_line_item: 'Article de la ligne financière',
    aumico_admin_navigation_localization: 'Localisation',
    aumico_admin_navigation_logout: 'Se déconnecter',
    aumico_admin_navigation_manage: 'Gérer',
    aumico_admin_navigation_login: 'Se connecter',
    aumico_admin_navigation_notes: 'Remarques',
    aumico_admin_navigation_settings: 'Paramètres',
    aumico_admin_navigation_signup: "S'inscrire",
    aumico_admin_navigation_templates: 'Modèles',
    aumico_admin_navigation_user_management: 'Gestion des utilisateurs',
    aumico_admin_navigation_types: 'Taper',
    aumico_admin_form_language: 'Language it-ch',
    aumico_annual_report_cash_flow_mandatory_field: 'Le champ suivant est un champ obligatoire',
    aumico_admin_user_already_exists: 'Cet utilisateur existe déjà',
    aumico_settings_financialLineItem_form_name_already_exists_error: 'Il y a déjà un fli avec ce nom',
    aumico_settings_accountingbasis_form_name_already_exists_error:
        'Il y a déjà une norme comptable avec cette désignation',
    aumico_settings_legalForm_form_name_already_exists_error: 'Il y a déjà une forme juridique avec cette désignation',
    aumico_annual_report_general_information_company: 'entreprise',
    aumico_reports_main_navigation_user_profile: 'Ajuster le profil',
    aumico_annual_report_print_options_show_fli_total: 'Totaux de la somme',
    aumico_reports_internal_mapping_changes_warning:
        'Le système a fait des affectations dans la cartographie des comptes. Enregistrez si vous souhaitez le maintenir.',
    aumico_annual_report_interpretation_account_number_invalid_input:
        'Seuls les nombres ou zones positifs (par exemple 3 ou 3-5) sont autorisés',
    aumico_reports_welcome_page_footer_about_link: 'https://aumico.io/agb/',
    aumico_reports_welcome_page_footer_impressum_link: 'https://aumico.io/impressum/',
    aumico_reports_welcome_page_footer_privacy_policy_link: 'https://aumico.io/datenschutz/',
    aumico_templates_group_account_mapping_unallowed:
        "Il n'est pas possible d'attribuer les comptes sélectionnés au groupe de comptes souhaité car il contient un ou plusieurs sous-groupes comptables.",
    aumico_information_dialog_title: 'information',
    aumico_reports_equality_check_dialog_assets_and_liabilities_closing_not_equal:
        "Actif et passif de l'année en cours ne sont pas d'accord",
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_and_closing_not_equal:
        "Actif et les passif de l'année actuelle et de l'année dernière ne correspondent pas",
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_not_equal:
        "Actif et les responsabilités de l'année précédente ne correspondent pas",
    aumico_reports_equality_check_dialog_cashflow_totals_closing_not_equal:
        "Le total des flux de trésorerie de l'année en cours ne correspond pas",
    aumico_reports_equality_check_dialog_cashflow_totals_opening_and_closing_not_equal:
        "Le total des flux de trésorerie du courant et de l'année dernière ne correspond pas",
    aumico_reports_equality_check_dialog_cashflow_totals_opening_not_equal:
        "Le total des flux de trésorerie de l'année précédente ne correspond pas",
    aumico_reports_equality_check_dialog_go_back_and_correct_it: 'Retour et corriger',
    aumico_reports_equality_check_dialog_proceed: 'Continuer sans corriger',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_closing_not_equal:
        "Les bénéfices du bilan et le calcul des bénéfices de l'année en cours ne sont pas d'accord",
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_and_closing_not_equal:
        'Le bénéfice du bilan ne correspond pas au bénéfice du compte de résultat.',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_not_equal:
        "Les bénéfices du bilan et le calcul des bénéfices de l'année précédente ne sont pas d'accord",
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_closing_not_equal:
        "Le total de l'actif et du passif de l'année en cours ne correspond pas",
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_and_closing_not_equal:
        "Actif et passif du courant et de l'année dernière ne correspond pas (en raison de la formation / dissolution des réserves latentes)",
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_not_equal:
        "Le total des actifs et passifs de l'année précédente ne correspondent pas",
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_closing_not_equal:
        "Le résultat annuel du compte de résultat et le bénéfice du bilan ne correspondent pas pour l'année en cours (en raison de la constitution/dissolution de réserves latentes).",
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_and_closing_not_equal:
        "Résultat annuel de l'état du succès et du profit du bilan dans le courant et l'année dernière ne sont pas d'accord (en raison de la formation / dissolution des réserves latentes)",
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_not_equal:
        "Résultat annuel de l'état du succès et du profit du bilan de l'année précédente n'est pas d'accord (en raison de la formation / dissolution des réserves latentes)",
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_and_closing_not_equal:
        "Les actifs et les passifs de l'année en cours et de l'année précédente ne correspondent pas (en raison de reclassements).",
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_closing_not_equal:
        "Les actifs et les passifs de l'exercice en cours ne correspondent pas (en raison de reclassements).",
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_closing_not_equal:
        "Le résultat annuel de l'état de réussite et du profit du bilan ne sont pas d'accord au cours de l'année en cours (sur la base des inversions)",
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_and_closing_not_equal:
        "Résultat annuel de l'état de réussite et de profit du bilan dans le courant et l'année dernière ne sont pas d'accord (en raison de la réorganisation)",
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_not_equal:
        "Le résultat annuel de l'état de réussite et du profit du bilan de l'année précédente n'est pas d'accord (basé sur la réorganisation)",
    aumico_reports_equality_check_print_preview_table_adjustments: 'Bilan des réserves latentes',
    aumico_reports_equality_check_print_preview_information_dialog_content:
        "Le contrôle final vous aide à vous assurer qu'aucune erreur ne se glisse dans vos rapports annuels.",
    aumico_reports_equality_check_print_preview_table_adjustments_profit_income_equals_adjustments_profit_balance:
        'Résultat silencieux.',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_not_equal:
        "Actif et passif de l'année précédente ne sont pas d'accord (en raison de la réorganisation)",
    aumico_reports_equality_check_print_preview_table_assets_equal_liabilities: 'Actif = passif',
    aumico_reports_equality_check_print_preview_table_current_year_column: 'année actuelle',
    aumico_reports_equality_check_print_preview_table_cashflow_statement: 'Relevé de trésorerie',
    aumico_reports_equality_check_print_preview_table_previous_year_row: 'Année précédente',
    aumico_reports_equality_check_print_preview_table_profit_income_equals_profit_fli: 'Bilan de profit = gagner',
    aumico_reports_equality_check_print_preview_table_previous_year_column: 'Année précédente',
    aumico_reports_equality_check_print_preview_table_reclasses_profit_income_equals_reclasses_profit_balance:
        'Reclass.. Résultat Il = réverbération. Équilibre des résultats',
    aumico_reports_equality_check_print_preview_table_current_year_row: 'année actuelle',
    aumico_reports_equality_check_print_preview_table_title: 'Aperçu',
    aumico_reports_equality_check_print_preview_table_reclasses: 'Bilan des exigences',
    aumico_reports_equality_check_print_preview_title: 'Vérification finale',
    aumico_reports_required_data_not_completed: "L'une des étapes précédentes n'est pas encore terminée.",
    aumico_reports_template_not_found: '#Valeur!',
    aumico_reports_error_dialog_something_went_wrong: "Quelque chose s'est mal passé",
    aumico_annual_report_print_options_label_income_ratio_reference: 'Facture de succès de valeur de référence',
    aumico_annual_report_print_options_income_ratio_reference_internal_change_warning_message:
        "La valeur de référence de l'indice de relation dans le calcul des bénéfices a été modifiée car elle ne peut pas être 0.",
    aumico_annual_report_print_options_label_show_ratios: 'Ratios',
    aumico_companies_notification_error_description:
        "L'entreprise n'a pas pu être supprimée car il existe peut-être un lien.",
    aumico_reports_notification_success_title: 'Mis à jour avec succés',
    aumico_reports_default_page_header: 'Indéfini',
    aumico_reports_notification_error_title: "Quelque chose s'est mal passé",
    aumico_admin_edit_user_profile: 'Modifier le profil utilisateur',
    aumico_core_information_popup_default_title: 'information',
    aumico_templates_group_form_enter_group_title_error: 'Veuillez saisir un nom pour le groupe',
    aumico_templates_group_form_enter_group_total_name_error: 'Veuillez saisir un nom pour le groupotal',
    aumico_templates_group_form_title: 'Groupe de noms',
    aumico_templates_group_form_total_name: 'Description Groupotal (Total ...)',
    aumico_annual_report_complementary_reports_add_report_button: 'Ajouter un rapport',
    aumico_annual_report_complementary_reports_description:
        "Ajoute d'autres rapports à tes comptes annuels, comme par exemple un Management Summary, une déclaration d'intégralité et bien d'autres encore.",
    aumico_annual_report_complementary_reports_headline: 'Rapports complémentaires',
    aumico_annual_report_complementary_reports_report_rich_text_placeholder: 'Insérer le texte',
    aumico_annual_report_complementary_reports_report_title: 'Titre du rapport',
    aumico_annual_report_complementary_reports_title_error: 'Le titre est un champ obligatoire',
    aumico_annual_report_print_options_show_complementary_reports: 'Rapports complémentaires',
    aumico_empty_field_error: "C'est un champ obligatoire",
    aumico_reports_annualreport_navigation_complementary_reports: 'Rapports complémentaires',
    aumico_users_personal_information_language_error: 'La langue est un domaine obligatoire',
    aumico_users_personal_information_organization_label: 'Nom de votre entreprise',
    aumico_users_personal_information_language_section_title: 'Choisissez votre langue',
    aumico_users_registration_email_username_placeholder: "Entrer l'adresse e-mail",
    aumico_users_personal_information_sub_title: 'Veuillez nous fournir les informations suivantes:',
    aumico_users_personal_information_main_title: 'Nous voulons apprendre à vous connaître',
    aumico_users_registration_password_label: 'mot de passe',
    aumico_users_registration_password_placeholder: 'Entrer le mot de passe',
    aumico_users_registration_privacy_policy: 'Protection des données',
    aumico_users_registration_email_username_required_error:
        "L'adresse e-mail professionnelle est un champ obligatoire",
    aumico_users_personal_information_organization_error: 'Le nom de votre entreprise est un domaine obligatoire',
    aumico_users_reset_password_button: 'réinitialiser le mot de passe',
    aumico_users_signup_continue_button: 'Plus loin',
    aumico_users_signup_creating_your_account_button: 'Créer un compte',
    aumico_users_registration_read_and_agree: "J'ai lu la déclaration de protection des données et je l'ai convenu:",
    aumico_users_registration_main_title: 'Commencez votre phase de test de 10 jours!',
    aumico_annual_report_ems_add_new_item_button_text: '+ Nouvelle ligne',
    aumico_annual_report_ems_total_equity_header_text: 'Totalement des capitaux propres',
    aumico_annual_report_ems_new_total_column: 'Nouveau total',
    aumico_annual_report_ems_manual_column: 'Colonne ajoutée manuellement',
    aumico_annual_report_ems_row_title: 'Capitaux propres au',
    aumico_annual_report_ems_business_year: 'Exercice',
    aumico_annual_report_ems_difference_to: 'Différence par rapport aux capitaux propres au',
    aumico_annual_report_ems_position_column_header: 'Poste / mouvement',
    aumico_annual_report_ems_add_column: '+ Nouvelle colonne',
    aumico_annual_report_ems_add_column_limit: 'Le PDF peut afficher au maximum 8 colonnes.',
    aumico_annual_report_ems_column_type_select_label: 'Choisir le type de colonne',
    aumico_annual_report_ems_column_type_value: 'Colonne de valeurs',
    aumico_annual_report_ems_column_type_value_description: 'Poste avec des valeurs saisissables',
    aumico_annual_report_ems_column_type_total: 'Colonne de total',
    aumico_annual_report_ems_column_type_total_description: 'Somme des colonnes de valeurs sélectionnées',
    aumico_annual_report_ems_structure_diff_intro: 'La structure des comptes du mapping a changé.',
    aumico_annual_report_ems_structure_diff_new: 'Nouvellement ajouté : {{names}}.',
    aumico_annual_report_ems_structure_diff_removed: 'Ne figure plus dans le mapping : {{names}}.',
    aumico_annual_report_ems_structure_diff_apply: 'Mettre à jour les colonnes',
    aumico_annual_report_print_options_show_ems: 'Spectacle ekn',
    aumico_reports_annualreport_navigation_equity_movement_schedule: 'Tableau des capitaux propres',
    aumico_reports_annualreport_navigation_fixed_assets_schedule: 'Horaire des immobilisations - DE',
    aumico_reports_annualreport_navigation_reorder_report_and_print: 'Imprimer dans un ordre différent',
    aumico_reports_equity_movement_schedule_no_table_shown_error_message:
        "Il n'y a aucun compte affecté aux capitaux propres.",
    aumico_reports_reorder_report_cover_section_title: 'Page couverture',
    aumico_reports_reorder_report_section_save_button: 'Sauvegarder',
    aumico_reports_reorder_report_sections_dialog_title: 'Pour changer la commande',
    aumico_annual_report_ems_text_addition_above_title: 'Introduction',
    aumico_annual_report_ems_text_addition_below_title: 'Remarque',
    aumico_annual_report_ems_title: 'Tableau des capitaux propres',
    aumico_annual_report_print_preview_ems: 'Tableau des capitaux propres',
    aumico_reports_main_navigation_organization_settings: 'Paramètres organisationnels',
    aumico_reports_main_navigation_design_settings: 'Design',
    aumico_reports_organization_settings_navigation_organization_profile: 'profil',
    aumico_reports_organization_settings_navigation_text_snippets: 'Modèles de signalement',
    aumico_reports_organization_settings_text_snippets_title: 'Modèles de signalement',
    aumico_annual_report_complementary_reports_delete_icon_text: 'Supprimer',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_cancel_button: 'Annuler',
    aumico_annual_report_complementary_reports_prefill_with_text_snippet_icon_text: 'Insérer le module de texte',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_description:
        'Es-tu sûr? Vous écrasez le champ de texte',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_yes_button: 'Oui',
    aumico_annual_report_complementary_reports_text_snippets_dialog_description: 'Décrit',
    aumico_annual_report_complementary_reports_text_snippets_dialog_insert_text_snippet_button: "Modèle d'insertion",
    aumico_annual_report_complementary_reports_text_snippets_dialog_title: 'Insérer un modèle prédéfini',
    aumico_reports_equity_movement_schedule_refresh_button_text: 'Mettre à jour Ekn',
    aumico_reports_organization_settings_text_snippets_add_new_button: 'Ajouter',
    aumico_reports_organization_settings_text_snippets_create_dialog_title: 'Ajouter un nouveau modèle',
    aumico_reports_organization_settings_text_snippets_form_dialog_content_field_required_error:
        'Le contenu est requis',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_conflict_error_notification_description:
        'La création du module de texte a échoué: la description existe déjà',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_success_notification_description:
        'Module de texte créé avec succès',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_internal_server_error_description:
        "Le module de texte n'a pas pu être créé : Erreur du serveur interne",
    aumico_reports_organization_settings_text_snippets_form_dialog_cancel_button: 'Annuler',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_already_exists_error:
        'Description existe déjà',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_required_error:
        'Description requise',
    aumico_reports_organization_settings_text_snippets_form_dialog_save_button: 'Sauvegarder',
    aumico_reports_organization_settings_text_snippets_form_dialog_error_notification_title: 'Erreur',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field: 'titre',
    aumico_reports_organization_settings_text_snippets_list_created_by_column_header: 'Créé par',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field_required_error: 'Titre requis',
    aumico_reports_organization_settings_text_snippets_list_created_at_column_header: 'Créé sur',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field: 'Description',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_description:
        "Le module de texte n'a pas pu être supprimé: Erreur du serveur interne",
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_description:
        'Êtes-vous sûr de vouloir supprimer le module de texte sélectionné?',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_yes_button: 'Oui',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_cancel_button: 'Annuler',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_title: 'Réussi',
    aumico_reports_organization_settings_text_snippets_list_last_modified_column_header: 'Dernier édité',
    aumico_reports_organization_settings_text_snippets_form_dialog_success_notification_title: 'Réussi',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_description:
        'Module de texte supprimé avec succès',
    aumico_reports_organization_settings_text_snippets_list_description_column_header: 'Description',
    aumico_reports_organization_settings_text_snippets_list_title_column_header: 'titre',
    aumico_reports_organization_settings_text_snippets_list_delete_button: 'Supprimer',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_title: 'Erreur',
    aumico_reports_organization_settings_text_snippets_list_modified_by_column_header: 'Édité par',
    aumico_admin_ar_template_data_not_completed_error: 'Les informations générales doivent être remplies',
    aumico_admin_ar_template_define_pdf_template: 'Définir le modèle PDF',
    aumico_admin_ar_template_download_pdf_template: 'Télécharger le modèle PDF',
    aumico_admin_ar_template_general_information_accounting_bases: 'Normes de comptabilité',
    aumico_admin_ar_template_general_information_annual_report_steps: 'Étapes de navigation Jr',
    aumico_admin_ar_template_general_information_consistency: 'la cohérence',
    aumico_admin_ar_template_general_information_countries: 'pays',
    aumico_admin_ar_template_general_information_field_required_error: 'Ce champ est obligatoire',
    aumico_admin_ar_template_general_information_legal_forms: 'forme juridique',
    aumico_admin_ar_template_general_information_business_models: "Modèle d'entreprise",
    aumico_admin_ar_template_general_information_state: 'statut',
    aumico_admin_ar_template_general_information_name: 'Nom de famille',
    aumico_admin_ar_template_list_delete_error_notification_description: "Échoué! Le modèle n'a pas pu être supprimé",
    aumico_admin_ar_template_list_delete_failed_notification_title: 'Erreur',
    aumico_admin_ar_template_list_delete_success_notification_description: 'Le modèle a été supprimé avec succès',
    aumico_admin_ar_template_list_menu_item_delete: 'supprimer',
    aumico_admin_ar_template_navigation_general_information: 'informations générales',
    aumico_admin_ar_template_list_delete_success_notification_title: 'Réussi',
    aumico_admin_ar_template_navigation_balance_sheet_taxonomy: 'Équilibre taxonomie',
    aumico_admin_ar_template_navigation_income_statement_taxonomy: 'Taxonomie de calcul du succès',
    aumico_admin_ar_template_pdf_error_notification_description_file_too_large:
        'Le modèle PDF ne peut pas être téléchargé: le fichier est trop grand',
    aumico_admin_ar_template_navigation_notes: 'Annexe',
    aumico_admin_ar_template_navigation_pdf_template: 'Modèle PDF',
    aumico_admin_ar_template_pdf_updated_success_notification_description: 'Modèle PDF mis à jour avec succès',
    aumico_admin_countries_label: 'Des pays',
    aumico_admin_ar_template_table_actions: 'action',
    aumico_admin_ar_template_specifications: 'Caractéristiques',
    aumico_admin_ar_template_pdf_error_notification_description_file_type_invalid:
        'Le modèle PDF ne peut pas être téléchargé: le type de fichier doit être .docx',
    aumico_admin_menu_item_demote_to_admin: "Déploier l'administrateur",
    aumico_admin_navigation_ar_templates: 'Modèles AR',
    aumico_admin_menu_item_unblock_user: "Déverrouiller l'utilisateur",
    aumico_admin_menu_item_promote_to_admin: 'Définir comme administrateur',
    aumico_admin_menu_item_block_user: 'Bloquer un utilisateur',
    aumico_admin_user_list_notification_failure_description:
        "Une erreur s'est produite, veuillez réessayer ou nous contacter plus tard ou nous contacter",
    aumico_admin_user_list_notification_success_title: 'Réussi',
    aumico_admin_user_list_notification_success_description: 'Utilisateur mis à jour avec succès',
    aumico_admin_user_list_notification_failure_title: 'Erreur',
    aumico_admin_user_list_status_inactive: 'Inactif',
    aumico_admin_usermanagement_confirmation_modal_change_user_role: 'Voulez-vous changer le rôle de {e-mail}',
    aumico_admin_usermanagement_confirmation_modal_change_user_activity_state:
        "Souhaitez-vous modifier l'état de l'utilisateur suivant {e-mail}?",
    aumico_admin_usermanagement_confirmation_modal_cancel_button: 'Annuler',
    aumico_admin_usermanagement_confirmation_modal_title_block_user: 'Bloquer les utilisateurs',
    aumico_admin_usermanagement_confirmation_modal_title_promote_admin: 'Émettre des droits administratifs',
    aumico_admin_usermanagement_confirmation_modal_title_unblock_user: "Déverrouiller l'utilisateur",
    aumico_admin_usermanagement_confirmation_modal_title_demote_admin: 'Supprimer les droits administratifs',
    aumico_admin_navigation_aumico_organization: 'Organisations AUMICO',
    aumico_annual_report_import_page_can_not_navigate_to_mapping_dialog_description:
        "Vous devez d'abord télécharger des données pour obtenir une étape de mappage",
    aumico_annual_report_print_options_experimental_section: 'Propre disposition (bêta)',
    aumico_annual_report_print_options_experimental_section_description:
        "Ceci est un domaine de test dans lequel vous pouvez utiliser de nouvelles options d'impression",
    aumico_annual_report_print_options_aop: 'Emploi du bénéfice résultant du bilan',
    aumico_annual_report_print_options_fin_statement: 'Rapport annuels',
    aumico_annual_report_print_options_hide_decimal_places_in_values: 'Masquer les décimales dans les valeurs',
    aumico_annual_report_print_options_hide_decimal_places_in_ratios:
        'Masquer les décimales dans les chiffres clés du rapport',
    aumico_annual_report_print_options_hide_empty_lines: 'Supprimer lignes vides',
    aumico_admin_user_list_status_active: 'Actif',
    aumico_annual_report_print_options_show_account_numbers: 'Afficher le numéro de compte',
    aumico_change_password_notification_success: 'Mot de passe changé avec succès',
    aumico_change_password_notification_failed_title: 'Échoué!',
    aumico_change_password_relogin_title: 'Mot de passe modifié',
    aumico_change_password_relogin_description: 'Votre mot de passe a été modifié. Veuillez vous reconnecter.',
    aumico_change_password_relogin_failed_title: 'Se reconnecter',
    aumico_change_password_relogin_failed_description: 'Votre mot de passe n\'a pas été modifié. Veuillez vous reconnecter.',
    aumico_change_password_relogin_button: 'Se déconnecter',
    aumico_change_password_notification_failed: "Lorsque vous modifiez le mot de passe, une erreur s'est produite",
    aumico_admin_usermanagement_confirmation_modal_confirm_button: 'Confirmer',
    aumico_companies_form_country_has_no_legal_form:
        'Ce pays ne contient pas le formulaire juridique que vous avez sélectionné',
    aumico_editable_account_number_unique_validator: 'Le numéro de compte ne se produit pas plusieurs fois',
    aumico_editable_account_invalid_data_modal_title: 'Données invalides',
    aumico_editable_account_invalid_data_modal_content: "L'intitulé du compte et le numéro de compte sont nécessaires.",
    aumico_editable_account_placeholder_name: 'Désignation de compte',
    aumico_annual_report_country_has_no_legal_account_basis:
        "Aucun plan de compte disponible pour le pays de l'entreprise",
    aumico_editable_account_placeholder_opening_value: 'Année précédente',
    aumico_general_information_autofill_date_popup_autofill_btn: 'Remplissez automatiquement',
    aumico_editable_account_placeholder_number: 'numéro de compte bancaire',
    aumico_general_information_autofill_date_popup_no_autofill_btn: 'Ne pas remplir automatiquement',
    aumico_annual_report_print_options_experimental_section_text:
        "Veuillez noter que les nouvelles options d'impression ne fonctionnent que si vous appuyez sur le nouveau bouton (Imprimer (PDF TRON)). Les paramètres de la zone de test ne sont pas affichés dans l'aperçu.",
    aumico_googleidp_invalid_code_error_message_title: 'Code expiré ou non valide',
    aumico_invitation_expired_description:
        "Il semble que votre code d'invitation ait expiré. Veuillez contacter un administrateur",
    aumico_notification_resend_email_failed_content: 'E-mail La livraison a échoué, veuillez réessayer plus tard',
    aumico_googleidp_invalid_code_error_message_content:
        "Votre e-mail de confirmation a expiré. Cliquez ici pour envoyer à nouveau l'e-mail",
    aumico_notification_resend_email_success_content: 'Email envoyé avec succès, veuillez vérifier votre e-mail',
    aumico_notification_resend_email_success: 'Réussi!',
    aumico_annual_report_print_options_notes: 'Annexe',
    aumico_reports_ar_templates_list_dialog_save_button: 'Enregistrer le modèle de rapport annuel sélectionné',
    aumico_notification_resend_email_failure: 'Échoué',

    aumico_reports_invitation_intro: "Vous avez été invité par {nom d'invitation}",
    aumico_change_password_notification_success_title: 'Mot de passe changé',
    aumico_reports_ar_templates_list_dialog_title: 'Modèles de rapport annuel',
    aumico_reports_invite_new_users_dialog_input_placeholder: 'Add Email Address',
    aumico_reports_invite_users_email_already_exist_error_message:
        "Les e-mails suivants n'ont pas été invités car ils existent déjà dans une autre organisation",
    aumico_reports_invite_users_cannot_invite_same_organization_users:
        "Les e-mails suivants n'ont pas été invités car ils existent déjà dans votre organisation",
    aumico_reports_organization_navigation_users: 'utilisateur',
    aumico_reports_invite_users_success_message: 'Votre invitation a réussi',
    aumico_reports_invite_new_users_dialog_title: 'Invitez de nouveaux utilisateurs à organiser',
    aumico_reports_invite_new_users_dialog_save_button: 'Inviter',
    aumico_reports_remove_users_success_message: "L'utilisateur a été supprimé avec succès",
    aumico_reports_organization_settings_text_snippets_form_dialog_update_success_notification_description:
        'Les modèles de texte ont été mis à jour avec succès',
    aumico_editable_account_placeholder_closing_value: 'Dernière année',
    aumico_users_organization_change_organization_state_modal_confirm_no_action: 'Annuler',
    aumico_user_email_already_exists_error: "L'adresse e-mail est déjà utilisée par une autre organisation",
    aumico_reports_no_annualreport_template_defined:
        "Il n'y a pas de modèle pour les rapports annuels pour le formulaire juridique sélectionné et la norme comptable et le pays spécifié",
    aumico_reports_invite_users_wrong_data_error_message: 'Les fausses données ont été envoyées',
    aumico_general_information_autofill_date_popup_content:
        'Souhaitez-vous que les données restantes soient remplies automatiquement?',
    aumico_users_organization_users_table_email_label: 'e-mail',
    aumico_users_organization_users_remove_cancel_button: 'Annuler',
    aumico_reports_print_page_data_not_available: 'Pas de données disponibles',
    aumico_users_organization_users_table_phone_number_label: 'téléphone',
    aumico_users_organization_users_table_role_label: 'rôle',
    aumico_reports_organization_settings_text_snippets_update_dialog_title: 'Mettre à jour les modèles de texte',
    aumico_invitation_expired_title: "Le code d'invitation a expiré",
    aumico_users_organization_change_organization_state_modal_confirm_action: 'Confirmer',
    aumico_users_organization_change_organization_state_action: 'Changer le statut',
    aumico_reports_annualreport_navigation_print_using_pdf_tron: 'Export PDF',
    aumico_users_organization_users_remove_confirmation_button: 'Retirer',
    aumico_users_organization_users_remove_confirmation_text:
        'Les utilisateurs sélectionnés perdent leur accès à la plate-forme. Êtes-vous sûr de vouloir vous retirer?',
    aumico_reports_invite_new_users_dialog_input_label: "Entrer l'adresse e-mail",
    aumico_users_organization_users_table_remove_users: "Supprimer de l'organisation",
    aumico_reports_invite_users_failure_okay_button_label: "D'ACCORD",
    aumico_reports_organization_settings_text_snippets_form_dialog_update_error_notification_description:
        "Mise à jour de l'extrait de texte Échec: Erreur du serveur interne",
    aumico_reports_remove_users_user_removing_self_error_message:
        "Vous ne pouvez pas vous supprimer en tant qu'utilisateur",
    aumico_users_organization_change_organization_state_modal_title: "Changer le statut de l'organisation",
    aumico_users_organization_users_table_name_label: 'utilisateur',
    aumico_admin_home_welcome_label: "Bienvenue à l'interface administrateur!",
    aumico_reports_share_annual_report_dialog_text:
        'Souhaite soumettre un rapport financier. Souhaitez-vous accepter la proportion de cette organisation?',
    aumico_reports_share_annual_report_success_notification_title: 'Succès entièrement partagé entièrement',
    aumico_reports_share_annual_report_success_notification_description: 'Votre rapport annuel a partagé avec succès',
    aumico_reports_share_annual_report_dialog_accept_button: 'Accepter',
    aumico_reports_share_annual_report_dialog_decline_button: 'Perdre du poids',
    aumico_annual_report_table_menu_option_per_row_secure_share: 'Partager',
    aumico_reports_share_annual_report_dialog_title: 'Partager Rapport annuel',
    aumico_reports_share_annual_report_dialog_content:
        "Vous pouvez partager un rapport annuel avec n'importe quelle adresse e-mail",
    aumico_reports_invitation_dialog_validation_message_enter_valid_email:
        "S'il vous plaît, mettez une adresse email valide",
    aumico_reports_share_annual_report_dialog_input_label: 'e-mail',
    aumico_reports_share_annual_report_dialog_save_button: 'Partager',
    aumico_reports_annualreport_footer_share_annual_report: 'Part de partage',
    aumico_reports_customer_attraction_dialog_title: 'Curieux de savoir comment utiliser aumico avec votre entreprise?',
    aumico_reports_customer_attraction_dialog_button_text: 'Parle-nous',
    aumico_reports_customer_attraction_dialog_text_below_button: 'ou appelez-nous: +12 345 67686',
    aumico_reports_customer_attraction_dialog_descriptive_text:
        "Nous avons d'excellentes solutions pour le porteur Pelletesque SEM MI SAPIEN DIAM SEM SED. Ultrices de feugiat molestie varius adipiscing vitae amet temporaire amet. Pharetra Vulzutate Sagittis Bibendum.",
    aumico_reports_share_annual_report_confirmation_dialog_message:
        'Êtes-vous sura que vous souhaitez partager votre rapport avec:',
    aumico_reports_share_annual_report_confirmation_go_back_cancel_button: 'retourner',
    aumico_reports_share_annual_report_confirmation_dialog_save_button: 'Oui, partager',
    aumico_annual_report_print_only: 'Imprimer',
    aumico_annual_reports_export_excel: 'Export Excel',
    aumico_admin_navigation_translations: 'traduction',
    aumico_admin_translations_expand_all: 'Développer tout',
    aumico_admin_translations_collapse_all: 'Toutes les mises à niveau',
    aumico_admin_translations_show_only_untranslated: "Tout simplement non traduit d'annonces",
    aumico_admin_translations_save: 'Sauvegarder',
    aumico_admin_translations_notes_types: 'Points annexés',
    aumico_admin_translations_notes_templates: "Modèles d'annexe",
    aumico_admin_translations_accounting_bases: 'Norme de comptabilité',
    aumico_admin_translations_tasks: 'Tâches',
    aumico_admin_translations_checklists: 'Listes de contrôle',
    aumico_admin_translations_legal_forms: 'forme juridique',
    aumico_admin_translations_financial_line_items: 'Finance Post',
    aumico_admin_translations_groups: 'groupes',
    aumico_admin_translations_name_column_header: 'Nom de famille',
    aumico_reports_error_dialog_bad_request: 'Mauvaise demande',
    aumico_reports_error_dialog_bad_request_first_and_last_names_required: 'Le premier nom et le nom sont requis',
    aumico_reports_error_dialog_bad_request_phone_number_invalid:
        'Le numéro de téléphone doit avoir le bon format et ne doit pas être vide. Format correct: + <antercoce> <Tempeisund>',
    aumico_annual_report_print_preview_fcp: 'Processus de clôture financière',
    aumico_annual_report_print_preview_fas: 'Répertoire du système',
    aumico_annual_report_fas_section_costs_title: "Coûts d'acquisition et de production",
    aumico_annual_report_fas_section_depr_title: 'Amortissements',
    aumico_annual_report_fas_section_valAppr_title: 'Attributions',
    aumico_annual_report_fas_select_reference: 'Sélectionner la référence',
    aumico_annual_report_fas_remove_group: 'Supprimer le groupe',
    aumico_annual_report_fas_add_group: 'Ajouter un groupe',
    aumico_annual_report_fas_remove_column: 'Retirer la colonne',
    aumico_annual_report_fas_add_column: 'Ajouter la colonne',
    aumico_annual_report_fas_costs: 'AHK',
    aumico_annual_report_fas_additions_column: 'Accessoire',
    aumico_annual_report_fas_disposals_column: 'départs',
    aumico_annual_report_fas_transfers_column: 'transfert',
    aumico_annual_report_fas_depr_additions_column: 'Amortissements de la période',
    aumico_annual_report_fas_depr_disposals_column: 'Sorties ',
    aumico_annual_report_fas_depr_transfers_column: 'Transferts',
    aumico_annual_report_fas_depr_cumulated: 'amortissements cumulés',
    aumico_annual_report_fas_valueAppreciation: 'Attributions',
    aumico_annual_report_fas_bookvalue_current: 'Valeur comptable',
    aumico_annual_report_fas_bookvalue_previous: 'Valeur comptable',
    aumico_annual_report_fas_depreciations: 'amortissements cumulés',
    aumico_annual_report_fas_direct_assigned_accounts: 'comptes directement attribués (groupés)',
    aumico_annual_report_datev_error_detected:
        'Nous avons découvert au moins une erreur ! Veuillez corriger les erreurs ou utiliser un autre fichier.',
    aumico_annual_report_datev_error_malformatted_file: 'Fichier mal formaté',
    aumico_annual_report_datev_error_wrong_asset_data: 'Les actifs ne peuvent pas être interprétés',
    aumico_annual_report_datev_error_wrong_liabilties_data: 'Les passifs ne peuvent pas être interprétés',
    aumico_annual_report_datev_error_wrong_income_data: 'Le compte de résultat ne peut pas être interprété',
    aumico_annual_report_datev_error_root_node_empty: 'First element empty',
    aumico_annual_report_datev_master_file_detected:
        'We detected a DATEV master data import file. please click "save and continue" if you want to import the taxonomy and accounts.',
    aumico_annual_report_datev_account_file_detected:
        'We detected a DATEV account data import file. please click "save and continue" if you want to import the accounts.',
    aumico_annual_report_show_settings: 'display settings',
    aumico_annual_report_hide_settings: 'hide settings',
    aumico_annual_report_special_flis_form_title: 'Special Flis',
    aumico_annual_report_special_flis_form_intro: 'Select the financial items that serve a special function.',
    aumico_annual_report_special_flis_equity_group_label: 'Equity',
    aumico_annual_report_special_flis_profit_fli_label: 'Profit',
    aumico_annual_report_special_flis_uncoveredShortfallAssets_label: 'Uncovered Shortfall Assets',
    aumico_annual_report_special_flis_uncoveredShortfallLiabilities_label: 'Uncovered Shortfall Liabilities',
    aumico_annual_report_special_flis_field_required_error: 'selection is required',
    aumico_annual_report_special_flis_please_select: 'Please select',
    aumico_report_fas_print_subtotal: 'Total',
    aumico_report_fas_print_section_costs_title: "Coût d'acquisition et de production",
    aumico_report_fas_print_section_depr_title: 'amortissements cumulés',
    aumico_report_fas_print_section_valueApr_title: 'Réévaluations de la période',
    aumico_report_fas_print_section_bookvalue_current: 'Valeur comptable',
    aumico_report_fas_print_section_bookvalue_previous: 'Valeur comptable',
    aumico_annual_report_fas_other_column: 'Plus',
    aumico_report_fas_print_costs_additions: "Frais d'accès",
    aumico_report_fas_print_costs_disposals: 'Départ coûte',
    aumico_report_fas_print_costs_transfers: 'Frais de transfert',
    aumico_report_fas_print_depreciations_additions: 'Amortissements de la période',
    aumico_report_fas_print_depreciations_disposals: 'Dépréciation des départs',
    aumico_report_fas_print_depreciations_transfers: 'Dépréciation de transfert',
    aumico_report_fas_print_value_appreciation: 'Augmentation de valeur',
    aumico_annual_report_table_label_share_date: 'Partagé sur',
    aumico_annual_report_export_to_word: 'Export Word',
    aumico_annual_report_aop_profit_calculation_custom_account_name_placeholder: 'Entrez le nom du compte',
    aumico_annual_report_aop_profit_calculation_account_caption_form_field_label: 'Autre désignation',
    aumico_users_edit_user_general_information_name_required: 'Le prénom est requis',
    aumico_users_edit_user_general_information_surname_required: 'Le nom de famille est requis',
    aumico_users_edit_user_general_information_phone_invalid:
        "Le numéro de téléphone n'est pas valide. Il doit être dans le format de + <ländercode> <numéro de téléphone>",
    aumico_annual_report_print_options_show_balance_account_proof: 'PRÉPENCE DE CONTENCE DU bilan',
    aumico_annual_report_print_options_show_income_account_proof: 'Consommer la facture de preuve de réussite',
    aumico_annual_report_print_preview_account_proof_for_balance: 'PRÉPENCE DE CONTENCE DU bilan',
    aumico_annual_report_print_preview_account_proof_for_income: 'Consommer la facture de preuve de réussite',
    aumico_templates_group_account_mapping_add_subtotal: 'Insérer le montant',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options_label: 'Choisissez un groupe',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options: 'groupes',
    aumico_templates_group_account_mapping_add_fli: 'Poste',
    aumico_templates_fli_form_cash_flow_types: 'Type de flux de trésorerie',
    aumico_templates_fli_form_cash_flow_options_label: 'Choisissez le type de flux de trésorerie',
    aumico_templates_fli_form_fli_types: 'Type de poste',
    aumico_templates_fli_form_fli_type_options_label: 'Choisissez le type de poste',
    aumico_templates_fli_form_groups: 'Sélectionner un groupe',
    aumico_templates_fli_form_group_options_label: 'Sélectionner un groupe',
    aumico_templates_group_account_mapping_cash_flow_type_none: 'Non pertinent',
    aumico_templates_group_account_mapping_cash_flow_type_operations: 'Chirurgical',
    aumico_templates_group_account_mapping_cash_flow_type_networking_capital: 'Actifs de circulation nette',
    aumico_templates_group_account_mapping_cash_flow_type_investing: "Activité d'investissement",
    aumico_templates_group_account_mapping_cash_flow_type_financing: 'Finance',
    aumico_templates_group_account_mapping_fli_type_assets: 'Actif',
    aumico_templates_group_account_mapping_fli_type_liabilities: 'Passif',
    aumico_templates_group_account_mapping_fli_type_income: 'revenu',
    aumico_templates_group_account_mapping_fli_type_expenses: 'Frais',
    aumico_organization_settings_print_closing_value_totals_in_separate_columns:
        "Somme d'impression dans des colonnes distinctes",
    aumico_organization_settings_display_assets_and_liabilities_in_same_page:
        'Imprimer actif et responsabilités au format paysage (Allemagne)',
    aumico_organization_settings_print_success_notification_title: 'Réussi',
    aumico_organization_settings_print_success_notification_description: 'Paramètres organisationnels avec succès',
    aumico_templates_group_account_mapping_add_more_items_of_that_item_checkbox: 'Créer',
    aumico_templates_group_account_mapping_of_that_item_text: '{ de ça }',
    aumico_annual_report_fas_accounts_select_reference_placeholder: 'Sélectionner la référence',
    aumico_users_organization_upload_pdf_template_action: 'Télécharger le modèle PDF',
    aumico_users_organization_reset_to_default_template_action: 'Rétablir le modèle par défaut',
    aumico_users_organization_reset_to_default_template_action_success:
        'La réinitialisation du modèle par défaut a réussi',
    aumico_users_organization_reset_to_default_template_action_failed:
        'La réinitialisation du modèle par défaut a échoué',
    aumico_users_organization_upload_pdf_template_failure_notification_description:
        "Le modèle de rapport n'a pas pu être téléchargé",
    aumico_users_organization_upload_pdf_template_success_notification_description:
        'Le modèle rapporté a été téléchargé avec succès',
    aumico_reports_print_page_fixed_assets_schedule_invalid_warning:
        "Le miroir végétal n'est pas valide par rapport à la cartographie des données",
    aumico_reports_referral_invite_notification_failure_title: 'Invitation de référence',
    aumico_reports_referral_invite_notification_failure_description: "Le courrier de référence n'a pas pu être envoyé",
    aumico_reports_referral_invite_notification_success_title: 'Invitation de référence',
    aumico_reports_referral_invite_notification_success_description: 'Envoi du courrier de référence avec succès',
    aumico_annual_report_complementary_reports_autofill_button: "Autofill de l'année précédente",
    aumico_annual_report_complementary_reports_autofill_dialog_description:
        "Êtes-vous sûr que vous souhaitez écraser vos rapports complémentaires avec ceux de l'année précédente?",
    aumico_annual_report_complementary_reports_autofill_dialog_yes: 'Oui',
    aumico_annual_report_complementary_reports_autofill_dialoh_cancel: 'Annuler',
    aumico_admin_ar_template_navigation_settings: 'Paramètres',
    aumico_admin_ar_template_settings_title: 'Définir les paramètres',
    aumico_admin_ar_template_settings_uncovered_shortfall: 'Manque à gagner',
    aumico_organization_settings_uncoveredShortfall: 'Manque à gagner',
    aumico_templates_account_mapping_form_apply_uncovered_shortfall: 'Insérer un manque à gagner',
    aumico_templates_switch_accounts_dialog_title: "Définir les comptes d'échange",
    aumico_templates_switch_accounts_dialog_initial_situation: 'Position de départ',
    aumico_templates_switch_accounts_dialog_preview_output: 'Édition de prévisualisation',
    aumico_templates_switch_accounts_dialog_drop_account: 'Où voulez-vous attribuer le compte?',
    aumico_templates_switch_accounts_dialog_selection_label:
        'Affecter un groupe de compte ou un groupe de comptabilité',
    aumico_templates_switch_accounts_dialog_selection_placeholder:
        'Sélectionnez le groupe de compte ou le sous-groupe comptable',
    aumico_templates_switch_accounts_dialog_error_mandatory_selection:
        'Vous devez sélectionner un groupe de comptes ou de groupe comptable',
    aumico_reports_share_not_found: "La part doit avoir été retirée, expirée ou rejetée à l'avance",
    aumico_organization_settings_show_shareholder_info: 'Afficher les informations des actionnaires',
    aumico_annual_report_print_options_label_show_shareholderInformation: 'Afficher les informations des actionnaires',
    aumico_templates_group_account_mapping_create_group: 'Groupe',
    aumico_templates_group_account_mapping_create_group_form_fli_options_label: 'Sélectionner les postes financiers',
    aumico_templates_group_account_mapping_create_group_form_fli_options: 'Sélectionner les postes financiers',
    aumico_templates_group_account_mapping_create_group_form_name_label: 'Nom du groupe',
    aumico_templates_group_account_mapping_create_group_form_name: 'Nom du groupe',
    aumico_templates_group_account_mapping_create_group_form_name_required_error: 'Le nom du groupe est obligatoire',
    aumico_templates_group_account_mapping_create_group_form_name_already_exists_error: 'Le nom du groupe existe déjà',
    aumico_templates_group_account_mapping_create_group_form_total_name_required_error:
        'Le nom total du groupe est requis',
    aumico_templates_group_account_mapping_create_group_form_total_name_label: 'Groupe Total Nom',
    aumico_templates_group_account_mapping_create_group_form_total_name: 'Groupe Total Nom ',
    aumico_templates_group_account_mapping_create_group_form_button: 'sauvegarder',
    aumico_templates_group_account_mapping_there_is_an_empty_group_warning:
        'Il existe un ou plusieurs groupes vides qui ne contiennent pas de postes financiers',
    aumico_templates_fli_form_error_name_already_exists: 'Le groupe de comptes existe déjà',
    aumico_templates_mapping_engine_equity_group_not_defined_title: 'Erreur de déficit indédié',
    aumico_templates_mapping_engine_equity_group_not_defined_description:
        "L'équité n'est pas définie dans la taxonomie du bilan",
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_fli_caption: 'Manque à gagner',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_fli_caption: 'Manque à gagner',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_account_name: 'Compte du déficit découvert',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_account_name: 'Compte du déficit découvert',
    aumico_templates_form_equity_group: "Choisissez un groupe d'actions",
    aumico_templates_form_uncovered_shortfall_assets_fli:
        'Veuillez choisir le groupe de comptes actif parmi la carence découverte',
    aumico_templates_form_uncovered_shortfall_liabilities_fli:
        'Veuillez sélectionner le groupe de comptes passif dans la carence découverte',
    aumico_templates_form_add_hidden_group: 'Se regrouper',
    aumico_templates_form_create_sub_fli_or_of_that_item: 'Créer un sous-groupe de compte ou une publication',
    aumico_annual_report_import_indicate_shareholder_column: 'Spécifiez la colonne des actionnaires',
    aumico_admin_ar_template_settings_show_shareholder_information:
        'Afficher les informations sur le titulaire du shale',
    aumico_companies_form_label_tax_domicile: 'Domicile fiscal',
    aumico_companies_form_label_GICSCode: 'Industrie',
    aumico_reports_annualreport_navigation_balance_account_proof: 'PRÉPENCE DE CONTENCE DU bilan',
    aumico_reports_annualreport_navigation_income_account_proof: 'Consommer la facture de preuve de réussite',
    aumico_templates_mapping_remove_group_warning_dialog_text:
        'La suppression de ce groupe signifie que toutes les autres étapes qui utilisent ce groupe ou un élément de ce groupe sont réinitialisées. Êtes-vous sûr de les supprimer?',
    aumico_templates_mapping_remove_item_warning_dialog_cancel_button: 'Annuler',
    aumico_templates_mapping_remove_item_warning_dialog_remove_button: 'Retirer',
    aumico_templates_mapping_remove_item_warning_dialog_text:
        "La suppression de cet élément conduit à réinitialiser toutes les autres étapes qui l'utilisent. Êtes-vous sûr de vouloir le supprimer?",
    aumico_reports_accept_policy_dialog_title: 'Update CGV, protection des données, traitement des données de commande',
    aumico_reports_accept_policy_dialog_first_paragraph:
        'Le 1er septembre, la loi fédérale révisée sur la protection des données (LPD) est entrée en vigueur. Dans ce contexte, nous avons modifié notre',
    aumico_reports_accept_policy_dialog_first_paragraph_the: 'le',
    aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those: 'ainsi que les',
    aumico_reports_accept_policy_dialog_first_paragraph_adjusted: 'adaptés',
    aumico_reports_accept_policy_dialog_second_paragraph:
        "Les versions révisées sont désormais entièrement conformes à la nouvelle législation suisse sur la protection des données, ainsi qu'au règlement européen sur la protection des données (RGPD). Tu trouveras les nouvelles dispositions sous les liens ci-dessus ou sur https://aumico.io/. Les nouvelles dispositions s'appliquent avec effet rétroactif au 1er septembre 2023.",
    aumico_reports_accept_policy_dialog_third_paragraph:
        "Veuillez accepter ici nos nouvelles CGV, la politique de confidentialité, ainsi que l'accord de traitement des données de commande, afin de pouvoir continuer à utiliser aumico.",
    aumico_reports_accept_policy_dialog_privacy_policy: 'Politique de confidentialité',
    aumico_reports_accept_policy_dialog_terms_and_conditions: 'conditions générales de vente (CGV),',
    aumico_reports_accept_policy_dialog_agreement_on_data_processing:
        'Accord sur le traitement des données des commandes (TDC)',
    aumico_reports_accept_policy_to_continue_dialog_first_paragraph: 'Es-tu sûr de ne plus vouloir utiliser aumico?',
    aumico_reports_accept_policy_to_continue_dialog_second_paragraph:
        "Si tu n'acceptes pas les nouvelles dispositions, tu ne pourras plus utiliser aumico. Toutes les données de ton organisation seront supprimées dans les 30 jours.",
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph: 'Si tu as des questions, adresse-toi à',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph_contact_email: 'privacy@aumico.ch',
    aumico_reports_accept_policy_to_continue_dialog_i_agree_button: "Je suis d'accord",
    aumico_reports_accept_policy_to_continue_dialog_decline_policy_button: 'Supprimer mon compte',
    aumico_users_registration_prices: 'Prix',
    aumico_users_registration_terms_and_conditions: 'Conditions générales de vente',
    aumico_users_registration_text_between_links: "d'aumico et je déclare l'accepter. J'ai également lu et accepté les",
    aumico_users_registration_text_after_links: 'noté par aumico',
    aumico_users_registration_agreement_on_data_processing: 'Accord sur le traitement des données des commandes',
    aumico_annual_report_account_proof_display_account_number_column_header: 'compete',
    aumico_annual_report_account_proof_display_account_name_column_header: 'Désignation ',
    aumico_annual_report_print_options_show_group_headers: "Afficher l'en-tête du groupe",
    aumico_annual_report_print_options_show_group_totals: 'Afficher les totaux du groupe',
    aumico_templates_template_account_mapping_form_show_details: 'Voir les détails',
    aumico_templates_template_account_mapping_form_hide_details: 'Cacher les détails',
    aumico_annual_report_print_options_title_and_signature: 'Titre et signature',
    aumico_reports_equality_check_print_preview_hide_details: 'Cacher les détails',
    aumico_reports_equality_check_print_preview_show_details: 'Voir les détails',
    aumico_templates_group_account_mapping_menu_edit: 'Editer',
    aumico_templates_group_account_mapping_switch_account: 'Changer de compte',
    aumico_templates_group_account_mapping_add_account: 'nouveau compte',
    aumico_templates_group_account_mapping_add_sub_total: 'sous-total',
    aumico_templates_group_account_mapping_add_group: 'Groupe',
    aumico_templates_group_account_mapping_add_empty_space_above: "l'espace ci-dessus",
    aumico_templates_group_account_mapping_add_empty_space_below: "l'espace ci-dessous",
    aumico_templates_group_account_mapping_add_header_above: "l'en-tête ci-dessus",
    aumico_templates_group_account_mapping_add_header_below: "l'en-tête ci-dessous",
    aumico_users_registration_country_placeholder: 'Choisir un pays',
    aumico_users_registration_country_label: 'Lieu de votre entreprise',
    aumico_users_registration_country_required_error: 'La sélection du pays est requise ',
    aumico_users_registration_country_tool_tip_message:
        ' La sélection du pays est essentiel pour la conformité avec les règles de protection des données de votre organisation.',
    aumico_templates_group_account_mapping_fli_disable_numbering: 'Désactiver numérotation',
    aumico_templates_group_account_mapping_fli_enable_numbering: 'Ajouter numérotation',
    aumico_annual_report_print_options_show_fas: 'Tableau des immobilisations',

    aumico_annual_report_display_current_date_column_header: 'Année fiscale',
    aumico_annual_report_display_previous_date_column_header: 'Année précédente',
    aumico_annual_report_general_information_report_language: 'Langue du rapport',
    aumico_templates_account_mapping_form_transferred_surplus_account_name: 'Bénéfice transféré',
    aumico_templates_subtotal_form_subtotal_scope: 'Section',
    aumico_templates_subtotal_form_subtotal_position: 'Position après',
    aumico_templates_account_mapping_form_map_income_total_to_annual_surplus:
        "Transférer le total des recettes à l'excédent annuel",
    aumico_annual_report_special_flis_annual_surplus_fli_label: "Bénéfice net de l'exercice",
    aumico_annual_report_general_information_select_locale: 'Sélectionner la langue du rapport',
    aumico_reports_annualreport_print_label_previous_year: 'Année précédente',
    aumico_reports_annualreport_print_label_current_year: 'Année courante',
    aumico_reports_annualreport_print_label_ratio: 'Ratio',
    aumico_reports_annualreport_print_label_taxdomicile: 'Domicile fiscal',
    aumico_reports_annualreport_print_label_taxid: 'Identifiant fiscal',
    aumico_reports_annualreport_print_label_assets: 'Actif',
    aumico_reports_annualreport_print_label_liabilities: 'Passif',
    aumico_reports_annualreport_print_label_page: 'page',
    aumico_annual_report_general_information_update_company_btn_text: 'Actualiser données enterprise',
    aumico_reports_general_info_company_update_confirm: 'Actualiser',
    aumico_reports_general_info_company_update_cancel: 'Annuler',
    aumico_reports_general_info_company_update_confirmation_text:
        "Tu souhaites adapter les données de l'entreprise dans ce rapport?",
    aumico_reports_general_info_update_company_success_notification_title: 'Adaptations réussies',
    aumico_reports_general_info_update_company_success_notification_description:
        "Les informations sur l'entreprise ont été mises à jour avec succès",
    aumico_reports_company_legal_form_update_confirmation_text:
        "Tu veux mettre à jour les données de l'entreprise ? Une modification de la forme juridique aura un impact sur la structure du bilan et du compte de résultats.",
    aumico_templates_group_account_mapping_duplicate_account: 'Dupliquer le compte',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options: 'Sélection de ce poste',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options_label: 'Sélection de ce poste',
    aumico_templates_group_account_mapping_duplicate_account_form_button: 'Dupliquer le compte',
    aumico_general_information_no_template_for_your_combination: 'Pas de modèle pour votre combinaison',
    aumico_general_information_no_template_for_your_combination_content_1:
        "Désolé, nous n'avons pas trouvé de modèle pour la combinaison de forme juridique et de norme comptable. Veuillez vérifier votre sélection",
    aumico_general_information_no_template_for_your_combination_content_2:
        "Tu peux aussi nous contacter à l'adresse support@aumico.ch. Nous nous ferons un plaisir de t'aider.",
    aumico_dialog_error: 'Erreur',
    aumico_dialog_error_too_many_requests:
        "Oups ! il semble qu'il y ait eu trop de demandes en même temps. Veuillez patienter un instant et recharger la page. Nous vous remercions de votre patience.",
    aumico_notes_input_options_compare_years: 'Comparer les années',
    aumico_notes_input_options_text: 'Text',
    aumico_notes_input_options_data_type: 'Sélectionner le type de valeurs',
    aumico_notes_input_options_number_of_decimal_places: 'Nombre de chiffres après la virgule',
    aumico_notes_input_options_use_as_parameter: 'Disponible comme paramètre de rapport',
    aumico_notes_input_options_parameter_name: 'Entrer le nom du paramètre',
    aumico_notes_input_options_data_type_text: 'Text',
    aumico_notes_input_options_data_type_number: 'Nombre',
    aumico_notes_input_options_data_type_currency: 'Devise',
    aumico_reports_main_navigation_company_valuation: 'Calculer la valeur fiscale',
    aumico_reports_company_valuation_navigation_valuation_report: 'Rapport de valeur fiscale',
    aumico_reports_company_valuation_report_title: 'Calcul automatique de la valeur fiscale pour tes mandants',
    aumico_reports_company_valuation_report_descriptive_text_1:
        'Sur la base des derniers comptes annuels de tes clients.',
    aumico_reports_company_valuation_report_descriptive_text_2:
        'Reçois un calcul complet de la valeur fiscale dans les deux jours ouvrables.',
    aumico_reports_company_valuation_report_descriptive_text_3:
        'Reçois un rapport de 4 pages dans ta boîte de réception, pour 49 CHF par rapport (hors TVA)',
    aumico_reports_company_valuation_report_download_button_text: 'Télécharger un modèle de rapport',
    aumico_reports_company_valuation_report_order_button_text: 'Commander le rapport',
    aumico_reports_company_valuation_dialog_title: 'Commander rapport de valeur fiscale',
    aumico_reports_company_valuation_dialog_text:
        "Le rapport de calcul de la valeur fiscale coûte 49 CHF par rapport (hors TVA). Le rapport est reçu dans les deux jours ouvrables. En passant la commande, vous acceptez qu'aumico traite les données financières du client dans le but d'établir le rapport d'évaluation.",
    aumico_reports_company_valuation_dialog_place_order_button_text: 'Commander',
    aumico_reports_company_valuation_confirmation_dialog_content_title: 'Confirmation de commande',
    aumico_reports_company_valuation_confirmation_dialog_text:
        'Nous avons bien reçu ta commande. Tu recevras le rapport dans les deux jours ouvrables.',
    aumico_reports_company_valuation_confirmation_dialog_button_text: 'Terminé',
    aumico_reports_valuation_report_announcement_dialog_title: 'Découvrir le calcul de la valeur fiscale',
    aumico_reports_valuation_report_announcement_dialog_content_1:
        'Etablis un calcul de la valeur fiscale pour tes clients selon la méthode du praticien',
    aumico_reports_valuation_report_announcement_dialog_content_2:
        'Sélectionne le client pour lequel tu souhaites générer le rapport. Confirme ta sélection et reçois les calculs de la valeur fiscale dans les 2 jours ouvrables.',
    aumico_reports_valuation_report_announcement_dialog_content_3:
        'Offre une valeur ajoutée à tes clients et envoie-leur un calcul de la valeur fiscale avec chaque facture annuelle.',
    aumico_reports_valuation_report_announcement_dialog_button_text: 'En savoir plus',
    aumico_annual_report_main_navigation_new: 'NOUVEAU',
    aumico_reports_company_valuation_dialog_select_company: 'Sélectionner une entreprise',
    aumico_confirmation_modal_cancel_button: 'Annuler',
    aumico_confirmation_modal_delete_button: 'Supprimer',
    aumico_edit_notes_toggle: "Modifier l'annexe",
    aumico_add_notes_button: 'Nouvelle section',
    aumico_new_note_placeholder: 'Titre de la section',
    aumico_add_notes_component_button: 'Nouveau composant',
    aumico_confirmation_modal_notes_deletion:
        'Voulez-vous supprimer la note ? Il ne sera pas possible de restaurer les informations après la suppression.',
    aumico_confirmation_modal_notes_component_deletion:
        'Voulez-vous supprimer ce composant de note ? Il ne sera pas possible de restaurer les informations après la suppression.',
    aumico_notes_add_all_text: 'Ajouter tout le texte',
    aumico_add_to_notes_button: 'Ajouter',
    aumico_notes_extra_settings_title: 'Saisir le titre (facultatif)',
    aumico_notes_select_option_description: 'Description (facultatif)',
    aumico_notes_select_options: 'Options',
    aumico_notes_extra_settings_add_option: 'Add option',
    aumico_notes_extra_settings_option: 'Option',
    aumico_notes_extra_settings_options: 'Dropdown values',
    aumico_notes_simple_input: 'Simple Input',
    aumico_core_ck_editor_add_custom_style: 'Ajouter un style personnalisé',
    aumico_core_ck_editor_make_row_total: 'Faire le total de la ligne',
    aumico_core_ck_editor_make_column_total: 'Faire le total de la colonne',
    aumico_core_ck_editor_make_column_highlight: 'Mettre en évidence la colonne',
    aumico_core_ck_editor_make_column_number_column: 'Faire de la colonne une colonne de numéros',
    aumico_core_ck_editor_remove_row_style: 'Supprimer le style de la ligne',
    aumico_core_ck_editor_remove_column_style: 'Supprimer le style de la colonne',
    aumico_core_ck_editor_align_table: 'Aligner le tableau',
    aumico_core_ck_editor_align_table_left: 'Aligner le tableau à gauche',
    aumico_core_ck_editor_align_table_right: 'Aligner le tableau à droite',
    aumico_core_ck_editor_align_table_center: 'Aligner le tableau au centre',
    aumico_core_ck_editor_align_cell_horizontal: 'Aligner la cellule horizontalement',
    aumico_core_ck_editor_align_cell_horizontal_left: 'Aligner la cellule à gauche',
    aumico_core_ck_editor_align_cell_horizontal_right: 'Aligner la cellule à droite',
    aumico_core_ck_editor_align_cell_vertical: 'Aligner la cellule verticalement',
    aumico_core_ck_editor_align_cell_vertical_top: 'Aligner la cellule en haut',
    aumico_core_ck_editor_align_cell_vertical_bottom: 'Aligner la cellule en bas',
    aumico_core_ck_editor_table_column: 'Colonne',
    aumico_core_ck_editor_table_column_header_column: "Colonne d'en-tête",
    aumico_core_ck_editor_table_column_insert_column_left: 'Insérer une colonne à gauche',
    aumico_core_ck_editor_table_column_insert_column_right: 'Insérer une colonne à droite',
    aumico_core_ck_editor_table_column_delete_column: 'Supprimer la colonne',
    aumico_core_ck_editor_table_column_select_column: 'Sélectionner la colonne',
    aumico_core_ck_editor_table_row: 'Ligne',
    aumico_core_ck_editor_table_row_header_row: "Ligne d'en-tête",
    aumico_core_ck_editor_table_row_insert_row_above: 'Insérer une ligne au-dessus',
    aumico_core_ck_editor_table_row_insert_row_below: 'Insérer une ligne en dessous',
    aumico_core_ck_editor_table_row_delete_row: 'Supprimer la ligne',
    aumico_core_ck_editor_table_row_select_row: 'Sélectionner la ligne',
    aumico_core_ck_editor_table_merge_cells: 'Fusionner les cellules',
    aumico_core_ck_editor_table_merge_cells_up: 'Fusionner les cellules vers le haut',
    aumico_core_ck_editor_table_merge_cells_down: 'Fusionner les cellules vers le bas',
    aumico_core_ck_editor_table_merge_cells_right: 'Fusionner les cellules à droite',
    aumico_core_ck_editor_table_merge_cells_left: 'Fusionner les cellules à gauche',
    aumico_core_ck_editor_table_split_cell_vertically: 'Diviser la cellule verticalement',
    aumico_core_ck_editor_table_split_cell_horizontally: 'Diviser la cellule horizontalement',
    aumico_core_ck_editor_enforce_page_break: 'Forcer un saut de page',
    aumico_notes_super_table_remove_confirmation_dialog_ok: "D'ACCORD",
    aumico_notes_super_table_remove_confirmation_dialog_cancel: 'retourner',
    aumico_notes_super_table_remove_confirmation_dialog_description:
        'Vous supprimerez une colonne. Voulez-vous quand même continuer ?',
    aumico_notes_movement_schedule: 'Calendrier des mouvements',
    aumico_notes_fli_table: 'Tableau FLi',
    aumico_notes_equity_table: 'Tableau des capitaux propres',
    aumico_add_to_notes_dialog_title: 'Bibliothèque de composants de notes',
    aumico_notes_extra_settings: 'Paramètres supplémentaires',
    aumico_notes_super_table_options_title: 'Titre',
    aumico_notes_super_table_options_col_type: 'Type de colonne',
    aumico_notes_super_table_col_title: 'Titre de la colonne',
    aumico_notes_super_table_options_segment_type: 'Type de segment',
    aumico_notes_super_table_segment_title: 'Titre du segment',
    aumico_notes_super_table_options_col_type_current_year: 'Année en cours',
    aumico_notes_super_table_options_col_type_previous_year: 'Année précédente',
    aumico_notes_super_table_options_col_type_text: 'Texte',
    aumico_notes_super_table_options_col_type_number: 'Nombre',
    aumico_notes_super_table_options_segment_type_basic: 'Segment de base',
    aumico_notes_super_table_options_segment_type_total: 'Segment total',
    aumico_notes_super_table_options_col_belonging_year_current: 'Année en cours',
    aumico_notes_super_table_options_col_belonging_year_previous: 'Année précédente',
    aumico_notes_super_table_options_col_belonging_year: "Année d'appartenance",
    aumico_notes_super_table_segment_child_columns: 'Colonnes enfants',
    aumico_notes_super_table_options_define_columns: 'Définir les colonnes',
    aumico_notes_super_table_options_define_segments: 'Définir les segments',
    aumico_notes_super_table_add_row: 'Ajouter une ligne',
    aumico_notes_super_table_add_row_menu_option_select_from_balance: 'Sélectionner depuis le bilan',
    aumico_notes_super_table_add_row_menu_option_select_from_income: 'Sélectionner depuis le revenu',
    aumico_notes_super_table_add_row_menu_option_add_calculation: 'Ajouter un calcul',
    aumico_notes_super_table_add_row_menu_option_add_title_row: 'Ajouter une ligne de titre',
    aumico_notes_super_table_add_row_menu_option_add_space_row: "Ajouter une ligne d'espace",
    aumico_notes_super_table_add_row_menu_option_add_free_text_row: 'Ajouter une ligne de texte libre',
    aumico_notes_super_table_add_row_menu_option_add_rate: 'Ligne de cours',
    aumico_notes_super_table_add_rate_row_title: 'Ajouter une ligne de cours',
    aumico_notes_super_table_add_rate_select_source: 'Quel cours la ligne doit-elle afficher ?',
    aumico_notes_super_table_rate_source_closing: 'Cours de clôture',
    aumico_notes_super_table_rate_source_average: 'Cours moyen',
    aumico_notes_super_table_rate_source_position: 'Cours d\'une position',
    aumico_annual_report_fx_notes_reserve_label: 'Réserve de conversion',
    aumico_notes_fli_currency_chip_tooltip: 'Change les colonnes de devises de ce tableau : monnaie fonctionnelle → les deux → monnaie de présentation',
    aumico_annual_report_print_options_fx_accordion_title: 'Monnaie fonctionnelle',
    aumico_annual_report_print_options_fx_show_statement_display_columns: 'Bilan et compte de résultat dans les deux monnaies',
    aumico_notes_super_table_add_row_menu_option_add_text_row: 'Ajouter une ligne de texte',
    aumico_notes_super_table_add_row_menu_option_create_segments: 'Créer des segments',
    aumico_notes_super_table_current_value_placeholder: "Entrer la valeur de l'année en cours",
    aumico_notes_super_table_previous_value_placeholder: "Entrer la valeur de l'année précédente",
    aumico_notes_super_table_numeric_value_placeholder: 'Entrer un nombre',
    aumico_notes_super_table_text_value_placeholder: 'Entrer du texte',
    aumico_notes_super_table_data_selection_title: 'Ajouter une ligne',
    aumico_notes_super_table_data_selection_label:
        'Veuillez sélectionner un ou plusieurs éléments pour une nouvelle ligne :',
    aumico_notes_super_table_create_segment_title: 'Créer un segment',
    aumico_notes_super_table_create_segment_select_columns_placeholder: 'Sélectionner les colonnes',
    aumico_notes_super_table_create_segment_save_button: 'Ajouter un segment',
    aumico_notes_super_table_add_calculation_row_title: 'Ajouter une ligne de calcul',
    aumico_notes_super_table_add_calculation_column_title: 'Ajouter une colonne de calcul',
    aumico_notes_super_table_add_caclulation_select_calculation_type: 'Sélectionner le type de calcul',
    aumico_notes_super_table_add_calculation_function_summation: 'Somme des éléments',
    aumico_notes_super_table_add_calculation_function_ratio: 'Ratio',
    aumico_notes_super_table_add_calculation_function_subtraction: 'Soustraction',
    aumico_notes_super_table_add_calculation_function_multiplication: 'Multiplication',
    aumico_notes_super_table_add_calculation_title_placeholder: 'Entrer le titre du calcul',
    aumico_notes_super_table_add_calculation_button: 'Ajouter un calcul',
    aumico_notes_super_table_add_calculation_select_relation_item_placeholder: 'En relation avec',
    aumico_notes_super_table_add_calculation_select_column_placeholder: 'Sélectionner les colonnes',
    aumico_notes_super_table_add_calculation_select_column_placeholder_SUM: 'Sélectionner les colonnes à additionner',
    aumico_notes_super_table_add_calculation_select_column_placeholder_MUL: 'Sélectionner les colonnes à multiplier',
    aumico_notes_super_table_add_calculation_select_column_placeholder_RATIO: 'Sélectionner les colonnes pour le ratio',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_SUM: 'Sélectionner les lignes à additionner',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_MUL: 'Sélectionner les lignes à multiplier',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_RATIO: 'Sélectionner les lignes pour le ratio',
    aumico_notes_super_table_add_calculation_minuend_placeholder: "Sélectionner l'élément X",
    aumico_notes_super_table_add_calculation_subtrahend_placeholder: "Sélectionner l'élément Y",
    aumico_notes_super_table_add_column: 'Ajouter une colonne',
    aumico_notes_super_table_add_column_menu_option_add_calculation: 'Ajouter une colonne de calcul',
    aumico_notes_super_table_add_column_menu_option_add_column: 'Ajouter une colonne libre',
    aumico_notes_super_table_add_free_column_title_placeholder: 'Entrer le titre de la colonne',
    aumico_notes_super_table_add_free_column_col_type: 'Format des valeurs de la colonne',
    aumico_notes_super_table_add_free_column_belonging_year: "La colonne appartient à l'année",
    aumico_notes_super_table_add_free_column_save_button: 'Ajouter une colonne',
    aumico_notes_super_table_select_income_or_balance: "Veuillez choisir d'où proviennent les données:",
    aumico_notes_components_list_reset_values_from_mapping: 'Actualiser les valeurs',
    aumico_notes_super_table: 'Super tableau',
    aumico_notes_select_options_min_options: 'Veuillez sélectionner au moins deux options.',
    aumico_notes_super_table_options_transpose: 'Transposer 90',
    aumico_notes_super_table_options_col_belonging_year_none: 'Aucun',
    aumico_notes_super_table_add_free_column_edit_button: 'Modifier la colonne',
    aumico_notes_super_table_turning_on_transpose_toggle_not_allowed:
        "Le nombre maximum de lignes autorisées pour la vue transposée est de 7 lignes. Impossible d'activer le basculement de transposition.",
    aumico_notes_super_table_turning_off_transpose_toggle_not_allowed:
        'Le nombre maximum de colonnes autorisées pour la vue non transposée est de 7 colonnes. Impossible de désactiver le basculement de transposition.',
    aumico_print_preview_rename_section_title_dialog_title: 'Renommer le titre de la section',
    aumico_print_preview_rename_section_title_dialog_input_field_placeholder: 'Saisir le titre de la section',
    aumico_print_preview_rename_section_title_dialog_input_field_title: 'Titre de la section',
    aumico_reports_main_navigation_company_profile: "Profil d'entreprise",
    aumico_reports_main_navigation_person_list: 'Personnes',
    aumico_reports_export_all_persons_file_name: 'toutes les personnes',
    aumico_reports_main_navigation_person_new: 'Nouvelle personne',
    aumico_reports_main_navigation_person_profile: 'Profil',
    aumico_users_registration_password_lower_case_criteria_message: 'Au moins un caractère minuscule',
    aumico_users_registration_password_upper_case_criteria_message: 'Au moins un caractère majuscule',
    aumico_users_registration_password_digits_criteria_message: 'Au moins un chiffre',
    aumico_users_registration_password_special_char_criteria_message: 'Au moins un caractère spécial',
    aumico_users_registration_password_min_chars_criteria_message: 'Au moins 8 caractères',
    aumico_admin_ar_template_general_information_caption: 'Description',
    aumico_report_save_success_notification_description: 'Sauvegarde réussie',
    aumico_report_save_failure_notification_description: 'Échec de la sauvegarde',
    aumico_add_referencing_in_balance_and_income_btn: 'Ajouter des références',
    aumico_add_numbering_toggle: 'Ajouter une numérotation',
    aumico_view_notes_components_in_edit_mode_toggle: 'Afficher les sections en mode édition',
    aumico_annual_report_save_error_not_loaded: "Les données du rapport n'ont pas encore été chargées. Veuillez patienter un moment et réessayer.",
    aumico_notes_title: 'Titre',
    aumico_notes_referencing_title: 'Ajouter des références',
    aumico_notes_referencing_sub_title: 'Sélection multiple possible',
    aumico_notes_referencing_add_referencing: 'Ajouter des références',
    aumico_admin_translations_ar_templates: 'Modèles de rapports annuels',
    aumico_annual_report_fas_unmapped_uploaded_accounts_warning: 'Les comptes suivants téléchargés ne sont pas mappés',
    aumico_annual_report_fas_invalid_file_format_warning_text: "Le fichier téléchargé n'a pas le bon format",
    aumico_annual_report_complementary_reports_show_in_toc_toggle: 'Afficher le rapport dans la table des matières',
    aumico_annual_report_complementary_reports_at_the_start: 'AVANT les comptes annuels',
    aumico_annual_report_complementary_reports_at_the_end: 'APRÈS les comptes annuels',
    aumico_annual_report_complementary_reports_as_appendix: 'En annexe aux comptes annuels',
    aumico_annual_report_print_preview_appendix_section_title: 'Annexe',
    aumico_view_notes_components_highlight_todos_toggle: 'Mise en évidence',
    aumico_copy_notes_structure_from_another_annual_report: "Copier l'annexe",
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_description:
        "Toutes les notes créées sont ainsi remplacées. L'opération ne peut pas être annulée. Tu souhaites poursuivre le processus ?",
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_button: 'Oui',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_inclusive_data_button:
        'Oui, y compris les données',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_cancel_button: 'Annuler',
    aumico_notes_copy_notes_structure_fetch_error: 'Les notes n\'ont pas pu être récupérées depuis ce rapport.',
    aumico_users_organization_upload_or_pdf_template_action: 'Télécharger ou modèle PDF',
    aumico_users_organization_upload_hgb_pdf_template_action: 'Télécharger le modèle PDF HGB',
    aumico_users_organization_reset_to_default_or_template_action: 'Réinitialiser ou utiliser le modèle par défaut',
    aumico_users_organization_reset_to_default_hgb_template_action: 'Réinitialiser le modèle HGB par défaut',
    aumico_reports_organization_settings_navigation_checklists: 'Listes de contrôle',
    aumico_admin_menu_item_change_fcp: "Changer l'abonnement PCF",
    aumico_admin_menu_item_deactivate_fcp: 'Désactiver le processus de clôture',
    aumico_admin_change_fcpstate_select_fcp_status: 'Statut PCF',
    aumico_admin_change_fcp_statefcp_status: 'Changer le statut',
    aumico_admin_change_fcpstate_cancel: 'Annuler',
    aumico_admin_change_fcpstate_confirm: 'Confirmer',
    aumico_reports_main_navigation_closing_process_enabling: 'Processus de clôture',
    aumico_reports_closing_process_request_approval: 'Inscrivez-vous pour la bêta',
    aumico_reports_closing_process_waiting_for_approval: 'Approbation de la bêta en cours',
    aumico_reports_closing_process_cancel: "Annuler l'abonnement",

    aumico_reports_closing_process_benefits: 'Avantages .....',
    aumico_reports_closing_process_pricing: 'Tarification .....',
    aumico_reports_closing_process_terms_and_conditions: 'Termes et conditions .....',
    aumico_confirmation_modal_activate_button: 'Activer',
    aumico_confirmation_modal_cancel_subscription_button: "Annuler l'abonnement",
    aumico_confirmation_modal_activate_subscription_description:
        'En cliquant sur "Activer", vous lancez un essai gratuit de 31 jours. Pendant cette période, vous aurez un accès complet à la fonctionnalité de processus de clôture. L\'essai sera automatiquement renouvelé à la fin de la période !',
    aumico_reports_closing_process_deactivate: 'Désactiver',
    aumico_reports_cant_activate_fcp:
        "Vous ne pouvez pas activer l'essai PCF car vous êtes déjà abonné. Pour un abonnement annuel, contactez les ventes d'aumico à sales@aumico.ch",
    aumico_reports_cant_activate_fcp_ok: 'Ok',

    aumico_reports_create_new_checklist: 'Créer une nouvelle liste de contrôle',
    aumico_reports_checklist_title_label: 'Titre',
    aumico_reports_checklist_title_placeholder: 'Entrez le titre de la liste de contrôle...',
    aumico_reports_select_flis_label: 'Sélectionnez les FLIs',
    aumico_reports_enter_task_placeholder: 'entrez une tâche',
    aumico_reports_add_more_tasks_button: 'Ajouter plus de tâches',
    aumico_reports_cancel_button: 'Annuler',
    aumico_reports_save_checklist_button: 'Enregistrer la liste de contrôle',
    aumico_admin_user_notification_success_description: 'Données enregistrées avec succès',
    aumico_reports_checklist_title: 'Liste de contrôle',
    aumico_reports_checklist_content:
        'Voici les listes de contrôle pour vos FLIs. Elles vous aideront à suivre le processus et à vous assurer de ne rien oublier.',
    aumico_reports_comments_title: 'Commentaires',
    aumico_reports_comments_content:
        'Ici, vous pouvez ajouter des commentaires pour les comptes. Vous pouvez les utiliser comme notes personnelles ou pour vos collaborateurs.',
    aumico_reports_docs_title: 'Documents',
    aumico_reports_docs_content:
        'Les documents seront disponibles ici. Vous pouvez télécharger et téléverser des documents pour les comptes.',
    aumico_reports_no_checklist_message: 'Nous n’avons trouvé aucune liste de contrôle pour ce FLI.',
    aumico_reports_create_checklist_button: 'Créer une nouvelle liste de contrôle',
    aumico_reports_or_text: 'ou',
    aumico_reports_import_checklist_button: 'Importer une liste de contrôle',

    aumico_reports_last_year: "L'année dernière",
    aumico_reports_this_year: 'Cette année',
    aumico_reports_select_checklist: 'Sélectionnez une liste de contrôle',
    aumico_reports_import_checklist: 'Importer une liste de contrôle',
    aumico_reports_custom_checklist_creation_text:
        "Vous pouvez également {{linkText}} dans les paramètres de l'organisation.",
    aumico_reports_custom_checklist_creation_link_text: 'créer vos propres listes de contrôle',
    aumico_reports_closing_entries_title: 'Écritures de clôture',
    aumico_reports_closing_entries_content: 'Veuillez sélectionner une écriture de clôture.',
    aumico_checklist_management_table_checklist_name: 'Nom',
    aumico_checklist_management_table_checklist_created_at: 'Créé le',
    aumico_checklist_management_table_checklist_last_change: 'Dernière modification',
    aumico_checklist_management_table_checklist_modified_by: 'Modifié par',
    aumico_reports_annualreport_print_with_legacy_service: 'Imprimer avec le service classique',

    aumico_reports_fcp_enable_title: 'Activer le processus de clôture financière',
    aumico_reports_fcp_enable_subtitle: 'Accédez pleinement au processus de clôture à un tarif annuel compétitif.',
    aumico_reports_fcp_teaser_1_title: 'Automatisez vos clôtures financières',
    aumico_reports_fcp_teaser_1_text: 'Planifiez, créez, lancez. Collaborez sans effort avec votre organisation.',
    aumico_reports_fcp_teaser_2_title: 'Réduisez les erreurs manuelles',
    aumico_reports_fcp_teaser_2_text:
        'Protégez votre organisation et restez conforme grâce à des flux de travail structurés.',
    aumico_reports_fcp_teaser_3_title: 'Assurez la conformité aux normes comptables',
    aumico_reports_fcp_teaser_3_text: 'Attribuez automatiquement les tâches et utilisez des centaines de modèles.',
    aumico_reports_fcp_beta_terms_title: 'Informations sur la bêta',
    aumico_reports_fcp_trial_terms_1: 'Essai gratuit de 30 jours',
    aumico_reports_fcp_trial_terms_2: 'Se transforme automatiquement en contrat annuel si non annulé',
    aumico_reports_fcp_trial_terms_3: "Annulez à tout moment pendant la période d'essai",
    aumico_reports_fcp_trial_info_title: "Informations sur l'essai",
    aumico_reports_fcp_trial_info_text: "Il vous reste {{x}} jours dans votre période d'essai.",
    aumico_reports_fcp_subscription_info_title: "Informations sur l'abonnement",
    aumico_reports_fcp_subscription_info_text: "Il vous reste {{x}} jours dans votre période d'abonnement.",
    aumico_reports_fcp_trial_deactivation_title: 'Nous aimerions avoir votre avis',
    aumico_reports_fcp_trial_deactivation_text: "Veuillez nous indiquer pourquoi vous arrêtez l'essai...",
    aumico_reports_fcp_subscription_deactivation_title: 'Nous aimerions avoir votre avis',
    aumico_reports_fcp_subscription_deactivation_text: "Veuillez nous indiquer pourquoi vous arrêtez l'abonnement...",
    aumico_reports_fcp_deactivation_placeholder: 'Écrivez votre retour ici...',
    aumico_reports_fcp_deactivation_feedback_button: 'Envoyer le retour et désactiver',
    aumico_reports_fcp_deactivation_confirmation_question_text:
        'Êtes-vous sûr de vouloir désactiver le processus de clôture ?',
    aumico_reports_fcp_deactivation_terms: 'Remarque :',
    aumico_reports_fcp_deactivation_term_data_storage: "Les données produites pendant l'activation seront perdues.",
    aumico_reports_fcp_deactivation_term_end_date: 'La fonctionnalité sera terminée le {{date}}',
    aumico_reports_fcp_deactivation_term_costs: 'Aucun frais ne sera facturé.',
    aumico_reports_add_a_new_comment_placeholder: 'Ajouter un nouveau commentaire',
    aumico_reports_add_new_comments_button: 'Ajouter',
    aumico_reports_add_edit_comments_button: 'Modifier',
    aumico_reports_mark_comment_as: 'Marquer comme :',
    aumico_reports_comments_section_description:
        'Ici, vous pouvez ajouter des commentaires pour les comptes. Vous pouvez les utiliser comme notes personnelles ou pour vos collaborateurs.',
    aumico_reports_mark_as_internal_comment: 'Marquer comme interne',
    aumico_reports_mark_as_external_comment: 'Marquer comme externe',
    aumico_reports_mark_as_review_comment: 'Marquer pour révision',
    aumico_reports_mark_comment_as_pendency: 'Pendance',
    aumico_reports_copy_comment: 'Copier',
    aumico_reports_delete_comment: 'Supprimer',
    aumico_reports_is_internal_comment: 'Interne',
    aumico_reports_is_external_comment: 'Externe',
    aumico_reports_is_pendancy_comment: 'Pendance',
    aumico_reports_is_review_comment: 'Révision',

    aumico_reports_fcp_file_virused_error_message: 'Le fichier téléchargé est infecté par un virus',
    aumico_reports_fcp_file_uploaded_success_message: 'Fichier téléchargé avec succès',
    aumico_reports_browse_files: 'Parcourir les fichiers',
    aumico_reports_fcp_edit_checklist: 'Modifier la liste de contrôle',

    aumico_reports_fcp_tree_adjustment_col_header: 'Ajustement',
    aumico_reports_fcp_tree_current_year_col_header: 'Année en cours',
    aumico_reports_fcp_tree_previous_year_col_header: 'Année précédente',
    aumico_reports_notes_search_reports: 'Rechercher',
    aumico_reports_finalize_and_continue_button: 'Finaliser et continuer',
    aumico_reports_preview_button_text: 'Aperçu',
    aumico_reports_export_button_text: 'Exporter',
    aumico_reports_export_unlabeled_comment: 'Inclure les commentaires sans étiquette',
    aumico_reports_export_internal_comment: 'Inclure les commentaires internes',
    aumico_reports_export_external_comment: 'Inclure les commentaires externes',
    aumico_reports_export_review_comment: 'Inclure les commentaires en attente de révision',
    aumico_reports_export_pendency: 'Inclure les dépendances',
    aumico_reports_export_excel: 'Excel',
    aumico_reports_export_closing: 'Inclure les clôtures',
    aumico_reports_closing_process_balance_navigation_tab: 'Balance',
    aumico_reports_closing_process_income_navigation_tab: 'Revenus',
    aumico_reports_fcp_save_checklist_button: 'Enregistrer la liste de contrôle',
    aumico_reports_fcp_closing_edit_entry: 'Modifier',
    aumico_reports_fcp_closing_delete_entry: 'Supprimer',
    aumico_reports_fcp_closing_add_entry: 'Ajouter une entrée',
    aumico_reports_fcp_closing_save_entry: 'Enregistrer',
    aumico_reports_fcp_closing_enter_amount: 'Saisir le montant',
    aumico_reports_fcp_closing_add_new_amount: 'Ajouter un nouveau montant',
    aumico_reports_fcp_closing_select_debit: 'Sélectionner un débit',
    aumico_reports_fcp_closing_add_new_debit: 'Ajouter un nouveau débit',
    aumico_reports_fcp_closing_select_credit: 'Sélectionner un crédit',
    aumico_reports_fcp_closing_add_new_credit: 'Ajouter un nouveau crédit',
    aumico_reports_fcp_closing_add_details: 'Ajouter des détails',
    aumico_reports_fcp_closing_details: 'Détails',
    aumico_reports_fcp_closing_add_new_text: 'Ajouter un nouveau texte',
    aumico_reports_fcp_closing_no_closing_entries_last_year:
        "Il n'y a pas d'écritures de clôture pour ce compte l'année dernière.",
    aumico_reports_fcp_closing_amount: 'Montant',
    aumico_reports_fcp_closing_debit: 'Débit',
    aumico_reports_fcp_closing_credit: 'Crédit',
    aumico_reports_fcp_closing_done: 'Terminé',
    aumico_reports_fcp_no_items: 'Aucun élément',
    aumico_reports_fcp_unknown_state: 'ÉTAT INCONNU',
    aumico_reports_fcp_search_placeholder: 'Rechercher',

    aumico_reports_fcp_closing_process_checklist_mark_all_as_done: 'Marquer tout comme terminé',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_confirm: 'Oui',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_cancel: 'Non',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_dont_show_again:
        'Ne plus afficher cette fenêtre contextuelle',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_text:
        'Souhaitez-vous terminer la tâche pour tous les comptes ?',

    aumico_reports_fcp_closing_process_checklist_delete_checklist:
        'Êtes-vous sûr de vouloir supprimer cette liste de contrôle ?',
    aumico_reports_confirm_delete: 'Oui, je suis sûr',
    aumico_reports_cancel_delete: 'Non, annuler',
    aumico_support_nav_item: 'Support',
    aumico_annual_report_mapping_load_fli_cfs_settings_warning:
        'Appuyez sur le bouton "Recharger les paramètres CFS" si, lors de l\'édition des FLIs, le type de flux de trésorerie est manquant. En utilisant cette fonction, les types de flux de trésorerie de tous les FLIs seront rechargés depuis les paramètres. Tout type de flux de trésorerie que vous avez ajouté vous-même devra être saisi à nouveau. Ceci est une solution temporaire !',
    aumico_annual_report_mapping_load_fli_cfs_settings_button: 'Recharger les paramètres CFS',
    aumico_annual_report_mapping_load_fli_cfs_settings_dialog_content:
        'Cette action ne peut pas être annulée après enregistrement. Veuillez vérifier attentivement les types de flux de trésorerie de chaque FLI après avoir utilisé cette fonction.',

    aumico_annual_report_fcp_checklist_not_allow_duplicate: 'Les tâches dupliquées ne sont pas autorisées !',
    aumico_reports_just_now: "à l'instant",

    aumico_reports_fcp_uploading: 'Téléchargement en cours',
    aumico_reports_fcp_uploaded: 'Téléchargé',
    aumico_reports_hours_of_uploading: 'il y a {{diffInHours}} heures',
    aumico_reports_hour_of_uploading: 'il y a {{diffInHours}} heure',
    aumico_reports_days_of_uploading: 'il y a {{diffInDays}} jours',
    aumico_reports_day_of_uploading: 'il y a {{diffInDays}} jour',
    aumico_reports_fcp_file_is_virused_warning_popup:
        'Le fichier que vous avez téléchargé est infecté par un virus et ne peut pas être traité.',

    aumico_add_new_notes_accordion_section_title: 'Ajouter une section',
    aumico_add_new_notes_accordion_section_note_title: 'Saisir le titre ici',
    aumico_add_new_notes_accordion_section_note_title_input_placeholder: 'entrer le texte ici',
    aumico_add_new_notes_accordion_section_select_note_component_to_add: 'Sélectionner un composant',
    aumico_add_new_notes_accordion_section_add_numbering_toggle: 'Ajouter une numérotation',
    aumico_add_new_notes_accordion_section_add_numbering_toggle_description: 'Numérotation automatique',
    aumico_add_new_notes_accordion_section_button: 'Ajouter',
    aumico_add_new_notes_component_title: 'Ajouter un nouveau composant',
    aumico_add_new_notes_component_button: 'Ajouter',
    aumico_add_new_notes_component_add_numbering_toggle: 'Ajouter une numérotation',
    aumico_add_new_notes_component_add_numbering_toggle_description: 'Numérotation automatique',
    aumico_reports_fcp_file_allowed_files: 'Veuillez télécharger un fichier .xlsx, .xls ou .pdf',
    aumico_reports_fcp_file_uploaded_by: 'Par',
    aumico_reports_drag_files: 'Glissez les fichiers ici pour les télécharger',
    aumico_annual_report_aop_description: 'AOP Description',
    aumico_annual_report_investing_activities: 'Investition',
    aumico_annual_report_financing_activities: 'Financement',
    aumico_annual_report_cash_flow_networking_capital: 'Actif circulant net',
    aumico_annual_report_cash_flow_operating_activities: 'Cash-flow opérationnel',
    aumico_annual_report_cash_flow_manual: 'Saisie manuelle',
    aumico_annual_report_delete_item_confirmation_text: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    aumico_annual_report_cashflow_difference_text: 'Contrôle de la différence',
    aumico_annual_report_cashflow_difference_should_be_zero_text: 'Doit être égal à 0',

    aumico_reports_side_bar_organization_name: "Nom de l'organisation",
    aumico_reports_side_bar_help: 'Assistance',
    aumico_core_ham_referencing_input_placeholder: 'Titre',
    aumico_notes_components_list_actions_break_page: 'Saut de page',
    aumico_notes_components_list_actions_compare_years: "Afficher l'année de comparaison",
    aumico_notes_components_list_actions_settings: 'Paramètres',
    aumico_notes_components_list_actions_add: 'Ajouter',
    aumico_notes_components_list_actions_show_previous_year: "Annoncer l'année précédente",
    aumico_notes_components_list_actions_transpose: 'tourner 90 degrés',
    aumico_notes_components_list_actions_flip_signs: 'Changer le signe',
    aumico_notes_components_list_actions_show_total: 'Afficher le total',
    aumico_text_snippets_table_search_placeholder: 'Rechercher',
    aumico_reports_organization_settings_users_add_new_button: 'Ajouter',
    aumico_reports_organization_settings_checklist_add_new_button: 'Ajouter',
    admin_create_licence_package_title: 'Créer un paquet de licences',
    admin_create_licence_package_type: 'Package Type',
    admin_create_licence_package_type_required: 'Le type de paquet est requis.',
    admin_create_licence_package_size: 'Taille du paquet',
    admin_create_licence_package_size_required: 'La taille du paquet est requise.',
    admin_create_licence_package_size_min: "La taille du paquet doit être d'au moins {{min}}.",
    admin_create_licence_package_start_date: 'Date de début',
    admin_create_licence_package_start_date_required: 'La date de début est requise.',
    admin_create_licence_package_end_date: 'End Date',
    admin_create_licence_package_end_date_required: 'La date de fin est requise.',
    admin_create_licence_package_end_date_invalid: 'La date de fin doit être postérieure à la date de début.',
    admin_create_licence_package_description: 'Description',
    admin_create_licence_package_price: 'Prix',
    admin_create_licence_package_price_min: 'Le prix doit être au moins {{min}}.',
    admin_create_licence_package_discount_amount: 'Montant de la remise',
    admin_create_licence_package_discount_amount_min: 'Le montant de la remise doit être au moins égal à {{min}}.',
    admin_create_licence_package_discount_percent: "Pourcentage d'actualisation",
    admin_create_licence_package_discount_percent_min:
        'Le pourcentage de réduction doit être au moins égal à {{min}}%.',
    admin_create_licence_package_discount_percent_max: 'Le pourcentage de remise ne peut pas dépasser {{max}}%.',
    admin_create_licence_package_cancel: 'Annuler',
    admin_create_licence_package_confirm: 'Confirmer',
    aumico_annual_report_cashflow_unsaved_changes:
        "Des modifications non enregistrées ont été détectées. Les données d'impression ne seront pas mises à jour tant que vous n'aurez pas confirmé et enregistré vos modifications.",
    aumico_annual_report_cash_flow_investing_add_row: 'Ajouter une ligne',
    aumico_reports_tooltip_text_verify_data:
        'Les valeurs ont été mises à jour. Veuillez vérifier si le flux de trésorerie est toujours correct.',
    aumico_reports_tooltip_text_verify_fcp_data:
        'Les valeurs ont été mises à jour. Processus de clôture financière si le flux de trésorerie est toujours correct.',
    aumico_reports_aop_account_caption: 'Caption',
    aumico_annual_report_print_options_label_non_breaking_hyphen_toggle: 'Qualité réduite',
    aumico_annual_report_print_options_repeat_appendix_title: 'Répéter le titre de l\'annexe sur chaque page',
    aumico_annual_report_print_options_round_to_thousands: 'Arrondir les valeurs en milliers',
    aumico_templates_mapping_remove_account_will_change_previous_year_values_warning:
        "Veuillez noter que la suppression d'un compte modifiera la valeur de l'année précédente.",
    aumico_companies_form_assigned_users: 'Manager de mandat',
    aumico_companies_form_assigned_on: 'Attribué le',

    aumico_admin_organization_list_package_type: 'Type',
    aumico_admin_organization_list_package_start_date: 'Date de début',
    aumico_admin_organization_list_package_end_date: 'Date de fin',
    aumico_admin_organization_list_package_size: 'Taille',
    aumico_admin_organization_list_actions: 'Actions',
    aumico_admin_organization_list_add_package: 'Ajouter un paquet',
    aumico_admin_organization_list_package_delete: 'Supprimer',
    aumico_admin_organization_list_package_edit: 'Editer',
    aumico_admin_delete_package_confirmation_dialog_description: 'Êtes-vous sûr de vouloir supprimer ce paquet ?',
    aumico_admin_organization_abcp_needs_cpmm: 'Nécessite CPMM',
    aumico_admin_organization_abcp_update_failed: 'Impossible de changer ABCP.',
    aumico_users_organization_users_table_date_added_label: 'Ajouté le',
    aumico_users_organization_users_table_status_label: 'Status',
    aumico_users_organization_users_table_pending_label: 'En attente',
    aumico_users_organization_users_table_active_label: 'Actif',
    aumico_users_organization_users_table_resend_invite: "Renvoyer l'invitation",
    aumico_users_organization_users_table_withdraw_invite_action: 'Retirer',
    aumico_users_organization_users_table_resend_invite_action: 'Renvoyer',
    aumico_users_organization_users_table_withdraw_invite_modal_title: "Retirer l'invitation ?",
    aumico_users_organization_users_table_resend_invite_modal_title: "Renvoyer l'invitation?",
    aumico_users_organization_users_table_withdraw_invite_modal_body:
        "Êtes-vous sûr de vouloir retirer cette invitation ? L'utilisateur ne pourra plus rejoindre la plateforme s'il n'est pas réinvité.",
    aumico_users_organization_users_table_resend_invite_modal_body:
        'Êtes-vous sûr de vouloir renvoyer cette invitation ?',
    aumico_users_organization_users_table_invite_modal_body:
        "Les utilisateurs invités ont accès à toutes les données de l'organisation",
    aumico_companies_details_text: 'Détails de la société',
    aumico_companies_mandate_text: 'Mandat',
    aumico_annual_report_cash_flow_investing_add_new_section: 'Ajouter une nouvelle section',
    aumico_reports_design_settings_example_subtitle: '1.1 Exemple de sous-titre',
    aumico_reports_design_settings_example_title: '1. Exemple de titre',
    aumico_reports_design_settings_example_title_row: '1.1.1 Exemple de titre de tableau',
    aumico_annual_report_print_options_show_notes_in_detail_in_toc: 'Registre détaillé',
    aumico_components_ham_styling_menu_align_left: 'aligner à gauche',
    aumico_components_ham_styling_menu_align_center: 'aligner le centre',
    aumico_components_ham_styling_menu_align_right: 'aligner à droite',
    aumico_components_ham_styling_menu_bold: 'gras',
    aumico_components_ham_styling_menu_underlined: 'souligné',
    aumico_components_ham_styling_menu_italic: 'italique',
    aumico_components_ham_styling_menu_percentage: 'pourcentage',
    aumico_components_ham_styling_menu_less_decimals: 'diminuer les décimales',
    aumico_components_ham_styling_menu_more_decimals: 'augmenter les décimales',
    aumico_components_ham_styling_menu_flip_sign:
        "le signe de bascule n'affecte que la valeur affichée et non la valeur réelle",
    aumico_reports_organization_delete_user: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
    aumico_reports_organization_delete: 'Supprimer',
    aumico_reports_companies_upload_logo: 'Télécharger le logo',
    aumico_reports_companies_upload_logo_description:
        "Le logo téléchargé apparaîtra dans le profil de l'entreprise et pourra éventuellement être inclus dans les documents imprimés.",

    aumico_reports_companies_upload_file_upload_image_info: 'Télécharger un logo PNG',
    aumico_reports_companies_upload_file_upload_image_size: '(Maximum 5MB, 100x100px)',
    aumico_annual_report_print_options_advanced_title: 'Avancé',
    aumico_annual_report_print_options_components_accordion_title: 'Composants',
    aumico_annual_report_print_options_settings_accordion_title: 'Réglages',
    aumico_annual_report_print_options_signature_accordion_title: 'Signature',
    aumico_annual_report_print_options_financial_statement_components_title: 'Bilan & compte de résultat',
    aumico_annual_report_print_options_cash_flow_component_title: 'Tableau des flux de trésorerie',
    aumico_annual_report_print_options_notes_component_title: 'Annexe',
    aumico_annual_report_print_options_aop_component_title: 'Affectation du bénéfice',
    aumico_annual_report_print_options_place_signature_after_income_statement:
        'Apposer la signature après le compte de résultat',
    aumico_annual_report_file_size_error: 'Taille du fichier supérieure à 5MB',
    aumico_cover_page_internal_label: 'Interne',
    aumico_annual_report_select_autofill_options: 'Sélectionne les éléments à copier dans ce modèle',
    aumico_annual_report_autofill_options_taxonamy: 'Taxinomie',
    aumico_annual_report_autofill_options_cfs: 'Tableau des flux de trésorerie',
    aumico_annual_report_autofill_options_notes: 'Annexe',
    aumico_annual_report_autofill_options_aop: 'Affectation du bénéfice',
    aumico_annual_report_print_options_general_accordion_title: 'Général',
    aumico_notes_super_table_row_settings: 'Réglages des lignes',
    aumico_notes_super_table_reconcile: 'Réconcilier la valeur',
    aumico_notes_super_table_reconcile_dialog_description: 'Sélectionner un élément à réconcilier',
    aumico_notes_super_table_mapping_row_settings_description:
        'Veuillez sélectionner un ou plusieurs éléments pour une nouvelle ligne',
    aumico_notes_super_table_mapping_row_settings_row_title: 'Titre de la ligne',
    aumico_notes_super_table_delete_column_confirmation_text: 'Êtes-vous sûr de vouloir supprimer cette colonne?',
    aumico_notes_super_table_delete_row_confirmation_text: 'Êtes-vous sûr de vouloir supprimer cette ligne ?',
    aumico_notes_super_table_add_calculation_next: 'Continuer',
    aumico_notes_super_table_add_calculation_cancel: 'Retour',
    aumico_notes_super_table_segmented_columns: 'Sélectionner les colonnes à segmenter',
    aumico_notes_super_table_select_columns: 'Sélectionner les colonnes',
    aumico_admin_ar_template_list_reporting_template_name: 'Nom du modèle Pdf',
    aumico_admin_ar_template_reset_pdf_template_to_default_button: 'Réinitialiser le modèle par défaut ',
    aumico_admin_ar_template_uploaded_pdf_template_name: 'Nom du modèle pdf téléchargé',
    aumico_admin_ar_template_no_custom_pdf_template_uploaded: "Aucun modèle personnalisé n'a été téléchargé",
    aumico_notes_super_table_select_from_here: 'Sélectionnez ici',
    aumico_notes_super_table_edit_column: 'Editer la colonne',
    aumico_notes_super_table_select_summation_columns_label: 'Sélectionner les colonnes à additionner',
    aumico_notes_super_table_select_subtraction_column_mineund: 'Minuend',
    aumico_notes_super_table_select_subtraction_column_subtrahend: 'Soustrayant ',
    aumico_notes_super_table_select_multiplication_columns_label: 'Sélectionner les colonnes à multiplier',
    aumico_notes_super_table_ratio_choose_rows_for: 'Choisir les lignes',
    aumico_notes_super_table_ratio_choose_row_for: 'Choisir la ligne',
    aumico_notes_super_table_ratio_choose_cell: 'Cliquer sur la cellule pour la référence',
    aumico_notes_super_table_ratio_numerator: 'Numérateur',
    aumico_notes_super_table_calculation_item_selected: 'Elément sélectionné',
    aumico_notes_super_table_ratio_denomenator: 'Dénomeneur',
    aumico_annual_reports_export_excel_structured: 'Export Excel NEW',
    aumico_notes_super_table_previous_column_removal_confirmation:
        "Êtes-vous sûr de vouloir supprimer la colonne de l'année précédente ?",
    aumico_notes_fli_component_remove_fli_confirmation_text: 'Êtes-vous sûr de vouloir supprimer cet élément?',
    aumico_admin_navigation_survey_management: "Gestion de l'enquête",
    aumico_admin_survey_management_page_title: "Gestion de l'enquête",
    aumico_admin_survey_management_table_creation_date: 'Date de création',
    aumico_admin_survey_management_table_end_date: 'Date de fin',
    aumico_admin_survey_management_table_survey_status: "Statut de l'enquête",
    aumico_admin_survey_management_table_number_of_participants: 'Nombre de participants',
    aumico_admin_survey_management_start_new_survey_button: 'Démarrer une nouvelle enquête',
    aumico_admin_survey_management_start_new_survey_button_tooltip:
        "Une nouvelle enquête ne peut être lancée que si aucune autre enquête n'est active.",
    aumico_admin_survey_management_table_survey_status_badge_ACTIVE: 'active',
    aumico_admin_survey_table_management_survey_status_badge_INACTIVE: 'inactive',
    aumico_admin_survey_management_table_menu_options_delete: "Supprimer l'enquête",
    aumico_admin_survey_management_table_menu_options_stop: "Arrêter l'enquête",
    aumico_admin_survey_management_table_menu_options_download: 'Télécharger CSV',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_DISAPPOINTED: 'Neutre',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_NOT_DISAPPOINTED: 'Détracteur',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_VERY_DISAPPOINTED: 'Promoteur',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_OPEN: 'Ouvert',
    aumico_admin_survey_satisfaction_table_user: 'USER',
    aumico_admin_survey_satisfaction_table_organization: 'ORGANISATION',
    aumico_admin_survey_satisfaction_table_pmf_response: 'PMF RESPONSE',
    aumico_admin_survey_satisfaction_table_question_2: "PRINCIPAL AVANTAGE QUE VOUS RECEVEZ D'AUMICO ",
    aumico_admin_survey_satisfaction_table_question_3: 'COMMENT POUVONS-NOUS AMÉLIORER NOTRE PRODUIT ?',
    aumico_admin_survey_satisfaction_table_question_4: 'TYPE DE PERSONNE QUI EN BÉNÉFICIERA LE PLUS',
    aumico_admin_survey_satisfaction_page_pmf_score: 'PMF Score',
    aumico_admin_survey_satisfaction_page_participants: 'Participants',
    aumico_admin_survey_satisfaction_page_participants_out_of: 'de',
    aumico_admin_survey_satisfaction_page_users: 'Users',
    aumico_admin_survey_satisfaction_page_promoters: 'Promoteur',
    aumico_admin_survey_satisfaction_page_neutrals: 'Neutre',
    aumico_admin_survey_satisfaction_page_detractors: 'Détracteurs',
    aumico_admin_survey_satisfaction_page_end_survey_button: "Fin de l'enquête",
    aumico_admin_survey_satisfaction_page_download_csv_button: 'Télécharger CSV',
    aumico_admin_navigation_survey_satisfaction: 'Enquête de satisfaction des employés',
    aumico_survey_popup_go_back_button: 'Retourner',
    aumico_survey_popup_of: 'de',
    aumico_reports_navigation_survey_give_feedback: 'Donnez votre avis',
    aumico_survey_popup_thank_you: 'Merci',
    aumico_survey_popup_we_value_your_feedback:
        "Nous apprécions vraiment votre feedback ! Vos commentaires nous aident à améliorer aumico. Merci d'avoir pris le temps de nous faire part de vos réflexions! ",
    aumico_survey_popup_question_one: 'Comment vous sentiriez-vous si vous ne pouviez plus utiliser aumico?',
    aumico_survey_popup_question_two: "Qu'est-ce qui vous plaît le plus dans aumico?",
    aumico_survey_popup_question_three: 'Comment pouvons-nous encore améliorer aumico pour vous?',
    aumico_survey_popup_question_four: "Quel type de personne bénéficierait le plus d'aumico?",
    aumico_survey_popup_question_one_response_very_disappointed: 'Très déçu',
    aumico_survey_popup_question_one_response_somewhat_disappointed: 'Un peu déçu',
    aumico_survey_popup_question_one_response_not_disappointed: 'Pas déçu',
    aumico_survey_popup_close_button: 'Fermer',
    aumico_survey_popup_next_button: 'Suivant -fr',
    aumico_survey_popup_maybe_later_button: 'Peut-être plus tard',
    aumico_survey_popup_submit_button: 'Soumettre',
    aumico_survey_popup_placeholder: 'Ecrivez du texte ici. ..',
    aumico_annual_report_complementary_reports_drag_here: 'Faites glisser un rapport ici',
    aumico_complementary_reports_report_organize_reports: 'Organiser les rapports',
    aumico_complementary_reports_report_create_edit_reports: 'Créer des rapports',
    aumico_annual_reports_export_excel_structured_tooltip:
        'Exportation Excel nouvellement structurée et visuellement attrayante',
    aumico_annual_report_print_seal_report_action: 'Sceller le rapport annuel',
    aumico_annual_report_print_seal_report_history: 'Historique des scellés',
    aumico_annual_report_print_seal_report_history_tooltip: "Il n'y a pas d'historique à afficher",
    aumico_annual_report_print_seal_report_history_empty: 'Aucun historique des scellés disponible',
    aumico_annual_report_confirmation_seal_dialog_title: 'Sceller le rapport ?',
    aumico_annual_report_confirmation_seal_dialog_description:
        'Tous les exports seront générés sans la mention « Brouillon ». Le rapport peut être descellé à tout moment.',
    aumico_annual_report_confirmation_seal_dialog_action: 'Oui, sceller',
    aumico_annual_report_confirmation_unseal_dialog_title: 'Desceller un rapport?',
    aumico_annual_report_confirmation_unseal_dialog_description:
        "Le rapport reviendra à l\'état de brouillon. Tous les nouveaux exports incluront à nouveau la mention « Brouillon ». ",
    aumico_annual_report_confirmation_unseal_dialog_action: 'Desceller le rapport',
    aumico_annual_report_seal: 'Scellé',
    aumico_annual_report_unseal: 'Non scellé',
    aumico_annual_report_sealed_tag: 'Rapport annuel scellé',
    aumico_annual_report_fs_overview_sealed_tag: 'Scellé',
    aumico_annual_report_locked: 'Rapport verrouillé',
    aumico_annual_report_Unlock: 'Déverrouiller',
    aumico_annual_report_sealed_by: 'Par',
    aumico_button_close: 'Fermer',
    aumico_annual_report_complementary_report_name: 'Nom du rapport',
    aumico_annual_report_complementary_reports_title_no_brackets: 'Le titre ne doit pas contenir les caractères [ ou ].',
    aumico_annual_report_print_page_no_seal_history: 'Aucun historique de scellage disponible',
    aumico_annual_report_complementary_report_create_report: 'Créer des rapports',
    aumico_annual_report_complementary_report_organize_report: 'Organiser les rapports',
    aumico_notes_movement_schedule_component_column1_header: 'Entrées',
    aumico_notes_movement_schedule_component_column2_header: 'Cessions',
    aumico_notes_movement_schedule_component_column3_header: 'Amortiss. ',
    aumico_notes_movement_schedule_component_column4_header: 'Suramortiss.',
    aumico_companies_table_label_company_assignee: 'Manager',
    aumico_companies_table_download_xls: 'Download XLS',
    aumico_pm_tasks_status_filter_label: 'Statut',
    aumico_pm_tasks_status_open: 'Ouvert',
    aumico_pm_tasks_status_in_progress: 'En cours',
    aumico_pm_tasks_status_in_review: 'En révision',
    aumico_pm_tasks_status_done: 'Terminé',
    aumico_pm_tasks_company_filter_label: 'Entreprise',
    aumico_pm_tasks_apply_filter: 'Appliquer',
    aumico_pm_tasks_clear_filter: 'Effacer',
    aumico_pm_tasks_assignee_filter_label: 'Manager',
    aumico_pm_tasks_due_date_filter_label: "Date d'échéance",
    aumico_create_project_dialog_select_company_title: 'Sélectionne une entreprise à assigner à ce projet',
    aumico_create_project_dialog_select_company_description:
        "Choisis l'entreprise qui sera associée à ce projet pour une organisation et un suivi appropriés.",
    aumico_create_project_dialog_select_company_input_title: 'Entreprise',
    aumico_create_project_dialog_select_company_input_placeholder: 'Définir une entreprise à assigner à ce projet',
    aumico_create_project_dialog_cancel_button: 'Annuler',
    aumico_create_project_dialog_next_button: 'Suivant',
    aumico_create_project_dialog_submit_button: 'Soumettre',
    aumico_create_project_dialog_back_button: 'Retour',
    aumico_create_project_dialog_select_balance_sheet_date_title: 'Définir une date de bilan',
    aumico_create_project_dialog_select_balance_sheet_date_description:
        'Sélectionne la date de bilan appropriée qui sera utilisée pour le reporting financier de ce projet.',
    aumico_create_project_dialog_select_balance_sheet_date_input_title: 'Date de bilan',
    aumico_create_project_dialog_select_balance_sheet_date_input_placeholder: 'Sélectionner une date de bilan',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_today: "Aujourd'hui",
    aumico_create_project_dialog_select_balance_sheet_date_calendar_clear: 'Effacer',
    aumico_create_project_dialog_select_mandate_management_title: 'Configurer la gestion des mandats',
    aumico_create_project_dialog_select_mandate_management_copy_from_previous:
        "Copier la configuration de l'année précédente",
    aumico_create_project_dialog_select_mandate_management_reset_to_standard: 'Remettre à la configuration standard',
    aumico_create_project_dialog_select_closing_workflow_title: 'Configurer le workflow de clôture',
    aumico_create_project_dialog_select_closing_workflow_copy_from_previous:
        "Copier la configuration de l'année précédente",
    aumico_create_project_dialog_select_closing_workflow_reset_to_standard: 'Remettre à la configuration standard',
    aumico_create_project_dialog_of: 'de',
    aumico_tasks_overview_search_tasks: 'Rechercher',
    aumico_reports_organization_settings_workflow: 'Workflow',
    aumico_reports_organization_settings_mandate_management: 'Configurateur de gestion des mandats',
    aumico_organization_settings_mandate_management_configuration_page_header:
        'Configuration de la gestion des mandats',
    aumico_reports_organization_settings_closing_workflow: 'Configurateur de workflow de clôture',
    aumico_closing_workflow_overview_search_configurations: 'Rechercher',
    aumico_closing_workflow_overview_add_new_workflow: 'Ajouter un nouveau workflow',
    aumico_closing_workflow_overview_add_workflow_dialog_title: 'Ajouter un workflow',
    aumico_closing_workflow_overview_add_workflow_dialog_description:
        "Veux-tu commencer de zéro ou sélectionner à partir d'un modèle ?",
    aumico_closing_workflow_overview_start_from_scratch: 'Commencer de zéro',
    aumico_closing_workflow_overview_start_from_existing_workflow: "Commencer à partir d'un workflow existant",
    aumico_closing_workflow_overview_select_workflow_template_dialog_title:
        'Sélectionne un workflow à utiliser comme modèle',
    aumico_closing_workflow_overview_next_button: 'Suivant',
    aumico_closing_workflow_overview_back_button: 'Retour',
    aumico_closing_workflow_overview_select_workflow_template_name: 'Nom',
    aumico_organization_settings_closing_workflow_configuration_page_header: 'Configuration du workflow de clôture',
    aumico_cpmm_closing_workflows_table_delete_workflow_confirmation_text:
        'Es-tu sûr de vouloir supprimer ce workflow ? Cette action ne peut pas être annulée.',
    aumico_cpmm_closing_workflows_table_title_label: 'TITRE',
    aumico_cpmm_closing_workflows_table_creation_date_label: 'DATE DE CRÉATION',
    aumico_licence_banner_trial_active:
        "Tu es dans une période d'essai, tu peux utiliser l'application gratuitement jusqu'au {{value}}",
    aumico_licence_banner_trial_ended:
        "Ta période d'essai est terminée, veuillez contacter les ventes pour augmenter ton nombre de licences",
    aumico_licence_banner_suspended:
        'Ton compte est suspendu, veuillez contacter les ventes pour augmenter ton nombre de licences',
    aumico_licence_banner_churned:
        'Ton compte est annulé. L’accès à tes données est disponible jusqu’au {{value}}. Veuillez contacter les ventes si tu souhaites réactiver tes licences.',
    aumico_licence_tooltip_no_license:
        'Nombre maximum de mandats atteint, contacte les ventes pour augmenter ton nombre de licences',
    aumico_licence_banner_max_is_nearing:
        "Tu n'as plus que {{value}} licences restantes, contacte les ventes pour augmenter ton nombre de licences et éviter toute interruption.",
    aumico_licence_banner_max_reached:
        'Tu as atteint le nombre maximum de mandats de ton plan. Veuillez contacter les ventes pour augmenter ton nombre de licences.',
    aumico_licence_banner_request_more_button: 'Demander des licences supplémentaires',
    aumico_licence_banner_dismiss_button: 'Ne plus afficher',
    aumico_licence_banner_dialog_close_button: 'Fermer',
    aumico_licence_banner_dialog_title: 'Demande reçue',
    aumico_licence_banner_dialog_text: 'Notre équipe te contactera sous peu',
    aumico_licence_tooltip_max_reachedt:
        'Nombre maximum de mandats atteint, contacte les ventes pour augmenter ton nombre de licences',
    aumico_reports_annual_report_navigation_mandate_management: 'Gestion des mandats',
    aumico_reports_annual_report_navigation_closing_workflow: 'Workflow de clôture',
    aumico_reports_annual_report_navigation_closing: 'Clôture annuelle',
    aumico_reports_annual_report_navigation_report: 'Rapport',
    aumico_cp_workflow_title: 'Titre du flux de travail',
    aumico_cpmm_enter_title: 'Saisir le titre du flux de travail',
    aumico_cp_general: 'Général',
    aumico_cp_balance_sheet: 'Bilan',
    aumico_cp_income_statement: 'Compte de résultat',
    aumico_cpmm_add_section: 'Ajouter une section',
    aumico_cpmm_no_tasks_title: 'Aucune tâche pour l’instant',
    aumico_cpmm_no_tasks_subtitle: 'Ajoutez une tâche ou une section pour commencer',
    aumico_cpmm_set_section_name: 'Saisir le nom de la section',
    aumico_cpmm_task_name: 'Nom de la tâche',
    aumico_cpmm_task_description: 'Description de la tâche',
    aumico_cpmm_day_title: 'Jour',
    aumico_cpmm_day_placeholder: 'JJ',
    aumico_cpmm_month_title: 'Mois',
    aumico_cpmm_month_placeholder: 'MM',
    aumico_cpmm_period_title: 'Période',
    aumico_cpmm_period_placeholder: 'Définir la période',
    aumico_cpmm_new_task: 'Ajouter une nouvelle tâche',
    aumico_cpmm_max_length_notice_title: 'Nombre maximal de caractères atteint',
    aumico_cpmm_max_length_notice_description: 'Vous pouvez saisir un maximum de 50 caractères.',
    aumico_cpmm_current_period: 'Période actuelle',
    aumico_cpmm_next_period: 'Période suivante',
    aumico_cpmm_workflow_save_success: 'Workflow enregistré avec succès',
    aumico_cpmm_workflow_update_failure: 'Le workflow n’a pas pu être mis à jour. Veuillez réessayer.',
    aumico_cpmm_section_update_success: 'Section mise à jour avec succès',
    aumico_cpmm_section_update_failure: 'La section n’a pas pu être mise à jour. Veuillez réessayer.',
    aumico_cpmm_copy_of: 'Copie de ',
    aumico_cpmm_period_tooltip:
        'Période actuelle : année de la date de clôture du bilan sélectionnée pour le projet, Période suivante : année suivant la date de clôture du bilan sélectionnée.',
    aumico_tasks_unassigned: 'Non assigné',
    aumico_pm_tasks_company_table_header: 'Entreprise',
    aumico_pm_tasks_due_date_table_header: "Date d'échéance",
    aumico_pm_tasks_section_table_header: 'Section',
    aumico_pm_tasks_task_table_header: 'Tâche',
    aumico_pm_tasks_latest_comment_table_header: 'Dernier commentaire',
    aumico_pm_tasks_status_table_header: 'Statut',
    aumico_licence_tooltip_max_reached:
        'Nombre maximum de mandats atteint, contactez les ventes pour mettre à niveau votre nombre de licences',
    aumico_pm_tasks_responsible_table_header: 'Responsable',
    aumico_pm_tasks_select_date_today: "Aujourd'hui",
    aumico_pm_tasks_filter_clear: 'Effacer',
    aumico_pm_tasks_assignee_filter_my_tasks: 'Mes tâches',
    aumico_companies_form_closing_workflow: 'Workflow de clôture',
    aumico_cpmm_closing_workflows_table_delete_section_confirmation_text:
        'Êtes-vous sûr de vouloir supprimer cette section du workflow ?',
    aumico_reports_main_navigation_projects: 'Projets',
    aumico_reports_my_projects: 'Mes projets',
    aumico_reports_all_projects: 'Tous les projets',
    aumico_projects_overview_page_header: 'Projets',
    aumico_projects_overview_search_projects: 'Rechercher',
    aumico_projects_overview_add_new_project: 'Nouveau projet',
    aumico_companies_export_excel_table_header_name: 'Nom',
    aumico_companies_export_excel_table_header_street_and_number: 'Rue et numéro',
    aumico_companies_export_excel_table_header_addition_to_address: "Complément d'adresse",
    aumico_companies_export_excel_table_header_zip_code: 'Code postal',
    aumico_companies_export_excel_table_header_city: 'Ville',
    aumico_companies_export_excel_table_header_country: 'Pays',
    aumico_companies_export_excel_table_header_assigned_user: 'Utilisateur assigné',
    aumico_companies_export_excel_table_header_first_name: 'Prénom',
    aumico_companies_export_excel_table_header_last_name: 'Nom de famille',
    aumico_companies_export_excel_table_header_email: 'Email',
    aumico_companies_export_excel_table_header_phone: 'Téléphone',
    aumico_companies_export_excel_table_header_uid_number: 'Numéro UID',
    aumico_companies_export_excel_table_header_legal_form: 'Forme juridique',
    aumico_companies_export_excel_table_header_tax_domicile: 'Domicile fiscal',
    aumico_companies_export_excel_table_header_industry: "Secteur d'activité",
    aumico_companies_export_excel_table_header_closing_workflow: 'Workflow de clôture',
    aumico_reports_main_navigation_tasks: 'Tâches',
    aumico_reports_main_navigation_tasks_and_closing: 'Clôture et tâches',
    aumico_reports_tasks_and_closing_welcome_title: '🎉 Félicitations pour la mise à niveau ',
    aumico_reports_tasks_and_closing_upgrade_prompt:
        'Mettre à niveau vers le workflow de clôture et la gestion des mandats et tâches',
    aumico_reports_tasks_and_closing_confirm_and_continue: 'Confirmer et continuer',
    aumico_reports_tasks_and_closing_cancel: 'Pas pour le moment',
    aumico_reports_tasks_and_closing_start: 'Réserver une réunion',
    aumico_reports_tasks_and_closing_upgrade_access_description:
        "Mettez à niveau pour accéder au workflow de clôture et à la gestion des mandats et tâches — une fonctionnalité puissante pour rationaliser l'ensemble de votre processus et rester au courant des affaires. C'est une fonctionnalité payante, et votre compte sera facturé lors de l'activation.",
    aumico_reports_tasks_and_closing_success_message:
        "Vous avez activé avec succès la plateforme <b>tout-en-un pour la clôture de fin d'année</b>.<br/>Vous bénéficiez désormais de fonctionnalités avancées pour la <b>gestion des clients</b>, le <b>contrôle des tâches</b> et l'ensemble du <b>processus de clôture</b>.<br/>Notre <b>équipe Customer Success</b> est là pour vous aider à tout configurer – contactez-nous !",
    aumico_reports_tasks_and_closing_advertising_title:
        'Activer le workflow de clôture et la gestion des mandats et tâches',
    aumico_reports_tasks_and_closing_advertising_description:
        "Gestion client et workflows de clôture transparents, peu importe l'outil comptable que vous utilisez.",
    aumico_reports_tasks_and_closing_advertising_mandate_management_title: 'Gestion des mandats et tâches',
    aumico_reports_tasks_and_closing_advertising_mandate_management_description:
        'Configurez des workflows standardisés pour les tâches récurrentes (par ex., TVA, paie, déclarations fiscales) pour tous les clients.',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_title: 'Workflow de clôture',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_description:
        'Configurez et gérez les workflows de clôture de bout en bout et gérez les tâches, documents et commentaires en un seul endroit central.',
    aumico_reports_tasks_and_closing_advertising_upgrade_button: 'Mettre à niveau',
    aumico_create_project_invalid_date:
        'Date invalide, le format anglais est MM/DD/YYYY, le format allemand est DD.MM.YYYY',
    aumico_reports_project_upload_document_title: 'Télécharger un document',
    aumico_reports_project_upload_document_description:
        'Sélectionnez un fichier de votre appareil à joindre à cette tâche. Formats supportés : ',
    aumico_reports_project_upload_document_drag: 'Glissez les fichiers ici pour les télécharger',
    aumico_reports_project_upload_document_details: '(Taille max. 25MB)',
    aumico_cpmm_workflow_configurator_empty_section_confirmation_text:
        "Êtes-vous sûr de vouloir enregistrer avec des sections vides qui n'ont pas de tâches ? Cela entraînera la suppression de ces sections",
    cpmm_projects_overview_empty_mandates: "Vous n'avez pas encore de mandats !",
    cpmm_projects_overview_empty_companies: "Il n'y a pas encore d'entreprises !",
    cpmm_projects_overview_empty_assign_instructions:
        "Commencez par assigner des entreprises dans le profil de l'entreprise. Elles apparaîtront ici une fois ajoutées !",
    cpmm_projects_overview_empty_create_instructions: 'Créez de nouvelles entreprises pour les voir listées ici.',
    cpmm_projects_overview_empty_go_to_companies_button: "Aller à l'aperçu des entreprises",
    cpmm_projects_overview_empty_add_new_company_button: 'Ajouter une nouvelle entreprise',
    cpmm_projects_overview_group_mandate_management: 'Gestion des mandats',
    cpmm_projects_overview_group_closing_workflow: 'Workflow de clôture',
    cpmm_projects_overview_group_report: 'Rapport',
    cpmm_projects_overview_col_company: 'Entreprise',
    cpmm_projects_overview_col_balance_sheet_date: 'Date de bilan',
    cpmm_projects_overview_col_responsible: 'Responsable',
    cpmm_projects_overview_col_status: 'Statut',
    cpmm_projects_overview_action_change_status_to_done: 'Changer le statut à terminé',
    cpmm_projects_overview_action_change_status_to_active: 'Changer le statut à actif',
    cpmm_projects_overview_action_delete_project: 'Supprimer le projet',
    cpmm_projects_overview_badge_active: 'Actif',
    cpmm_projects_overview_header_row_abcp_closing: 'Statut',
    cpmm_projects_overview_badge_closing_started: 'Démarrée',
    cpmm_projects_overview_badge_closing_not_started: 'Pas démarrée',
    cpmm_projects_overview_badge_done: 'Terminé',
    cpmm_projects_overview_badge_report_open: 'Ouvert',
    cpmm_projects_overview_badge_report_sealed: 'Scellé',
    cpmm_projects_overview_badge_archived: 'Archivé',
    cpmm_projects_overview_header_row_GENERAL: 'Général',
    cpmm_projects_overview_header_row_BALANCE_SHEET: 'Bilan',
    cpmm_projects_overview_header_row_INCOME_STATEMENT: 'Compte de résultat',
    cpmm_projects_overview_empty_individual_company: "Il n'y a pas encore de projets pour ce mandat.",
    cpmm_projects_overview_empty_create_instructions_individual_company:
        'Commencez par créer un projet pour ce mandat !',
    aumico_companies_table_label_company_workflow: 'Workflow',
    aumico_reports_cpmm_tasks: 'Tâches',
    aumico_reports_cpmm_export_tasks: 'Exporter XLSX',
    aumico_reports_cpmm_export_tasks_open_tasks: 'Tâches ouvertes',
    aumico_reports_cpmm_export_tasks_completed_tasks: 'Tâches terminées',
    aumico_reports_cpmm_export_tasks_na_tasks: 'Tâches N/A',
    aumico_reports_cpmm_export_tasks_include_documents_names: 'Inclure les documents',
    aumico_reports_cpmm_export_tasks_include_annotations: 'Inclure les annotations',
    aumico_reports_cpmm_export_tasks_in_progress_tasks: 'Tâches en cours',
    aumico_reports_cpmm_export_tasks_in_review_tasks: 'Tâches en révision',
    aumico_reports_cpmm_export_documents_zip_mandate_management_documents: 'Documents de gestion des mandats',
    aumico_reports_cpmm_export_documents_zip_closing_workflow_documents: 'Documents de workflow de clôture',
    tasks_empty_state_text_one: "Vous n'avez pas encore de tâches !",
    tasks_empty_state_text_two: 'Commencez par créer un nouveau projet.',
    cpmm_projects_overview_empty_filtered_text1: 'Aucun projet trouvé',
    cpmm_projects_overview_empty_filtered_text2:
        'Les filtres actuels ne renvoient aucun projet. Ajustez-les ou réinitialisez-les.',
    tasks_empty_state_text_one_filters: 'Aucune tâche trouvée',
    tasks_empty_state_text_two_filters:
        'Les filtres actuels ne renvoient aucune tâche. Ajuste-les ou réinitialise-les.',
    aumico_license_book_call_text:
        "Si vous ne voulez pas attendre, réservez directement une réunion avec l'équipe de vente.",
    aumico_license_book_call_button: 'Réserver une réunion',
    aumico_reports_export_all_companies_file_name: 'Toutes les entreprises',
    aumico_cpmm_document_uploaded_success_title: 'Document téléchargé avec succès',
    aumico_cpmm_document_uploaded_success_description: 'Le document a été téléchargé avec succès',
    aumico_cpmm_document_uploaded_failure_title: 'Erreur lors du téléchargement du document',
    aumico_cpmm_document_uploaded_failure_description: 'Échec du téléchargement du document. Veuillez réessayer',
    aumico_cpmm_task_bulk_update_success_title: 'Tâches mises à jour avec succès',
    aumico_cpmm_task_bulk_update_success_description: 'Les tâches ont été mises à jour avec succès.',
    aumico_cpmm_task_bulk_update_failure_title: 'Erreur lors de la mise à jour des tâches',
    aumico_cpmm_task_bulk_update_failure_description: "Les tâches n'ont pas pu être mises à jour. Veuillez réessayer.",
    aumico_company_assignee_change_confirmation_dialog_title: "Changer l'employé administratif ?",
    aumico_company_assignee_change_confirmation_dialog_text:
        "Tu changes l'employé administratif pour cette entreprise. Comment les tâches existantes doivent-elles être réassignées ?",
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user:
        "Réassigner uniquement les tâches assignées à l'ancien employé administratif",
    aumico_company_assignee_change_confirmation_update_all_tasks:
        "Réassigner toutes les tâches, y compris celles assignées à d'autres utilisateurs",
    aumico_company_assignee_change_confirmation_option: 'Option',
    aumico_project_overview_project_deletion_confirmation_text:
        'Êtes-vous sûr de vouloir supprimer ce projet ? Cette action ne peut pas être annulée.',
    aumico_project_overview_project_delete_success_message: 'Projet supprimé avec succès',
    aumico_cpmm_projects_bulk_delete_success_description: 'Les projets sélectionnés ont été supprimés avec succès.',
    aumico_cpmm_projects_bulk_delete_failure_title: 'Erreur lors de la suppression des projets',
    aumico_cpmm_projects_bulk_delete_failure_description:
        "Les projets sélectionnés n'ont pas pu être supprimés. Veuillez réessayer.",
    aumico_cpmm_projects_bulk_delete_success_title: 'Projets supprimés avec succès',
    aumico_project_overview_project_delete_error_message:
        'Erreur lors de la suppression du projet. Veuillez réessayer.',
    aumico_companies_form_validation_error: 'Tous les champs obligatoires ne sont pas remplis.',
    aumico_cpmm_sync_success_title: 'Les tâches ont été synchronisées avec succès',
    aumico_cpmm_sync_success_description: 'Toutes les tâches sont synchronisées avec le configurateur',
    aumico_cpmm_sync_failure_title: "Les tâches n'ont pas pu être synchronisées",
    aumico_cpmm_sync_failure_description:
        'Assure-toi que le processus de clôture est configuré dans le profil de cette entreprise !',
    aumico_MM_sync_banner:
        'Des modifications dans la configuration de la gestion du mandat ont été détectées. Voulez-vous appliquer ces modifications à votre projet ?',
    aumico_CP_sync_banner:
        'Des modifications dans la configuration du processus de clôture ont été détectées. Voulez-vous appliquer ces modifications à votre projet ?',
    aumico_MM_sync_dismiss_text: 'Non, ne pas appliquer',
    aumico_MM_sync_yes_text: 'Oui, appliquer',
    cpmm_workflow_tasks_empty: 'Aucune tâche disponible !',
    cpmm_workflow_tasks_empty_sync_instructions_MM:
        'Synchronisez votre projet pour importer des tâches depuis votre configuration de gestion de mandat.',
    cpmm_workflow_tasks_empty_sync_instructions_CP:
        'Synchronisez votre projet pour importer des tâches depuis votre configuration de processus de clôture.',
    aumico_workflow_sync: 'Synchroniser le workflow',
    aumico_company_delete_failed_because_of_conf_notification_message:
        "Erreur lors de la suppression de l'entreprise en raison de dépendances existantes... Vous devez d'abord supprimer les projets existants de cette entreprise.",
    aumico_company_delete_failed_because_of_conf_notification_title: 'We couldn’t delete this company',
    aumico_unknown_error: 'Une erreur inconnue est survenue. Veuillez réessayer ou contacter le support.',
    aumico_companies_workflow_change_title: 'Changer le workflow de clôture ?',
    aumico_companies_workflow_change_text:
        "La modification du workflow de clôture n'affectera que les nouveaux projets. Les projets existants resteront inchangés. Voulez-vous continuer ?",
    aumico_companies_workflow_change_cancel: 'Annuler',
    aumico_companies_workflow_change_confirm: 'Confirmer',
    aumico_projects_status_active: 'Actif',
    aumico_projects_status_done: 'Fait',
    aumico_projects_status_archived: 'Archivé',
    aumico_project_overview_status_update_success_message: 'Le statut du projet a été mis à jour avec succès.',
    aumico_project_overview_status_update_error_message:
        'Un problème est survenu lors de la mise à jour du statut du projet.',
    aumico_annualreport_redo_confirmation_title: 'Redémarrer le rapport annuel?',
    aumico_annualreport_redo_confirmation_description:
        'Si vous redémarrez le rapport annuel, le statut actuel sera supprimé et vous pourrez commencer un nouveau rapport annuel. Toutes les données précédentes seront perdues.',
    aumico_annual_report_complementary_reports_empty_state_text1: 'Pas encore de rapports complémentaires !',
    aumico_annual_report_complementary_reports_empty_state_text2:
        'Ajoute par exemple une déclaration de conformité ou le procès-verbal de l’assemblée générale.\n Tu peux automatiser les rapports avec des variables comme @Companyname ou @BalancesheetDate.',
    aumico_annual_report_complementary_reports_empty_state_text3:
        '<b>Astuce :</b> Standardise tes modèles dans les paramètres d’organisation pour les réutiliser avec chaque société.',
    aumico_company_assignee_change_confirmation_dialog_save_button: 'Suivant',
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text:
        'Cela transférera toutes les tâches de l’ancien gestionnaire de mandat au nouveau gestionnaire de mandat choisi.',
    aumico_company_assignee_change_confirmation_update_all_tasks_description_text:
        'Cela transférera toutes les tâches au nouveau gestionnaire de mandat choisi, quel que soit le responsable initial.',
    invite_friend_modal_title: 'Parle-en à un ami',
    invite_friend_description:
        'Si tu as trouvé notre outil utile, nous aimerions que tu le partages avec un collègue ou un ami qui pourrait en bénéficier.',
    invite_friend_email_label: "E-mail de l'ami",
    invite_friend_message_label: 'Message',
    invite_friend_message_placeholder:
        "Ajoute une note personnelle expliquant pourquoi tu penses qu'il/elle trouverait cet outil utile...",
    aumico_annual_report_complementary_reports_sample_empty_state_text1: 'Pas encore de modèles de rapport !',
    aumico_annual_report_complementary_reports_sample_empty_state_text2:
        'Crée ici des modèles par défaut pour les rapports complémentaires, comme les attestations de conformité ou les procès-verbaux d’assemblée générale. \nTu pourras ensuite les utiliser directement dans n’importe quel mandat – automatiquement avec des placeholders comme <b>@company.name</b> ou <b>@ar.duedate</b>.',
    aumico_annual_report_complementary_reports_sample_empty_state_text3:
        '<b>Astuce :</b> Sur notre <a href="https://aumico.freshdesk.com/support/solutions/articles/204000001667-erg%C3%A4nzende-berichte-alle-platzhalter-erkl%C3%A4rt-tabelle" target="_blank">page support</a>, tu trouveras tous les placeholders que tu peux utiliser.',
    aumico_companies_empty_state_text1: "Pas encore d'entreprise !",
    aumico_companies_empty_state_text2: 'Crée ta première entreprise et commence la saisie de tes projets.',
    cpmm_projects_overview_col_report_status: 'Statut du rapport',
    cpmm_projects_overview_col_project_status: 'Statut du projet',
    aumico_organization_settings_mandate_management_configuration_info_text1:
        "Saisis simplement les dates d'échéance de tes tâches comme si l’exercice comptable finissait toujours le 31.12. (date de clôture 31.12.)",
    aumico_organization_settings_mandate_management_configuration_info_text2:
        'Si tu crées plus tard un projet avec une autre date de clôture (par ex. <b>30.06.</b>), <b>toutes les échéances seront automatiquement décalées pour toi</b> – pas besoin de modifier quoi que ce soit à la main !',
    aumico_organization_settings_mandate_management_configuration_info_title: 'Astuce 💡',
    aumico_organization_settings_mandate_management_configuration_info_text_example:
        '<b>Exemple :</b> \nUne tâche avec une échéance au <b>31.03.</b> sera automatiquement déplacée au <b>30.09.</b> si la date de clôture est <b>30.06.</b>.',
    aumico_backend_errors_workflow_name_already_exists: 'Un workflow portant ce nom existe déjà.',
    aumico_app_cpmm_documents_open: 'Aperçu',
    aumico_app_cpmm_documents_download: 'Télécharger',
    aumico_app_cpmm_documents_wait_for_anti_virus: 'En attente du scan antivirus',
    aumico_app_cpmm_documents_preview_loading: 'Chargement...',
    aumico_app_cpmm_documents_preview_failed: "Impossible de générer l'aperçu",
    aumico_app_cpmm_documents_preview_not_supported: 'Aperçu non pris en charge',
    aumico_notes_update_banner_message:
        'Modifications détectées : le regroupement, l’affectation des comptes ou la balance ont été modifiés depuis le dernier enregistrement. L’annexe affiche déjà les valeurs actuelles. Veuillez l’enregistrer pour que l’impression les affiche aussi.',
    aumico_notes_update_banner_button: 'Appliquer les modifications',
    aumico_print_notes_outdated_banner_message:
        'L’annexe n’est pas à jour : le regroupement, l’affectation des comptes ou la balance ont été modifiés depuis le dernier enregistrement. Veuillez ouvrir l’annexe et l’enregistrer pour que l’impression affiche les valeurs actuelles.',
    aumico_print_notes_outdated_banner_button: 'Ouvrir l’annexe',
    aumico_notes_update_confirmation_success: 'Les notes ont été mises à jour avec succès.',
    aumico_notes_action_palette_column_label_name: 'Libellé de colonne',
    aumico_notes_action_palette_column_label_show_fiscal_year: "Afficher l'exercice fiscal",
    aumico_notes_action_palette_column_label_show_balance_sheet_date: 'Afficher la date du bilan',
    aumico_notes_action_palette_column_label_hide_column: 'Masquer la colonne',
    aumico_notes_action_palette_column_label_currency: 'Devise',
    aumico_notes_super_table_show_currency: 'Afficher la devise',
    aumico_notes_components_list_actions_table_tooltip: 'Paramètres du tableau',
    aumico_notes_components_list_actions_footnote_tooltip: 'Notes de bas de page',
    aumico_notes_components_list_actions_copy_tooltip: 'Copier le composant',
    aumico_notes_components_list_actions_break_page_tooltip: 'Insérer un saut de page après le composant',
    aumico_notes_components_list_actions_hide_component_tooltip: 'Masquer le composant',
    aumico_notes_components_list_actions_show_component_tooltip: 'Afficher le composant',
    aumico_notes_actions_hide_accordion_tooltip: 'Masquer tous les composants de l\'accordéon',
    aumico_notes_actions_show_accordion_tooltip: 'Afficher tous les composants de l\'accordéon',
    aumico_notes_component_hidden_badge: 'MASQUE',
    aumico_notes_super_table_edit_row: 'Modifier la ligne',
    aumico_notes_super_table_remove_row: 'Supprimer la ligne',
    aumico_notes_super_table_row_format: 'Format de ligne',
    aumico_notes_super_table_column_format: 'Format de colonne',
    aumico_notes_super_table_remove_column: 'Supprimer la colonne',
    aumico_notes_super_table_current_year_column_removal_confirmation:
        "Êtes-vous sûr de vouloir supprimer la colonne de l'année en cours ?",
    aumico_annual_report_print_page_rounding_disclaimer:
        'Toutes les valeurs affichées sont arrondies pour des raisons de présentation. En raison des arrondis, il peut y avoir de légères différences entre les totaux affichés et les valeurs réelles.',
    aumico_notes_footnote_label: 'Note de bas de page',
    aumico_notes_footnote_placeholder: 'Ajouter une note de bas de page à cette table...',
    aumico_notes_add_more_movement: 'Ajouter un nouvel emploi du temps de mouvement',
    aumico_notes_add_more_fli: 'Ajouter un nouveau tableau FLI',
    aumico_notes_add_more_row: 'Ajouter une nouvelle ligne',
    aumico_notes_add_component: 'Ajouter un composant',
    aumico_notes_super_table_edit_reconcile: 'Modifier la conciliation de valeur',
    aumico_add_new_notes_clipboard_title: 'Clipboard ',
    aumico_add_new_notes_paste_from_clipboard: 'Coller depuis le presse-papiers',
    aumico_notes_component_copied_to_clipboard: 'Copié dans le presse-papiers',
    aumico_notes_component_pasted_successfully: 'Ajouté aux pièces jointes',
    aumico_notes_super_table_add_column_width: 'Largeur de colonne',
    aumico_notes_super_table_options_col_width_dynamic: 'Dynamique',
    aumico_notes_super_table_options_col_width_small: 'Petit',
    aumico_notes_super_table_options_col_width_standard: 'Standard',
    aumico_notes_super_table_options_col_width_large: 'Grand',
    aumico_notes_empty_state_text_1: 'Personnalisez votre tableau en fonction de vos besoins.',
    aumico_notes_empty_state_text_2: 'Ajoutez la première ligne pour commencer.',
    aumico_notes_add_row_text: 'Ajouter une ligne',
    aumico_projects_overview_status_update_modal_title: 'Clore toutes les tâches ouvertes ?',
    aumico_projects_overview_status_update_modal_text:
        'Veux-tu que toutes les tâches ouvertes soient automatiquement marquées comme terminées ?',
    aumico_projects_overview_status_update_modal_confirm: 'Oui',
    aumico_projects_overview_status_update_modal_cancel: 'Non',
    aumico_companies_assignee_filter_my_companies: 'Mes entreprises',
    aumico_companies_filter_clear: 'Effacer',
    aumico_notes_super_table_add_row_menu_sub_title:
        'Sélectionnez le type de ligne que vous voulez ajouter au tableau.',
    aumico_notes_super_table_add_column_menu_title:
        'Sélectionnez le type de colonne que vous voulez ajouter au tableau.',
    aumico_notes_info_dialog_column_title: 'Comment utiliser correctement le réglage de la largeur des colonnes 💡',
    aumico_notes_info_dialog_column_text1:
        "<b>Dynamique</b> répartit l'espace disponible de manière uniforme entre toutes les colonnes marquées comme dynamiques.",
    aumico_notes_info_dialog_column_text2:
        '<b>Astuce :</b> Par exemple, si vous voulez afficher des pourcentages, utilisez <b>petit</b>. Pour les colonnes de texte, <b>dynamique</b> est recommandé. <b>Standard</b> convient aux nombres et a la même largeur que toutes les autres tables du PDF.',
    aumico_notes_info_dialog_column_done: 'Compris',
    aumico_admin_navigation_announcements: 'Annonces',
    aumico_admin_announcements_message: 'Message',
    aumico_admin_announcements_link_url: 'Link Url',
    aumico_admin_announcements_link_url_placeholder: 'https://example.com',
    aumico_admin_announcements_link_name: 'Link Name',
    aumico_admin_announcements_link_name_placeholder: 'Link Name',
    aumico_admin_announcements_dismissible: 'Fermable',
    aumico_admin_announcements_date_range: 'Plage de dates',
    aumico_admin_announcements_create_new_announcement: 'Nouvelle annonce',
    aumico_admin_announcements_edit_announcement: "Modifier l'annonce",
    aumico_admin_announcements_start_date: 'Date de début',
    aumico_admin_announcements_end_date: 'Date de fin',
    aumico_admin_announcements_start_date_required: 'La date de début est requise',
    aumico_admin_announcements_end_date_required: 'La date de fin est requise',
    aumico_admin_announcements_update_success: 'Annonce mise à jour avec succès',
    aumico_admin_announcements_create_success: 'Annonce créée avec succès',
    aumico_admin_announcements_delete_success: 'Annonce supprimée avec succès',
    aumico_admin_success_title: 'Succès',
    aumico_annual_report_complementary_reports_preview_button: 'Aperçu PDF',
    aumico_annual_report_complementary_reports_add_from_template: 'Ajouter depuis un modèle',
    aumico_annual_report_complementary_reports_add_blank_report: 'Ajouter un rapport vide',
    aumico_annual_report_complementary_reports_upload_PDF: 'Téléverser un PDF',
    aumico_annual_report_complementary_reports_new_title: 'Ajouter un nouveau rapport',
    aumico_annual_report_complementary_reports_select_template: 'Choisir un modèle',
    aumico_annual_report_complementary_reports_template_add: 'Insérer',
    aumico_annual_report_complementary_reports_template_cancel: 'Annuler',
    aumico_annual_report_complementary_reports_preview_scanning_warning:
        'Lors de l’impression, une page blanche est insérée à la place de ton PDF.',
    aumico_annual_report_complementary_reports_show_page_numbers_toggle: 'Afficher les numéros de page',
    aumico_create_project_dialog_select_report_type: 'Sélectionner le type de projet',
    aumico_create_project_dialog_select_report_type_annual: 'Annuel',
    aumico_create_project_dialog_select_report_type_quarterly: 'Trimestriel',
    aumico_create_project_dialog_select_report_type_monthly: 'Mensuel',
    aumico_create_project_dialog_select_report_type_custom: 'Personnalisé',
    aumico_annual_report_general_information_ar_template: 'Modèle de rapport',
    aumico_annual_report_general_information_select_ar_template: 'Sélectionner les composants du rapport',
    aumico_annual_report_general_information_report_type: 'Type de rapport',
    aumico_annual_report_general_information_select_report_type: 'Sélectionner le type de rapport',
    aumico_company_update_banner_message:
        'Vous avez mis à jour les informations de l’entreprise. Voulez-vous appliquer les modifications à ce projet ?',
    aumico_company_update_banner_button: 'Oui, appliquer',
    aumico_annual_report_translation_gaps_title: 'Textes sans traduction',
    aumico_annual_report_translation_gaps_text: 'textes n\'ont pas de traduction en {{language}}.',
    aumico_annual_report_translation_gaps_reassurance: 'L\'IA les traduit dans le style des traductions déjà présentes dans ce rapport. Les traductions peuvent ensuite être vérifiées dans la révision ou enregistrées directement.',
    aumico_annual_report_translation_done_title: 'Traduction terminée',
    aumico_annual_report_translation_done_count: '{{count}} textes ont été traduits en {{language}}.',
    aumico_annual_report_translation_done_question: 'Souhaitez-vous réviser la traduction ou l\'enregistrer directement ?',
    aumico_annual_report_translation_done_legend_ai: 'Traduit par l\'IA',
    aumico_annual_report_translation_done_legend_mapping: 'Traduction standard',
    aumico_annual_report_translation_done_legend_heading: 'En mode révision :',
    aumico_annual_report_translation_done_legend_unmarked: 'Les textes non marqués ne sont pas modifiables.',
    aumico_annual_report_translation_legend_title: 'Légende',
    aumico_annual_report_translation_done_legend_user: 'Modifié manuellement',
    aumico_annual_report_translation_action_review: 'Révision',
    aumico_annual_report_translation_action_save_now: 'Enregistrer maintenant',
    aumico_annual_report_translation_action_translate: 'Traduire avec l\'IA',
    aumico_annual_report_translation_action_later: 'Plus tard',
    aumico_annual_report_translation_manage_title: 'Gérer la traduction',
    aumico_annual_report_translation_manage_text: 'Vous pouvez parcourir les traductions de cette langue dans la révision et les corriger une par une.',
    aumico_annual_report_translation_manage_review: 'Révision',
    aumico_annual_report_translation_manage_undo: 'Annuler',
    aumico_annual_report_translation_manage_refresh: 'Rechercher de nouvelles lacunes',
    aumico_annual_report_translation_manage_no_gaps: 'Aucune nouvelle lacune trouvée.',
    aumico_annual_report_translation_undo_title: 'Annuler la traduction',
    aumico_annual_report_translation_undo_text: 'Toutes les traductions de cette langue seront supprimées, y compris vos propres corrections.',
    aumico_annual_report_translation_undo_confirm: 'Supprimer',
    aumico_annual_report_translation_part_template: 'Bilan et compte de résultat',
    aumico_annual_report_translation_part_accounts: 'Comptes',
    aumico_annual_report_translation_part_notes: 'Annexe',
    aumico_annual_report_translation_part_aop: 'Emploi du bénéfice',
    aumico_annual_report_translation_part_ems: 'Tableau des capitaux propres',
    aumico_annual_report_translation_part_cashflow: 'Tableau des flux de trésorerie',
    aumico_annual_report_translation_part_complementary: 'Rapports complémentaires',
    aumico_annual_report_translation_running: '{{count}} textes sont traduits en {{language}}.',
    aumico_annual_report_translation_running_progress: '{{translated}} textes sur {{total}} traduits.',
    aumico_annual_report_translation_running_hint: 'Cela prend généralement moins d\'une minute. Veuillez laisser la fenêtre ouverte.',
    aumico_annual_report_translation_failed: 'La traduction a échoué. Rien n\'a été modifié dans le rapport.',
    aumico_annual_report_translation_save: 'Enregistrer',
    aumico_annual_report_translation_edit_title: 'Corriger la traduction',
    aumico_annual_report_translation_edit_source: 'Langue du rapport',
    aumico_annual_report_translation_edit_target: 'Traduction',
    aumico_annual_report_translation_edit_empty: 'Le champ ne peut pas être vide.',
    aumico_annual_report_translation_manage: 'Gérer la traduction',
    aumico_annual_report_translation_sealed_tooltip: 'Descellez le rapport pour modifier la traduction.',
    aumico_company_update_banner_sealed_tooltip: 'Descellez le rapport pour appliquer les modifications.',
    aumico_general_information_current_period: 'Période actuelle',
    aumico_general_information_balance_sheet: 'Bilan',
    aumico_general_information_balance_sheet_date: 'Date du bilan',
    aumico_general_information_income_statement: 'Compte de résultat',
    aumico_general_information_previous_period: 'Période précédente',
    aumico_general_information_load_previous_data_from_aumico:
        'Charger les données de la période précédente depuis aumico',
    aumico_general_information_select_report: 'Sélectionner le rapport',
    aumico_general_information_choose_dataset_tooltip_text:
        'Vous pouvez choisir un ensemble de données à partir d’un rapport existant',
    cpmm_projects_overview_col_report_type: 'Type de rapport',
    aumico_annual_report_general_information_has_previous_data: 'A des données précédentes',
    aumico_ui_no_access_title: 'Pas d’accès',
    aumico_ui_no_access_message:
        "Tu n'as pas accès aux paramètres de l'organisation. Veuillez contacter ton administrateur.",
    aumico_ui_document_edit_form_title_add: 'Ajouter une documentation',
    aumico_ui_document_edit_form_title_edit: 'Modifier la documentation',
    aumico_ui_document_edit_form_file_existing: 'Fichier existant',
    aumico_ui_document_edit_form_file_upload_error_format:
        "Type de fichier non pris en charge. Merci de télécharger un fichier avec l'une des extensions acceptées.",
    aumico_ui_document_edit_form_file_required_error: 'Merci de sélectionner un fichier à télécharger.',
    aumico_ui_document_edit_form_link_required_error: "L'URL du lien est requise.",
    aumico_ui_document_edit_form_link_validation_error:
        'Merci de saisir une URL HTTPS valide (ex: https://www.aumico.io).',
    aumico_ui_document_edit_form_name_placeholder: 'Nom du document',
    aumico_ui_document_edit_form_name_label: 'Donne un nom à ton document',
    aumico_ui_document_edit_form_set_as_permanent: 'Définir comme permanent',
    aumico_ui_document_edit_form_set_as_permanent_tooltip:
        "Tu peux définir un fichier comme permanent et le conserver pour les prochaines périodes ou ajouter une date d'expiration.",
    aumico_ui_document_edit_form_expiration_date_label: "Date d'expiration (optionnel)",
    aumico_ui_document_edit_form_expiration_date_placeholder: "Sélectionner la date d'expiration",
    aumico_ui_document_edit_form_save_changes: 'Enregistrer les modifications',
    aumico_ui_document_edit_form_cancel: 'Annuler',
    aumico_ui_document_edit_form_submit_add: 'Ajouter le document',
    aumico_ui_document_edit_form_submit_add_link: 'Ajouter le lien',
    aumico_ui_document_edit_form_file_upload: 'Télécharger un fichier',
    aumico_ui_document_edit_form_add_link: 'Ajouter un lien',
    aumico_ui_document_edit_form_add_link_label: 'Lien',
    aumico_ui_document_edit_form_add_link_tooltip:
        'Ajoute un lien vers un document externe (p. ex. SharePoint, Google Drive, Dropbox). Seuls les liens HTTPS sont autorisés.',
    aumico_ui_document_edit_form_add_link_placeholder: 'https://...',
    aumico_app_cpmm_documents_delete_confirmation:
        'Es-tu sûr de vouloir supprimer ce document {{ documentName }} ? Cette action ne peut pas être annulée.',
    aumico_session_warning_reauth_button: 'Se réauthentifier',
    aumico_session_warning_message:
        'Ta session va expirer dans {{timeLeft}}. Merci de sauvegarder ton travail et de te réauthentifier pour continuer.',
    aumico_ui_document_has_expired: 'Ce document a expiré le : ',
    aumico_ui_document_about_to_expire: 'Ce document va expirer le : ',
    aumico_app_cpmm_documents_open_link: 'Ouvrir le lien dans le navigateur',
    aumico_app_cpmm_documents_is_permanent_tooltip: 'Ce document est permanent.',
    aumico_companies_list_filter_mandate_manager: 'Gestionnaire de mandat',
    aumico_companies_list_filter_clerk: 'Employé administratif',
    aumico_projects_overview_filter_assignee_label: 'Responsable',
    aumico_tasks_overview_filter_assignee_label: 'Responsable',
    aumico_companies_bulk_changes_saved_successfully_dialog: 'Les entreprises ont été mises à jour avec succès',
    aumico_company_assignee_change_dialog_title: 'Changer le responsable de mandat ?',
    aumico_company_assignee_change_dialog_title_plural:
        'Changer le responsable de mandat pour {{ count }} entreprises ?',
    aumico_company_clerk_change_dialog_title: 'Changer le gestionnaire ?',
    aumico_company_clerk_change_dialog_title_plural: 'Changer le gestionnaire pour {{ count }} entreprises ?',
    aumico_company_assignee_change_dialog_select_new_assignee: 'Sélectionner un nouveau responsable de mandat',
    aumico_company_clerk_change_dialog_select_new_clerk: 'Sélectionner un nouveau gestionnaire',
    aumico_company_assignee_change_dialog_add_assignee_for_selected_tasks: 'Choisir un responsable de mandat...',
    aumico_company_clerk_change_dialog_add_clerk_for_selected_tasks: 'Choisir un gestionnaire...',
    aumico_companies_bulk_edit_action_bar_selected_text: 'sélectionné(s)',
    aumico_bulk_edit_action_bar_max_selection_error: 'Maximum {{max}} sélections autorisées pour cette action',
    aumico_companies_assignee_change_action_bar: 'Changer le responsable de mandat',
    aumico_companies_clerk_change_action_bar: 'Changer le gestionnaire',
    aumico_companies_create_next_financial_year_action_bar: 'Créer le prochain exercice',
    aumico_companies_deactivate_action_bar: 'Désactiver les entreprises',
    aumico_companies_bulk_create_financial_year_modal_title: 'Aperçu de la création d\'exercice',
    aumico_companies_bulk_create_financial_year_confirm: 'Créer & Confirmer',
    aumico_companies_bulk_create_financial_year_summary: '{{ready}} seront créés, {{attention}} avec particularités, {{skip}} ignorés',
    aumico_companies_bulk_create_ready: 'Prêt pour la création',
    aumico_companies_bulk_create_attention: 'Attention: Exercices décalés',
    aumico_companies_bulk_create_skipped: 'Ignorés',
    aumico_companies_bulk_create_creating_year: 'Création de {{year}}',
    aumico_companies_bulk_create_clients: 'Clients',
    aumico_companies_bulk_create_preview_failed: 'Erreur lors du chargement de l\'aperçu',
    aumico_companies_bulk_create_success: '{{created}} exercices créés avec succès, {{failed}} erreurs',
    aumico_companies_bulk_create_failed: 'Erreur lors de la création des exercices',
    aumico_companies_bulk_create_job_failed: 'La création groupée a échoué. Veuillez réessayer.',
    aumico_companies_bulk_create_processing: 'Traitement des exercices',
    aumico_companies_bulk_create_processing_status: 'Traitement de {{processed}} sur {{total}} clients...',
    aumico_companies_bulk_create_success_count: 'Réussis',
    aumico_companies_bulk_create_failure_count: 'Échoués',
    aumico_companies_bulk_create_reason_error_calculating_preview: 'Erreur lors du calcul de l\'aperçu. Contactez le support.',
    aumico_companies_bulk_create_reason_company_status_only_active:
        'Le statut de l’entreprise est \'{{status}}\'. Seules les entreprises actives peuvent créer des exercices.',
    aumico_companies_bulk_create_reason_mandate_expired:
        'Le mandat de l’entreprise a expiré le {{mandateEndDate}}. Impossible de créer un exercice pour un mandat expiré.',
    aumico_companies_bulk_create_reason_access_denied:
        'Accès refusé : vous n’êtes pas autorisé à accéder à cette entreprise.',
    aumico_companies_bulk_create_reason_error_retrieving_company_info:
        'Erreur lors de la récupération des informations de l’entreprise.  Contactez le support.',
    aumico_companies_bulk_create_reason_no_previous_project: 'Aucun projet précédent trouvé',
    aumico_companies_bulk_create_reason_previous_project_no_general_info:
        'Le projet précédent ne contient pas d’informations générales enregistrées dans son rapport annuel',
    aumico_companies_bulk_create_reason_invalid_year_range:
        'Année invalide {{nextYear}} : doit être dans une plage raisonnable ({{minYear}} à {{maxYear}})',
    aumico_companies_bulk_create_reason_invalid_date_range:
        'Plage de dates invalide : la date de début doit être antérieure à la date de fin',
    aumico_companies_bulk_create_reason_project_already_exists: 'Un projet existe déjà pour cette période',
    aumico_companies_bulk_create_reason_non_calendar_fiscal_year:
        'Exercice non calendaire (ne commence pas le 1er janvier)',
    aumico_project_overview_bulk_update_status: 'Mettre à jour le statut du projet ?',
    aumico_project_overview_bulk_update_status_label: 'Sélectionner le statut du projet',
    aumico_project_overview_bulk_update_status_placeholder: 'Choisir un nouveau statut de projet...',
    aumico_project_status_change_action_bar: 'Changer le statut du projet',
    aumico_project_delete_action_bar: 'Supprimer les projets',
    aumico_cpmm_project_status_bulk_update_success_title: 'Mise à jour réussie',
    aumico_cpmm_project_status_bulk_update_success_description: 'Le statut du projet a été mis à jour avec succès.',
    aumico_tasks_overview_bulk_edit_status_title: 'Mettre à jour le statut des tâches pour la tâche ?',
    aumico_tasks_overview_bulk_edit_status_title_plural: 'Mettre à jour le statut des tâches pour {{ count }} tâches ?',
    aumico_tasks_overview_bulk_edit_status_label: 'Sélectionner le nouveau statut des tâches',
    aumico_tasks_overview_bulk_edit_status_placeholder: 'Choisir le statut des tâches...',
    aumico_tasks_overview_bulk_edit_assignee_title: 'Changer le chargé de la tâche ?',
    aumico_tasks_overview_bulk_edit_assignee_title_plural: 'Changer le chargé de {{ count }} tâches ?',
    aumico_tasks_overview_bulk_edit_assignee_label: 'Sélectionner un nouveau chargé',
    aumico_tasks_overview_bulk_edit_assignee_placeholder: 'Choisir le chargé...',
    aumico_tasks_overview_bulk_edit_due_date_title: 'Mettre à jour la date d’échéance pour la tâche ?',
    aumico_tasks_overview_bulk_edit_due_date_title_plural: 'Mettre à jour la date d’échéance pour {{ count }} tâches ?',
    aumico_tasks_overview_bulk_edit_status_action_bar: 'Changer le statut des tâches',
    aumico_tasks_overview_bulk_edit_assignee_action_bar: 'Changer le chargé',
    aumico_tasks_overview_bulk_edit_due_date_action_bar: 'Changer la date d’échéance',
    aumico_tasks_overview_bulk_edit_delete_action_bar: 'Supprimer les tâches',
    aumico_MMCP_overview_bulk_edit_select_all: 'Tout sélectionner',
    aumico_reports_organization_settings_navigation_organization_subscription: 'Abonnement',
    aumico_components_organization_settings_subscription_org_id: "ID de l'organisation :",
    aumico_create_project_dialog_select_report_type_description: 'Type de rapport',
    aumico_create_project_dialog_select_report_type_input_placeholder: 'Sélectionner un type de rapport',
    aumico_ui_billing_downgrade_title: 'Réduire l’abonnement ?',
    aumico_ui_billing_downgrade_confirm: 'Tu es sûr·e de vouloir réduire ton abonnement ?',
    aumico_ui_billing_downgrade_warning_features_standard:
        'Tu perdras l’accès à la gestion des mandats, des tâches et aux fonctions du processus de clôture.',
    aumico_ui_billing_downgrade_warning_features_pro: 'Tu perdras l’accès aux fonctionnalités Pro.',
    aumico_ui_billing_downgrade_warning_data_loss:
        'Toutes les infos ajoutées dans ces sections pourront être restaurées si tu réactives ton abonnement.',
    aumico_ui_action_close: 'Fermer',
    aumico_ui_action_downgrade: 'Réduire l’abonnement',
    aumico_ui_billing_upgrade_title: 'Mettre à niveau l’abonnement ?',
    aumico_ui_billing_upgrade_confirm:
        'Tu es sûr·e de vouloir mettre ton abonnement à niveau ? La page va se recharger.',
    aumico_ui_action_upgrade: 'Mettre à niveau l’abonnement',
    aumico_po_report_type_filter_label: 'Type de rapport',
    aumico_po_report_type_annual: 'Comptes annuels',
    aumico_po_report_type_quarterly: 'Comptes trimestriels',
    aumico_po_report_type_monthly: 'Comptes mensuels',
    aumico_po_report_type_custom: 'Comptes individuels',
    aumico_app_cpmm_annotation_delete_confirmation: 'Tu es sûr de vouloir supprimer le commentaire "{{ comment }}" ?',
    aumico_app_cpmm_task_delete_confirmation: 'Tu es sûr de vouloir supprimer la tâche "{{ task }}" ?',
    aumico_app_cpmm_tasks_delete_confirmation: 'Tu es sûr de vouloir supprimer la tâche ?',
    aumico_app_cpmm_tasks_delete_confirmation_plural: 'Tu es sûr de vouloir supprimer les {{ count }} tâches ?',
    aumico_app_cpmm_projects_delete_confirmation: 'Tu es sûr de vouloir supprimer le projet ?',
    aumico_app_cpmm_projects_delete_confirmation_plural: 'Tu es sûr de vouloir supprimer les {{ count }} projets ?',
    aumico_app_cpmm_companies_disable_confirmation: 'Êtes-vous sûr de vouloir désactiver l’entreprise ?',
    aumico_app_cpmm_companies_disable_confirmation_plural:
        'Êtes-vous sûr de vouloir désactiver les {{ count }} entreprises ?',
    aumico_orga_settings_role_change_action_bar: 'Changer le rôle',
    aumico_users_organization_users_table_delete_action_bar: "Supprimer l'utilisateur",
    aumico_backend_errors_project_deletion_due_to_dependency:
        'Ce rapport ne peut pas être supprimé car il est utilisé comme période précédente pour d’autres rapports’',
    aumico_bulk_delete_dependency_warning_description:
        'Les projets suivants sont utilisés comme période précédente ou ont été copiés pour d’autres rapports. Voulez-vous les supprimer quand même ?',
    aumico_bulk_delete_dependency_warning_proceed: 'Oui, supprimer quand même',
    aumico_bulk_delete_dependency_warning_skip: 'Non, ignorer ceux-ci',
    aumico_file_export_section_title: 'Section',
    aumico_file_export_description_title: 'Tâche / Compte',
    aumico_file_export_document_title: 'Document',
    aumico_reports_seal_unseal_cancel_action: 'Annuler',
    aumico_company_role_change_dialog_title: 'Changer le rôle ?',
    aumico_company_role_change_dialog_select_new_role: 'Sélectionner un nouveau rôle',
    aumico_company_role_change_dialog_add_role_for_selected_tasks: 'Choisir un rôle...',
    aumico_cpmm_projects_bulk_delete_failure_title_due_to_dependency_fr:
        "Certains projets n'ont pas pu être supprimés en raison de dépendances",
    aumico_backend_errors_project_deletion_due_to_dependency_multiple_fr:
        "Certains rapports sélectionnés ne peuvent pas être supprimés, car ils sont utilisés comme période précédente pour d'autres rapports. Veuillez d'abord supprimer ces rapports dépendants ->",
    aumico_organization_settings_mandate_management_configuration_mandate_and_tasks_toggle_tooltip:
        'Si désactivé, la gestion des mandats et le workflow de clôture seront désactivés.',
    aumico_user_notifications_title: 'Notifications',
    aumico_user_notifications_mark_all_read: 'Tout marquer comme lu',
    aumico_user_notifications_mark_as_read: 'Marquer comme lu',
    aumico_user_notifications_mark_as_unread: 'Marquer comme non lu',
    aumico_user_notifications_archive: 'Archiver',
    aumico_user_notifications_unarchive: 'Désarchiver',
    aumico_user_notifications_filter: 'Filtrer les notifications',
    aumico_user_notifications_clear_filter: 'Effacer',
    aumico_user_notifications_empty: 'Aucune notification pour le moment.',
    aumico_user_notifications_loading: 'Chargement…',
    aumico_user_notifications_filter_read: 'Lu',
    aumico_user_notifications_filter_unread: 'Non lu',
    aumico_user_notifications_filter_archived: 'Archivé',
    aumico_user_notifications_today: "Aujourd'hui",
    aumico_user_notifications_last_week: 'La semaine dernière',
    aumico_user_notifications_older: 'Plus ancien',
    aumico_user_notifications_task_fallback: 'tâche',
    aumico_user_notifications_role_fallback: 'rôle',
    aumico_user_notifications_someone_fallback: "quelqu'un",
    aumico_user_notifications_due_date_fallback: "date d'échéance",
    aumico_user_notifications_company_fallback: 'une entreprise',
    aumico_user_notifications_message_task_assigned: "Nouvelle tâche {{taskName}} t'a été assignée.",
    aumico_user_notifications_message_company_assigned: 'Tu as été assigné à {{companyName}} en tant que {{role}}.',
    aumico_user_notifications_message_mention: 'Tu as été mentionné dans {{taskName}}{{companyName}} par {{user}}.',
    aumico_user_notifications_message_task_ready_review: '{{taskName}} est prête pour révision.',
    aumico_user_notifications_message_task_rejected: '{{taskName}} a été renvoyée pour révision par {{user}}.',
    aumico_user_notifications_message_deadline_approaching: '{{companyName}} : La date limite pour {{taskName}} approche le {{dueDate}}',
    aumico_user_notifications_message_default: 'Notification',
    aumico_reports_unsaved_changes_warning_dialog_discard_and_delete_project:
        'Ignorer les modifications et supprimer le projet',
    aumico_reports_unsaved_changes_and_delete_project_warning_dialog_content:
        'Vous avez des modifications non enregistrées dans le rapport. Si vous continuez, ces modifications seront perdues. Êtes-vous sûr de vouloir supprimer le projet ?',
    aumico_grouping_masking_bulk_action_unhide: 'Afficher',
    aumico_grouping_masking_bulk_action_hide: 'Masquer',
    cpmm_projects_overview_col_label: 'Libellé',
    aumico_companies_form_label_label: 'Libellé',
    aumico_companies_table_label_company_label: 'Libellé',
    aumico_grouping_masking_sort_account_btn: 'Trier les comptes',
    aumico_grouping_masking_sort_account_number_based: 'Par numéro de compte',
    aumico_grouping_masking_sort_account_name_based: 'Par nom de compte',
    aumico_annual_report_mapping_page_can_not_navigate_to_grouping_and_masking_dialog_description:
        'Vous ne pouvez pas naviguer vers la boîte de dialogue de regroupement et de masquage car les données requises sont manquantes.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_title:
        'Passer à la transmission automatique des résultats annuels',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_description:
        'Voulez-vous passer au transfert automatique du résultat annuel pour ce projet ? Toutes les données de résultat annuel précédemment saisies seront supprimées et remplacées par les données transférées automatiquement.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_info_text:
        'Votre compte ne sera pas supprimé, mais seulement retiré de ce poste financier.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirm: 'Retirer & activer',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_cancel: 'Non, annuler',
    aumico_templates_annual_profit_account_badge_text: 'Transféré Profit',
    aumico_report_previous_annual_profit_manual_entry_title: "Modifier manuellement le résultat de l'année précédente",
    aumico_report_previous_annual_profit_manual_entry_submit_text: 'Ajouter manuellement',
    aumico_report_previous_annual_profit_manual_entry_description:
        "Le bénéfice à la date de référence n'a pas été trouvé automatiquement - veuillez le saisir manuellement.",
    aumico_report_previous_annual_profit_manual_entry_balance_date: 'Date de bilan',
    aumico_report_previous_annual_profit_manual_entry_missing_profit_period: 'Résultat de la période',
    aumico_report_previous_annual_profit_manual_entry_input_label: 'Saisir le bénéfice manuellement',
    aumico_report_previous_annual_profit_manual_entry_input_placeholder: 'Ajouter le bénéfice ici manuellement',
    aumico_templates_group_account_mapping_menu_edit_profit_manually: 'Modifier le bénéfice manuellement',
    aumico_annual_report_mapping_help_automatic_transfer_toggle_text:
        'Activer le transfert automatique des résultats annuels',
    aumico_annual_report_complementary_reports_show_title_in_report_toggle: 'Afficher le nom du rapport comme titre',
    aumico_annual_report_print_options_colors_accordion_title: 'Couleurs',
    aumico_reports_print_color_reset_to_default_button: 'Réinitialiser par défaut',
    aumico_projects_release_highlights_modal_title: 'Quoi de neuf dans aumico ?',
    aumico_projects_release_highlights_modal_next: 'Suivant',
    aumico_projects_release_highlights_modal_previous: 'Précédent',
    aumico_projects_release_highlights_modal_got_it: 'Compris',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirmation_description:
        'Voulez-vous vraiment passer en mode automatique ? Votre mappage manuel pour le résultat annuel sera remplacé.',
    aumico_templates_group_account_mapping_mapping_to_profit_fli_disabled_tooltip_text:
        "La valeur est automatiquement transférée depuis le compte de résultat. Il n'est pas possible de mapper un autre compte.",
    aumico_annual_report_cash_flow_system_value_tooltip: 'Système',
    aumico_pm_tasks_filter_apply: 'Appliquer',
    aumico_reports_error_profit_fli_not_found: 'Le compte de résultat n\'a pas pu être trouvé. Veuillez vérifier vos paramètres de mappage pour le définir.',

    aumico_zefix_search_title: 'Rechercher une entreprise dans Zefix',
    aumico_zefix_search_subtitle: 'Registre du commerce suisse · Importation automatique des données',
    aumico_zefix_search_placeholder: "Saisir le nom de l'entreprise ou l'UID (p. ex. aumico ou CHE-108.814.245)…",
    aumico_zefix_uid_mode: 'Mode UID',
    aumico_zefix_results_count: '{{count}} résultat(s) dans le registre du commerce',
    aumico_zefix_no_results_title: 'Aucune entrée trouvée dans Zefix',
    aumico_zefix_no_results_reason_1: 'Entreprise individuelle sans inscription au registre du commerce',
    aumico_zefix_no_results_reason_2: 'Entreprise étrangère',
    aumico_zefix_no_results_reason_3: 'Pas encore inscrit au registre du commerce',
    aumico_zefix_no_results_reason_4: 'Faute de frappe dans le nom',
    aumico_zefix_manual_entry: "Saisir l'entreprise manuellement",
    aumico_zefix_imported_banner: 'importé depuis Zefix — vérifiez les champs et enregistrez.',
    aumico_zefix_save_button: 'Vérifier les champs & Enregistrer',
    aumico_zefix_refresh_button: 'Actualiser',
    aumico_zefix_new_search: 'Nouvelle recherche',
    aumico_zefix_badge: '✓ Zefix',
    aumico_zefix_unavailable: 'Zefix est actuellement indisponible. Veuillez saisir les champs manuellement.',
    aumico_zefix_diff_title: 'Comparaison Zefix',
    aumico_zefix_diff_field: 'Champ',
    aumico_zefix_diff_current: 'Actuel',
    aumico_zefix_diff_new: 'Zefix (nouveau)',
    aumico_zefix_diff_no_changes: 'Toutes les données sont à jour — aucune modification trouvée.',
    aumico_zefix_diff_apply_all: 'Tout appliquer',
    aumico_zefix_status_in_liquidation: 'En liquidation',
    aumico_zefix_status_cancelled: 'Radié',
    aumico_zefix_field_name: 'Raison sociale',
    aumico_zefix_field_legalform: 'Forme juridique',
    aumico_zefix_field_street: 'Rue',
    aumico_zefix_field_zip: 'Code postal',
    aumico_zefix_field_city: 'Localité',
    aumico_zefix_field_uid: 'IDE',
    // AI Fixer Panel
    aumico_ai_fixer_panel_title: 'DATEV AI Fixer',
    aumico_ai_fixer_panel_description: "Laisse l'agent IA analyser et corriger automatiquement les problèmes de structure.",
    aumico_ai_fixer_panel_start_btn: 'Lancer la correction IA',
    aumico_ai_fixer_panel_running_title: "L'IA travaille…",
    aumico_ai_fixer_panel_completed_title: 'Correction IA terminée',
    aumico_ai_fixer_panel_accept_btn: 'Accepter',
    aumico_ai_fixer_panel_reject_btn: 'Refuser',
    aumico_ai_fixer_panel_failed_title: 'Échec de la correction IA',
    aumico_ai_fixer_panel_unknown_error: 'Une erreur inconnue s\'est produite.',
    aumico_ai_fixer_panel_retry_btn: 'Réessayer',
    aumico_ai_fixer_panel_cancel_btn: 'Annuler',

    // AI Fixer Progress
    aumico_ai_fixer_progress_step: 'étape',
    aumico_ai_fixer_progress_steps: 'étapes',

    // Taxonomy Preview Dialog
    aumico_ai_taxonomy_preview_title: 'Aperçu de la taxonomie — Correction IA',
    aumico_ai_taxonomy_preview_no_entries: 'Aucune entrée dans cette section.',
    aumico_ai_taxonomy_preview_chat_placeholder: "Demande à l'IA d'ajuster la structure de la taxonomie…",
    aumico_ai_taxonomy_preview_agent_working: "L'agent travaille…",
    aumico_ai_taxonomy_preview_chat_you: 'Toi',
    aumico_ai_taxonomy_preview_chat_ai: 'IA',
    aumico_ai_taxonomy_preview_type_message: 'Écris un message…',
    aumico_ai_taxonomy_preview_close: 'Fermer',
    aumico_ai_taxonomy_preview_send: 'Envoyer',
    aumico_ai_taxonomy_preview_btn_preview: '🔍 Aperçu de la structure',
    aumico_ai_taxonomy_preview_tree_updated: '✓ Structure mise à jour',

    // Taxonomy section labels
    aumico_ai_taxonomy_section_assets: 'Bilan — Actif',
    aumico_ai_taxonomy_section_liabilities: 'Bilan — Passif',
    aumico_ai_taxonomy_section_income: 'Compte de résultat',

    // Node classification display names
    aumico_ai_classification_fli: 'Poste',
    aumico_ai_classification_group: 'Groupe',
    aumico_ai_classification_hidden_group: 'Retrait',
    aumico_ai_classification_sum: 'Sous-total',
    aumico_ai_classification_of_that_item: 'Dont-poste',
    aumico_ai_classification_x_fli: 'Poste supplémentaire',
    aumico_ai_classification_sub_fli: 'Sous-poste',
    aumico_ai_classification_title: 'Titre',
    aumico_ai_classification_remove: 'Supprimer',
    aumico_ai_classification_unknown: 'Inconnu',
    aumico_ai_fixed_badge: '✅ Corrigé avec l\'IA',






    aumico_cover_page_draft_label: 'Brouillon',
    aumico_seal_banner_draft_title: 'Ce rapport n\'est pas encore scellé',
    aumico_seal_banner_draft_sub: 'Tous les exports incluront la mention « Brouillon » jusqu\'à ce qu\'ils soient scellés',
    aumico_seal_banner_sealed_title: 'Rapport scellé',
    aumico_seal_banner_sealed_sub: 'Scellé le {{date}} par {{user}}',
    aumico_seal_banner_audit_log: 'Journal d\'audit',
    aumico_seal_banner_unseal: 'Desceller',
    aumico_annual_report_unseal_warning: 'Desceller ce rapport peut entraîner des incohérences s\'il a déjà été partagé avec les parties prenantes. Voulez-vous continuer ?',

    // MFA - Setup Flow
    aumico_mfa_loading: 'Chargement...',
    aumico_mfa_setup_step1_title: 'Configurer l\'authentification à deux facteurs',
    aumico_mfa_setup_step1_description: 'Scannez le code QR ci-dessous avec votre application d\'authentification (ex. Google Authenticator, Authy).',
    aumico_mfa_setup_step1_manual_key: 'Ou entrez cette clé manuellement :',
    aumico_mfa_setup_step1_countdown_label: 'Nouveau code dans :',
    aumico_mfa_setup_step1_continue_button: 'Suivant',
    aumico_mfa_setup_step2_title: 'Vérifier votre application',
    aumico_mfa_setup_step2_description: 'Entrez le code à 6 chiffres de votre application d\'authentification pour confirmer la configuration.',
    aumico_mfa_setup_step2_code_label: 'Code d\'authentification',
    aumico_mfa_setup_step2_code_placeholder: 'Entrez le code à 6 chiffres',
    aumico_mfa_setup_step2_verify_button: 'Suivant',
    aumico_mfa_setup_step3_title: 'Enregistrer vos codes de sauvegarde',
    aumico_mfa_setup_step3_description: 'Enregistrez ces codes de sauvegarde en lieu sûr. Ils peuvent être utilisés pour accéder à votre compte si vous perdez votre appareil.',
    aumico_mfa_setup_step3_download_button: 'Télécharger',
    aumico_mfa_setup_step3_continue_button: 'Continuer',
    aumico_mfa_setup_error_initiate: 'Échec de l\'initialisation 2FA. Veuillez réessayer.',
    aumico_mfa_setup_error_invalid_code: 'Code invalide. Veuillez vérifier votre application d\'authentification.',
    aumico_mfa_setup_stepper_scan_qr: 'Scanner QR',
    aumico_mfa_setup_stepper_verify: 'Vérifier',
    aumico_mfa_setup_stepper_backup_codes: 'Codes de secours',
    aumico_mfa_setup_step1_app_hint: 'Google Authenticator, Authy ou toute application compatible TOTP',
    aumico_mfa_setup_step2_back_button: 'Retour',
    aumico_mfa_setup_step2_hint: 'Entrez le code de vérification à 6 chiffres',
    aumico_mfa_setup_footer: 'Votre organisation exige le 2FA. Il s\'agit d\'une configuration unique.',

    // MFA - Verify Flow (Login)
    aumico_mfa_verify_title: 'Authentification à deux facteurs',
    aumico_mfa_verify_description: 'Entrez le code à 6 chiffres de votre application d\'authentification.',
    aumico_mfa_verify_code_label: 'Code d\'authentification',
    aumico_mfa_verify_code_placeholder: 'Entrez le code à 6 chiffres',
    aumico_mfa_verify_backup_description: 'Entrez l\'un de vos codes de sauvegarde.',
    aumico_mfa_verify_backup_code_label: 'Code de sauvegarde',
    aumico_mfa_verify_backup_code_placeholder: 'Entrez le code de sauvegarde',
    aumico_mfa_verify_submit_button: 'Vérifier',
    aumico_mfa_verify_use_backup_code: 'Utiliser un code de sauvegarde',
    aumico_mfa_verify_use_totp_code: 'Utiliser l\'application d\'authentification',
    aumico_mfa_verify_error_invalid_code: 'Code invalide. Veuillez réessayer.',

    // MFA - Organization Settings
    aumico_mfa_org_toggle_title: 'Authentification à deux facteurs',
    aumico_mfa_org_toggle_description: 'Exiger que tous les utilisateurs de votre organisation configurent l\'authentification à deux facteurs.',
    aumico_mfa_org_toggle_description_detail: 'Le 2FA renforce la sécurité en nécessitant à la fois un mot de passe et un code de vérification basé sur le temps généré par l\'application Google Authenticator.',
    aumico_mfa_org_status_enabled: '2FA activé',
    aumico_mfa_org_status_disabled: '2FA désactivé',
    aumico_mfa_org_enable_button: 'Activer 2FA',
    aumico_mfa_org_disable_button: 'Désactiver 2FA',
    aumico_mfa_org_users_title: 'Statut MFA des utilisateurs',
    aumico_mfa_org_users_col_name: 'Nom',
    aumico_mfa_org_users_col_email: 'Email',
    aumico_mfa_org_users_col_status: 'Statut MFA',
    aumico_mfa_org_users_col_actions: 'Actions',
    aumico_mfa_org_users_col_enabled_at: 'Activé le',
    aumico_mfa_org_users_status_complete: 'Activé',
    aumico_mfa_org_users_status_pending: 'Non activé',
    aumico_mfa_org_users_reset_button: 'Réinitialiser MFA',
    aumico_mfa_org_notification_success_title: 'Succès',
    aumico_mfa_org_notification_error_title: 'Erreur',
    aumico_mfa_org_enable_success: '2FA a été activé pour votre organisation.',
    aumico_mfa_org_enable_error: 'Échec de l\'activation 2FA. Veuillez réessayer.',
    aumico_mfa_org_disable_success: '2FA a été désactivé pour votre organisation.',
    aumico_mfa_org_disable_error: 'Échec de la désactivation 2FA. Veuillez réessayer.',
    aumico_mfa_org_reset_user_success: 'MFA a été réinitialisé pour l\'utilisateur.',
    aumico_mfa_org_reset_user_error: 'Échec de la réinitialisation MFA. Veuillez réessayer.',
    aumico_mfa_org_enforce_button: 'Activer l\'authentification à 2 facteurs',
    aumico_mfa_org_enforce_button_tooltip: 'Attention : vous serez déconnecté immédiatement\npour configurer l\'authentification à deux facteurs.',
    aumico_mfa_org_disable_toggle_tooltip: 'La désactivation réinitialise la configuration MFA de tous les utilisateurs.',

    // MFA - Navigation
    aumico_reports_organization_navigation_2fa: 'Auth. à deux facteurs',
    aumico_reports_organization_settings_navigation_ai_settings: 'Paramètres IA',
    aumico_ai_settings_loading: 'Chargement des paramètres IA...',
    aumico_ai_settings_description: 'Active ou désactive les fonctionnalités IA pour ton organisation.',
    aumico_ai_settings_master_title: 'Activer les fonctionnalités IA',
    aumico_ai_settings_master_description: 'Active toutes les fonctionnalités IA pour ton organisation. Tu acceptes d\'abord les conditions d\'utilisation.',
    aumico_ai_settings_master_agb_empty: '(Aucun texte de CGU enregistré. Contacte ton administrateur.)',
    aumico_ai_settings_daily_usage: 'Consommé aujourd\'hui',
    aumico_ai_settings_monthly_usage: 'Consommé ce mois-ci',
    aumico_ai_settings_tokens: 'jetons',
    aumico_ai_settings_title: 'Fonctionnalités IA',
    aumico_ai_settings_status_active: 'Actif',
    aumico_ai_settings_status_inactive: 'Inactif',
    aumico_ai_settings_hero_headline: 'Une aide intelligente pour ta comptabilité',
    aumico_ai_settings_hero_sub: 'Les fonctionnalités IA analysent tes données directement dans l\'application. Traitées en toute sécurité dans l\'UE, jamais utilisées pour entraîner le modèle.',
    aumico_ai_settings_usage_title: 'Consommation de jetons',
    aumico_ai_settings_master_short_description: 'Active toutes les fonctionnalités IA pour ton organisation.',
    aumico_ai_settings_agents_title: 'Fonctionnalités IA disponibles',
    aumico_ai_settings_wip_label: 'En cours',
    aumico_ai_settings_wip_headline: 'Nous développons aumico IA en continu',
    aumico_ai_settings_wip_text: 'L\'infrastructure est en place. Nous investissons fortement dans de nouvelles fonctionnalités.',
    aumico_ai_settings_agent_available: 'Disponible',
    aumico_ai_settings_agent_soon: 'Bientôt disponible',
    aumico_ai_settings_agent_more_title: 'D\'autres fonctionnalités suivront',
    aumico_ai_settings_agent_more_text: 'Les nouvelles fonctionnalités apparaissent ici dès qu\'elles sont disponibles. Reste à l\'écoute.',
    aumico_ai_settings_feature_closing_title: 'Processus de clôture avec l\'IA',
    aumico_ai_settings_feature_closing_text: 'T\'accompagne dans la clôture annuelle : lit tes justificatifs, les attribue aux comptes et propose des rapprochements.',
    aumico_ai_settings_feature_translate_title: 'Traduire un rapport',
    aumico_ai_settings_feature_translate_text: 'Traduit un rapport dans une autre langue.',
    aumico_ai_settings_feature_datev_title: 'Réparer l\'import DATEV',
    aumico_ai_settings_feature_datev_text: 'Répare la hiérarchie des comptes d\'un import DATEV.',
    aumico_ai_settings_resets_daily: 'Se réinitialise à minuit',
    aumico_ai_settings_resets_monthly: 'Se réinitialise le 1er du mois',
    aumico_ai_settings_info_blocked: 'Lorsqu\'une limite est atteinte, les requêtes IA suivantes sont bloquées automatiquement.',
    aumico_ai_settings_info_agb: 'Lorsque les CGU sont mises à jour, tu les acceptes à nouveau.',
    aumico_ai_settings_load_error: 'Impossible de charger les paramètres IA.',
    aumico_ai_settings_notification_success_title: 'Paramètre enregistré',
    aumico_ai_settings_notification_enabled: 'Les fonctionnalités IA ont été activées.',
    aumico_ai_settings_notification_disabled: 'Les fonctionnalités IA ont été désactivées.',
    aumico_ai_settings_notification_error_title: 'Erreur',
    aumico_ai_settings_notification_error: 'Impossible d\'enregistrer le paramètre.',
    aumico_ai_settings_notification_version_changed: 'Les conditions d\'utilisation ont été mises à jour. Lis et accepte les nouvelles conditions.',
    aumico_ai_settings_acceptance_intro: 'Lis attentivement les conditions d\'utilisation suivantes avant d\'activer les fonctionnalités IA :',
    aumico_ai_settings_acceptance_disclaimer: 'En cliquant sur « Accepter et activer », tu confirmes avoir lu les conditions et consentir au traitement des données. Tu peux désactiver les fonctionnalités IA à tout moment.',
    aumico_ai_settings_acceptance_accept: 'Accepter et activer',
    aumico_ai_settings_acceptance_decline: 'Refuser',
    aumico_reports_main_navigation_company_integrations: 'Intégrations',
    aumico_companies_integrations_section_available: 'Disponible',
    aumico_companies_integrations_section_coming_soon: 'Prochainement',
    aumico_companies_integrations_btn_connecting: 'Connexion...',
    aumico_companies_integrations_status_connected: 'Connecté',
    aumico_companies_integrations_status_connected_since: 'depuis',
    aumico_companies_integrations_btn_disconnect: 'Déconnecter',
    aumico_companies_integrations_status_expired: 'Connexion expirée',
    aumico_companies_integrations_btn_reconnect: 'Reconnecter',
    aumico_companies_integrations_btn_connect: 'Connecter',
    aumico_companies_integrations_btn_sync_data: 'Synchroniser les données',
    aumico_companies_integrations_sync_never: 'Pas encore synchronisé',
    aumico_companies_integrations_sync_no_matching_year: 'Aucun exercice comptable correspondant trouvé',
    aumico_companies_integrations_sync_last: 'Dernière synchronisation le',
    aumico_companies_integrations_btn_submit_request: 'Demander une intégration',
    aumico_companies_integrations_btn_request: 'Demander',
    aumico_companies_integrations_bexio_description: 'Importe les données de comptes et les écritures de journal directement depuis Bexio.',
    aumico_companies_integrations_placeholder_name: 'Bientôt disponible',
    aumico_companies_integrations_placeholder_description: 'Nous travaillons en permanence sur de nouvelles intégrations.',
    aumico_companies_integrations_request_modal_title: 'Demander une intégration',
    aumico_companies_integrations_request_modal_label: 'Quel logiciel recherchez-vous ?',
    aumico_companies_integrations_request_modal_message_label: 'Notes supplémentaires (optionnel)',
    aumico_companies_integrations_request_modal_message_placeholder: 'Parlez-nous de vos besoins...',
    aumico_companies_integrations_request_topal: 'Topal',
    aumico_companies_integrations_request_abacus: 'Abacus',
    aumico_companies_integrations_request_infoniqa: 'Infoniqa',
    aumico_companies_integrations_request_other: 'Autre',
    aumico_companies_integrations_leaderboard_title: 'Classement des intégrations',
    aumico_companies_integrations_leaderboard_subtitle: 'Votez pour la prochaine intégration que vous souhaitez.',
    aumico_companies_integrations_votes_label: 'votes',
    aumico_companies_integrations_btn_upvote: 'Voter',
    aumico_companies_integrations_btn_voted: 'Voté',
    aumico_companies_integrations_name_bexio: 'Bexio',
    aumico_companies_integrations_name_topal: 'Topal',
    aumico_companies_integrations_name_abacus: 'Abacus',
    aumico_companies_integrations_name_accounto: 'Accounto',
    aumico_companies_integrations_name_infoniqa50: 'Infoniqa 50',
    aumico_companies_integrations_name_infoniqa200: 'Infoniqa 200',
    aumico_companies_integrations_name_xero: 'Xero',
    aumico_companies_integrations_name_klara: 'Klara',
    aumico_companies_integrations_name_banana: 'Banana',
    aumico_companies_integrations_name_atlanto: 'Atlanto',
    aumico_companies_integrations_name_proffix: 'PROFFIX',
    aumico_companies_integrations_name_infoniqaonestart: 'Infoniqa One Start',
    aumico_companies_integrations_name_odoo: 'Odoo',
    aumico_companies_integrations_name_dynamics365businesscentral: 'Dynamics 365 Business Central',
    aumico_companies_integrations_suggestion_cta_text: 'Votre intégration souhaitée n\'est pas encore dans la liste ? Partagez-la avec nous et nous l\'ajouterons au classement.',
    aumico_companies_integrations_suggestion_cta_button: 'Partager une intégration souhaitée',
    aumico_companies_integrations_vote_modal_title: 'Voter pour une intégration',
    aumico_companies_integrations_vote_modal_submit: 'Envoyer le vote',
    aumico_companies_integrations_vote_modal_hint: 'Avant d\'enregistrer votre vote, vous pouvez indiquer pourquoi cette intégration est importante. Ce contexte est utilisé en interne pour la priorisation.',
    aumico_companies_integrations_vote_modal_label: 'Contexte optionnel',
    aumico_companies_integrations_vote_modal_placeholder: 'Pourquoi cette intégration est-elle importante pour votre équipe ? (optionnel)',
    aumico_companies_integrations_suggestion_modal_title: 'Suggérer une nouvelle intégration',
    aumico_companies_integrations_suggestion_modal_hint: 'Partagez l\'intégration souhaitée et un contexte optionnel. Nous examinons ces propositions et les ajoutons au classement.',
    aumico_companies_integrations_suggestion_modal_label: 'Votre souhait d\'intégration',
    aumico_companies_integrations_suggestion_modal_placeholder: 'Exemple : Lexoffice. Contexte optionnel : utilisé par la majorité de nos clients.',
    bexio_import_title: 'Import Bexio',
    bexio_status_connected: 'Connecté',
    bexio_status_expired: 'Connexion expirée',
    bexio_loading_business_years: 'Chargement des exercices...',
    bexio_import_period: 'Période',
    bexio_no_matching_year: 'Aucun exercice correspondant à la date du bilan.',
    bexio_no_business_years: 'Aucun exercice trouvé dans Bexio.',
    bexio_import_data: 'Importer les données',
    bexio_importing: 'Importation...',
    bexio_import_manual: 'Télécharger manuellement',
    bexio_import_success: 'Import réussi',
    bexio_resync: 'Resynchroniser',
    bexio_accounts: 'comptes',
    bexio_entries: 'écritures',
    bexio_import_error: "L'import a échoué. Veuillez réessayer.",
    bexio_expired_nudge: 'La connexion Bexio a expiré. Reconnecte-toi dans le profil de l\'entreprise.',
    bexio_connect_nudge: 'Astuce : Connecte Bexio dans le profil de l\'entreprise pour importer automatiquement.',
    bexio_importing_title: 'Importation en cours',
    bexio_importing_subtitle: 'Tes données sont en cours de récupération',
    bexio_importing_hint: 'Cela ne prendra que quelques secondes',
    bexio_summary_title: "Résumé de l'import",
    bexio_summary_overview: 'Résumé',
    bexio_summary_company: 'Entreprise',
    bexio_summary_period: 'Période',
    bexio_summary_previous_period: "Période de l'année précédente",
    bexio_summary_accounts: 'Comptes',
    bexio_summary_continue: 'Continuer vers la mise en correspondance',
    bexio_summary_discard: 'Abandonner',
    bexio_summary_validation_title: 'Validation',
    bexio_summary_balance_check: 'Contrôle du bilan',
    bexio_summary_current_year: 'Année en cours',
    bexio_summary_previous_year: 'Année précédente',
    bexio_summary_assets: 'Actifs',
    bexio_summary_liabilities: 'Passifs',
    bexio_summary_net_income: 'Résultat de l\'exercice',
    d365bc_importing_title: 'Importation des données',
    d365bc_importing_subtitle: 'Récupération de tes données comptables depuis Business Central',
    d365bc_importing_hint: 'Cela ne prend qu\'un instant',
    d365bc_summary_title: 'Résumé de l\'import',
    d365bc_summary_overview: 'Aperçu',
    d365bc_summary_company: 'Entreprise',
    d365bc_summary_period: 'Période',
    d365bc_summary_previous_period: 'Période précédente',
    d365bc_summary_accounts: 'Comptes',
    d365bc_summary_continue: 'Continuer vers la mise en correspondance',
    d365bc_summary_discard: 'Annuler',
    d365bc_summary_validation_title: 'Validation',
    d365bc_summary_balance_check: 'Vérification de bilan',
    d365bc_summary_current_year: 'Année en cours',
    d365bc_summary_previous_year: 'Année précédente',
    d365bc_summary_assets: 'Actifs',
    d365bc_summary_liabilities: 'Passifs',
    topal_importing_title: 'Importation des données',
    topal_importing_subtitle: 'Récupération de tes données comptables depuis Topal',
    topal_importing_hint: 'Cela ne prend qu\'un instant',
    topal_summary_title: 'Résumé de l\'import',
    topal_summary_overview: 'Aperçu',
    topal_summary_company: 'Entreprise',
    topal_summary_period: 'Période',
    topal_summary_previous_period: 'Période précédente',
    topal_summary_accounts: 'Comptes',
    topal_summary_continue: 'Continuer vers la mise en correspondance',
    topal_summary_discard: 'Annuler',
    topal_summary_validation_title: 'Validation',
    topal_summary_balance_check: 'Vérification de bilan',
    topal_summary_current_year: 'Année en cours',
    topal_summary_previous_year: 'Année précédente',
    topal_summary_assets: 'Actifs',
    topal_summary_liabilities: 'Passifs',
    topal_import_failed_title: 'Échec de l’importation',
    topal_import_failed_description: 'L’importation Topal a échoué. Veuillez réessayer plus tard.',
    topal_import_no_fiscal_year_description:
        'Aucune donnée comptable Topal n’est disponible pour la période sélectionnée. Veuillez vérifier la période et la date de clôture du rapport, puis réessayer.',
    d365bc_summary_unmappable_accounts:
        "{{count}} compte(s) n'ont pu être affectés ni au bilan ni au compte de résultat et sont donc absents du rapport : {{accounts}}.<br>Renseigne la catégorie de compte pour ces comptes dans Business Central, puis synchronise à nouveau.",
    abacus_importing_title: 'Importation des données',
    abacus_importing_subtitle: 'Récupération de tes données comptables depuis Abacus',
    abacus_importing_hint: 'Cela ne prend qu\'un instant',
    abacus_summary_title: 'Résumé de l\'import',
    abacus_summary_overview: 'Aperçu',
    abacus_summary_company: 'Entreprise',
    abacus_summary_period: 'Période',
    abacus_summary_previous_period: 'Période précédente',
    abacus_summary_accounts: 'Comptes',
    abacus_summary_continue: 'Continuer vers la mise en correspondance',
    abacus_summary_discard: 'Annuler',
    abacus_summary_validation_title: 'Validation',
    abacus_summary_balance_check: 'Vérification de bilan',
    abacus_summary_current_year: 'Année en cours',
    abacus_summary_previous_year: 'Année précédente',
    abacus_summary_assets: 'Actifs',
    abacus_summary_liabilities: 'Passifs',
    abacus_summary_unmappable_accounts:
        "{{count}} compte(s) n'ont pu être affectés ni au bilan ni au compte de résultat et sont donc absents du rapport : {{accounts}}.<br>Renseigne la classe de compte pour ces comptes dans Abacus, puis synchronise à nouveau.",
    aumico_bexio_connect_success_title: 'Bexio connecté',
    aumico_bexio_connect_success_description: 'Votre compte Bexio a été connecté avec succès.',
    aumico_bexio_connect_failure_title: 'Connexion échouée',
    aumico_bexio_connect_failure_description: 'Impossible de connecter votre compte Bexio. Veuillez réessayer.',
    aumico_bexio_disconnect_success_title: 'Bexio déconnecté',
    aumico_bexio_disconnect_success_description: 'Votre compte Bexio a été déconnecté.',
    aumico_bexio_disconnect_failure_title: 'Déconnexion échouée',
    aumico_bexio_disconnect_failure_description: 'Impossible de déconnecter votre compte Bexio. Veuillez réessayer.',

    // CCR – Réserves issues d'apports en capital (KER)
    aumico_annual_report_ccr_description: "Réserves issues d'apports en capital",
    aumico_annual_report_ccr_beginning_of_year: "Total des réserves issues d'apports en capital au début de l'exercice",
    aumico_annual_report_ccr_end_of_year: "Total des réserves issues d'apports en capital à la fin de l'exercice",
    aumico_annual_report_ccr_select_account: 'Sélectionner un compte de capitaux propres',
    aumico_annual_report_ccr_add_new_item: 'Ajouter un élément',
    aumico_annual_report_ccr_enter_text: 'Entrer du texte',
    aumico_annual_report_ccr_enter_value: 'Entrer un montant',
    aumico_annual_report_ccr_toggle_show: "Afficher les réserves issues d'apports en capital",
    aumico_annual_report_ccr_toggle_hide: "Masquer les réserves issues d'apports en capital",
    aumico_annual_report_ccr_diff_prior: 'Différence exercice précédent',
    aumico_annual_report_ccr_diff_cur: "Différence ouverte exercice en cours",
    aumico_annual_report_ccr_add_comment: 'Ajouter un commentaire',
    aumico_annual_report_ccr_remove_comment_confirm: 'Voulez-vous vraiment supprimer le commentaire ? Tout le contenu de la note de bas de page sera supprimé.',
    aumico_reports_main_navigation_company_analytics: 'Analytique',
    aumico_analytics_empty_state_title: 'Aucune donnée pour le moment',
    aumico_analytics_empty_state_subtitle: "Créez un projet pour ce mandant afin d'activer la comparaison pluriannuelle.",
    aumico_analytics_empty_state_cta: 'Créer le premier projet',
    aumico_analytics_load_failed_message: "Les données n'ont pas pu être chargées. Veuillez recharger la page.",
    aumico_analytics_controls_delta_pct: '% A/A',
    aumico_analytics_controls_delta_chf: 'CHF A/A',
    aumico_analytics_controls_scope_balance: 'Bilan',
    aumico_analytics_controls_scope_income: 'Compte de résultat',
    aumico_analytics_controls_struct_mode: 'Analyse en pourcentage',
    aumico_analytics_controls_struct_mode_tooltip: "Chaque poste en % de la valeur de référence (produit d'exploitation / total actifs / total passifs)",
    aumico_analytics_controls_struct_mode_no_reference_tooltip: 'Aucune valeur de référence définie — analyse en pourcentage non disponible.',
    aumico_analytics_a11y_year_pill_toggle: "Activer/désactiver l'année {{year}}",
    aumico_analytics_table_label_column: 'Désignation',
    aumico_analytics_table_struct_column: '%',
    aumico_analytics_table_delta_column: 'Total Δ',
    aumico_analytics_table_empty_after_filter: 'Aucune position disponible.',
    aumico_analytics_currency_mismatch_banner: 'Note: Ces projets utilisent des devises différentes ({{currencies}}). Les valeurs sont affichées sans conversion.',
    aumico_pdf_my_table_delta_label: "Total Δ",
    aumico_pdf_my_export_button: "Exporter PDF",
    aumico_pdf_my_export_button_pending: "Génération du PDF …",
    aumico_pdf_my_export_failure_title: "Échec de l'export",
    aumico_pdf_my_export_failure_description: "L'export n'a pas pu être finalisé. Veuillez réessayer.",
    aumico_pdf_my_export_modal_title: "Exporter PDF",
    aumico_pdf_my_export_modal_subtitle: "Choisissez les postes à inclure dans le PDF.",
    aumico_pdf_my_export_modal_select_all: "Tout sélectionner",
    aumico_pdf_my_export_modal_deselect_all: "Tout désélectionner",
    aumico_pdf_my_export_modal_select_groups: "Tous les groupes",
    aumico_pdf_my_export_modal_select_subtotals: "Tous les sous-totaux",
    aumico_pdf_my_language_modal_title: "Choisir la langue",
    aumico_pdf_my_language_modal_subtitle: "Cette entreprise possède des rapports dans plusieurs langues. Dans quelle langue le comparatif pluriannuel doit-il être créé ?",
    aumico_pdf_my_language_modal_cancel: "Annuler",
    aumico_pdf_my_language_modal_confirm: "Appliquer",
    aumico_pdf_my_language_modal_count_singular: "rapport",
    aumico_pdf_my_language_modal_count_plural: "rapports",
    aumico_pdf_my_export_modal_cancel: "Annuler",
    aumico_pdf_my_export_modal_confirm: "Exporter",
    aumico_ai_fixer_panel_beta_label: 'Beta',
    aumico_ai_fixer_panel_bullet_analyse: 'Analyse automatiquement la structure de votre bilan et compte de résultat.',
    aumico_ai_fixer_panel_bullet_review: 'Vous gardez le contrôle et examinez le résultat avant de l\'accepter.',
    aumico_ai_fixer_panel_bullet_revert: 'Vous pouvez annuler les modifications à tout moment.',
    aumico_ai_error_features_not_enabled: 'Les fonctionnalités IA ne sont pas activées pour votre organisation. Veuillez les activer dans les paramètres IA.',
    aumico_ai_error_daily_limit_reached: 'La limite quotidienne de jetons de {{limit}} a été atteinte. Veuillez réessayer demain.',
    aumico_ai_error_monthly_limit_reached: 'La limite mensuelle de jetons de {{limit}} a été atteinte. Veuillez réessayer le mois prochain.',
    aumico_ai_error_session_not_found: 'Session IA introuvable.',
    aumico_ai_error_chat_in_progress: 'Une discussion est déjà en cours pour cette session. Veuillez patienter jusqu\'à ce qu\'elle se termine.',
    aumico_ai_error_invalid_payload: 'Entrée invalide pour l\'agent IA.',
    aumico_ai_error_agent_timeout: 'L\'agent IA a dépassé le délai de {{seconds}} secondes.',
    aumico_ai_error_chat_processing: 'Une erreur s\'est produite lors du traitement de votre message. Veuillez réessayer.',
    aumico_ai_error_unknown: 'Erreur inconnue lors du traitement IA.',
    // Clé plate, car le backend l'envoie ainsi (`orchestrator.handler.ts:parse()`) : une exécution
    // refusée doit DIRE quel champ ne convient pas, sinon il ne reste qu'une « erreur inconnue ».
    abcp_error_invalid_run_payload:
        "L'exécution a été refusée : la requête ne correspond pas au contrat de l'agent de clôture. Champs concernés : {{fields}}.",
    aumico_ai_progress_section_processing: 'Analyse de la section "{{sectionKey}}"…',
    aumico_ai_progress_section_already_valid: 'La section "{{sectionKey}}" est déjà valide.',
    aumico_ai_progress_section_fixed: 'Section "{{sectionKey}}" corrigée avec succès.',
    aumico_ai_progress_section_with_errors: 'Section "{{sectionKey}}" terminée avec {{errorCount}} erreur(s) restante(s).',
    aumico_ai_progress_section_timeout: 'La section "{{sectionKey}}" a dépassé le délai de {{seconds}}s.',
    aumico_ai_progress_chat_started: 'Traitement de votre message sur {{count}} section(s)…',
    aumico_ai_progress_chat_section_start: 'Analyse de la section "{{sectionKey}}"…',
    aumico_ai_progress_chat_section_complete: 'Section "{{sectionKey}}" : {{toolCallCount}} action(s), {{remainingErrors}} erreur(s) restante(s).',
    aumico_ai_progress_chat_section_no_changes: 'Section "{{sectionKey}}" : aucune modification nécessaire.',
    aumico_ai_progress_chat_section_timeout: 'La section "{{sectionKey}}" a dépassé le délai de {{seconds}}s.',
    aumico_ai_progress_tool_call: '[{{sectionKey}}] {{toolName}}',
    aumico_ai_progress_tool_call_with_errors: '[{{sectionKey}}] {{toolName}} → {{remainingErrors}} erreur(s) restante(s)',
    aumico_ai_chat_reply_no_output: 'Aucun résultat disponible à modifier. Veuillez d\'abord exécuter la correction IA.',
    aumico_ai_chat_reply_default: 'J\'ai traité votre demande. Veuillez examiner la structure mise à jour.',
    aumico_integrations_page_title: 'Intégrations',
    aumico_integrations_section_available: 'Intégrations disponibles',
    aumico_reports_organization_settings_navigation_integrations: 'Intégrations',
    aumico_integration_card_btn_connect: 'Connecter',
    aumico_integration_card_btn_disconnect: 'Déconnecter',
    aumico_integration_card_btn_test: 'Tester',
    aumico_integration_card_status_connected: 'Connecté',
    aumico_integration_card_status_error: 'Erreur',
    aumico_integration_card_status_expired: 'Expiré',
    aumico_integration_card_status_disconnected: 'Non connecté',
    aumico_integration_card_status_connecting: 'Connexion ...',
    aumico_integration_card_btn_reconnect: 'Reconnecter',
    aumico_integration_d365bc_displayname: 'Dynamics 365 Business Central',
    aumico_integration_d365bc_description: 'Importe les données de comptes et les écritures de journal directement depuis Business Central.',
    aumico_d365bc_connect_modal_title: 'Connecter Dynamics 365 Business Central',
    aumico_d365bc_step_welcome_intro: 'Tu vas être redirigé vers Microsoft pour autoriser aumico à accéder à ton Business Central.',
    aumico_d365bc_step_welcome_signin_button: 'Se connecter avec Microsoft',
    aumico_d365bc_step_setup_title: 'Dernière étape — configure dans ton BC',
    aumico_d365bc_step_setup_tenant_connected: 'Connecté avec Microsoft',
    aumico_d365bc_step_setup_step1: 'Ouvre le client web Business Central',
    aumico_d365bc_step_setup_step2: 'Cherche "Microsoft Entra applications"',
    aumico_d365bc_step_setup_step3_clientid: 'Saisis le Client ID',
    aumico_d365bc_step_setup_step4_state: 'Mets State = Enabled',
    aumico_d365bc_step_setup_step5_permission: 'Attribue le Permission Set "D365 READ"',
    aumico_d365bc_step_config_environment_label: 'Nom de l\'environnement BC',
    aumico_d365bc_step_config_environment_help: 'Généralement "production". À modifier seulement si ton BC porte un autre nom.',
    aumico_d365bc_step_config_displayname_help: 'Champ obligatoire. T\'aide à distinguer plusieurs tenants BC dans l\'aperçu.',
    aumico_d365bc_status_awaiting_consent: 'En attente de la connexion Microsoft ...',
    aumico_d365bc_status_creating: 'Création de la connexion ...',
    aumico_d365bc_status_success: 'Connexion établie avec succès',
    aumico_d365bc_status_success_next_mapping: 'À l\'étape suivante, tu associes tes companies.',
    aumico_mapping_modal_title: 'Associer les companies',
    aumico_mapping_currently_mapped_to: 'Actuellement associée à :',
    aumico_mapping_aumico_company_label: 'Company aumico',
    aumico_button_change: 'Modifier',
    aumico_mapping_loading: 'Chargement des suggestions ...',
    aumico_mapping_vendor_company_label: 'Company BC',
    aumico_mapping_search_placeholder: 'Saisir un nom de company ...',
    aumico_mapping_or: 'ou',
    aumico_mapping_search_hint_min_chars: 'Saisis au moins 3 caractères ...',
    aumico_mapping_search_loading: 'Chargement des companies ...',
    aumico_mapping_search_results_count: '{{count}} résultats',
    aumico_mapping_search_no_results: 'Aucune company aumico correspondante.',
    aumico_mapping_search_error: 'Impossible de charger les companies aumico.',
    aumico_mapping_summary_title: 'Mapping terminé',
    aumico_mapping_summary_matched: '{{count}} companies associées',
    aumico_mapping_summary_skipped: '{{count}} passées',
    aumico_mapping_summary_created: '{{count}} nouvelles companies créées',
    aumico_mapping_summary_later_hint: 'Tu peux associer les companies passées à tout moment plus tard.',
    aumico_mapping_btn_finish: 'Terminer',
    aumico_button_retry: 'Réessayer',
    aumico_integration_card_btn_manage: 'Gérer',
    aumico_integration_card_tenants_count: '{{count}} tenants connectés',
    aumico_integration_card_tenants_reauth: '{{count}} doivent se reconnecter',
    aumico_d365bc_manage_modal_title: 'Tenants connectés',
    aumico_d365bc_manage_back_to_list: 'Retour aux tenants',
    aumico_d365bc_manage_add_tenant: 'Connecter un nouveau tenant',
    aumico_d365bc_manage_tenant_label: 'Tenant',
    aumico_d365bc_manage_status_reauth: 'Session expirée',
    aumico_d365bc_manage_companies_count: '{{count}} companies',
    aumico_d365bc_manage_no_mapping: '(non associée)',
    aumico_d365bc_manage_loading_companies: 'Chargement des companies ...',
    aumico_d365bc_manage_company_column_bc: 'Company BC',
    aumico_d365bc_manage_search_empty: 'Aucune company trouvée.',
    aumico_d365bc_manage_btn_disconnect: 'Déconnecter le tenant',
    aumico_d365bc_manage_btn_unlink: 'Dissocier',
    aumico_d365bc_automatch_running: 'Détection automatique des associations ...',
    aumico_d365bc_automatch_success: '{{autoMatched}} détectées automatiquement · {{notMapped}} non associées',
    aumico_d365bc_automatch_partial_errors: '({{errors}} erreurs)',
    aumico_d365bc_automatch_failed: 'Auto-Match échoué. Veuillez associer les companies manuellement.',
    aumico_d365bc_manage_disconnect_confirm_title: 'Vraiment déconnecter ce tenant ?',
    aumico_d365bc_manage_disconnect_confirm_text: 'Toutes les associations et données mises en cache pour ce tenant seront supprimées.',
    aumico_d365bc_manage_empty: 'Aucun tenant connecté.',
    aumico_integration_topal_displayname: 'Topal',
    aumico_integration_topal_description: 'Importe les données comptables directement depuis Topal.',
    aumico_topal_connect_modal_title: 'Connecter Topal',
    aumico_topal_step_welcome_intro: 'Saisis l\'URL de ton serveur Topal ainsi que ton nom d\'utilisateur et ton mot de passe. aumico se connecte directement à ton Topal.',
    aumico_topal_step_config_displayname_help: 'Champ obligatoire. T\'aide à distinguer plusieurs serveurs Topal dans la vue d\'ensemble.',
    aumico_topal_step_config_serverurl_label: 'URL du serveur',
    aumico_topal_step_config_serverurl_help: 'L\'URL de ton serveur Topal avec le port, p.ex. https://topal.example.ch:9001',
    aumico_topal_step_config_username_label: 'Nom d\'utilisateur',
    aumico_topal_step_config_password_label: 'Mot de passe',
    aumico_topal_step_config_password_help: 'Le mot de passe est stocké chiffré et n\'est plus jamais affiché.',
    aumico_topal_step_config_password_show: 'Afficher',
    aumico_topal_step_config_password_hide: 'Masquer',
    aumico_topal_manage_modal_title: 'Serveurs Topal connectés',
    aumico_topal_manage_empty: 'Aucun serveur Topal connecté pour le moment.',
    aumico_topal_manage_add_server: 'Connecter un nouveau serveur',
    aumico_topal_manage_back_to_list: 'Retour aux serveurs',
    aumico_topal_manage_status_reauth: 'Connexion expirée',
    aumico_topal_manage_loading_companies: 'Chargement des entreprises ...',
    aumico_topal_manage_companies_count: '{{count}} entreprises',
    aumico_topal_manage_no_mapping: '(non liée)',
    aumico_topal_manage_company_column_topal: 'Entreprise Topal',
    aumico_topal_manage_search_empty: 'Aucune entreprise trouvée.',
    aumico_topal_manage_btn_unlink: 'Dissocier',
    aumico_topal_manage_btn_disconnect: 'Déconnecter le serveur',
    aumico_topal_manage_disconnect_confirm_title: 'Déconnecter vraiment ce serveur ?',
    aumico_topal_manage_disconnect_confirm_text: 'Tous les mappings et les données en cache de ce serveur seront supprimés.',
    aumico_topal_automatch_running: 'Détection automatique des liens ...',
    aumico_topal_automatch_success: '{{autoMatched}} détectées automatiquement · {{notMapped}} non liées',
    aumico_topal_automatch_partial_errors: '({{errors}} erreurs)',
    aumico_topal_automatch_failed: 'Échec de l\'auto-détection. Veuillez lier les entreprises manuellement.',
    // ── Accounto (REV-21119) ──
    aumico_integration_accounto_displayname: 'Accounto',
    aumico_integration_accounto_description: 'Importe les données comptables directement depuis Accounto.',
    aumico_accounto_connect_modal_title: 'Connecter Accounto',
    aumico_accounto_step_welcome_intro:
        'Crée une clé API dans Accounto et colle-la ici. Une clé fiduciaire connecte tous tes mandants, une clé PME ta propre entreprise. aumico lit uniquement les données comptables et n\'écrit rien dans ton Accounto.',
    aumico_accounto_step_config_displayname_help:
        'Obligatoire. T\'aide à distinguer plusieurs accès Accounto dans l\'aperçu.',
    aumico_accounto_step_config_apikey_label: 'Clé API',
    aumico_accounto_step_config_apikey_help:
        'Enregistrée chiffrée et plus jamais affichée. La clé a une date d\'expiration ; aumico t\'avertit 30 jours avant.',
    aumico_accounto_step_config_apikey_show: 'Afficher',
    aumico_accounto_step_config_apikey_hide: 'Masquer',
    aumico_accounto_validation_apikey_invalid:
        'Ce n\'est pas une clé API Accounto. Copie la clé entière depuis Accounto : trois parties séparées par des points.',
    aumico_accounto_validation_missing_fields: 'Encore à remplir :',
    aumico_accounto_manage_modal_title: 'Accès Accounto connectés',
    aumico_accounto_manage_empty: 'Aucun accès Accounto connecté pour l\'instant.',
    aumico_accounto_manage_add_server: 'Connecter une nouvelle clé API',
    aumico_accounto_manage_back_to_list: 'Retour aux accès',
    aumico_accounto_manage_status_reauth: 'Échec de la connexion',
    aumico_accounto_manage_key_advisor: 'Clé fiduciaire · mandant {{tenantId}}',
    aumico_accounto_manage_key_client: 'Clé PME · mandant {{tenantId}}',
    aumico_accounto_key_valid_until: 'Clé API valable jusqu\'au {{date}}',
    aumico_accounto_key_expiring: 'La clé API expire le {{date}}. Crée une nouvelle clé dans Accounto.',
    aumico_accounto_key_expired: 'La clé API a expiré le {{date}}. Crée une nouvelle clé dans Accounto.',
    aumico_accounto_card_key_expiring: 'Clé bientôt expirée',
    aumico_accounto_card_key_expired: 'Clé expirée',
    aumico_accounto_manage_loading_companies: 'Chargement des mandants ...',
    aumico_accounto_manage_companies_count: '{{count}} mandants',
    aumico_accounto_manage_no_mapping: '(non lié)',
    aumico_accounto_manage_company_column_accounto: 'Mandant Accounto',
    aumico_accounto_manage_search_empty: 'Aucun mandant trouvé.',
    aumico_accounto_manage_btn_unlink: 'Délier',
    aumico_accounto_manage_btn_disconnect: 'Déconnecter l\'accès',
    aumico_accounto_manage_disconnect_confirm_title: 'Vraiment déconnecter cet accès ?',
    aumico_accounto_manage_disconnect_confirm_text:
        'Tous les mappings et les données en cache de cet accès seront supprimés.',
    aumico_accounto_automatch_running: 'Détection automatique des liens ...',
    aumico_accounto_automatch_success: '{{autoMatched}} détectés automatiquement · {{notMapped}} non liés',
    aumico_accounto_automatch_partial_errors: '({{errors}} erreurs)',
    aumico_accounto_automatch_failed: 'Échec de l\'auto-détection. Veuillez lier les entreprises manuellement.',
    accounto_importing_title: 'Importation des données',
    accounto_importing_subtitle: 'Récupération de tes données comptables depuis Accounto',
    accounto_importing_hint: 'Cela ne prend qu\'un instant',
    accounto_summary_title: 'Résumé de l\'importation',
    accounto_summary_overview: 'Aperçu',
    accounto_summary_company: 'Entreprise',
    accounto_summary_period: 'Période',
    accounto_summary_previous_period: 'Période précédente',
    accounto_summary_accounts: 'Comptes',
    accounto_summary_continue: 'Continuer vers l\'affectation',
    accounto_summary_discard: 'Rejeter',
    accounto_summary_validation_title: 'Validation',
    accounto_summary_balance_check: 'Contrôle du bilan',
    accounto_summary_current_year: 'Année en cours',
    accounto_summary_previous_year: 'Année précédente',
    accounto_summary_assets: 'Actifs',
    accounto_summary_liabilities: 'Passifs',
    accounto_import_failed_title: 'Échec de l\'importation',
    accounto_import_failed_description: 'L\'importation depuis Accounto a échoué. Merci de réessayer plus tard.',
    accounto_import_key_expired_description: 'La clé API Accounto a expiré. Crée une nouvelle clé dans Accounto.',
    accounto_import_invalid_key_description:
        'La clé API Accounto est invalide ou a expiré. Crée une nouvelle clé dans Accounto et remplace-la sous Paramètres organisationnels → Intégrations.',
    accounto_import_connection_error_description:
        'La connexion à Accounto est interrompue. Teste-la sous Paramètres organisationnels → Intégrations ou remplace la clé API à cet endroit.',
    accounto_import_tenant_not_allowed_description:
        'Une clé PME n’importe que sa propre entreprise. Choisis le mandant de cette clé ou connecte une clé fiduciaire.',
    accounto_import_vendor_mismatch_description:
        'La connexion choisie n’est pas une connexion Accounto. Choisis la connexion Accounto de cette entreprise.',
    accounto_import_tenant_not_mapped_description:
        'Ce mandant Accounto n’est pas attribué à cette entreprise. Vérifie l’attribution sous Intégrations.',
    accounto_import_mapping_not_active_description:
        'L’attribution à ce mandant Accounto n’est pas active. Active-la sous Intégrations et réessaie.',
    accounto_import_unbalanced_booking_description:
        'Une écriture dans Accounto n’est pas équilibrée : le débit et le crédit ne concordent pas. Corrige-la dans Accounto et importe à nouveau.',
    accounto_import_unknown_accounting_type_description:
        'Un compte mouvementé dans Accounto a un type de compte inconnu. Vérifie le type de compte dans Accounto et importe à nouveau.',
    // ── Proffix (REV-22536) ──
    aumico_integration_proffix_displayname: 'PROFFIX',
    aumico_integration_proffix_description: 'Importe les données comptables directement depuis PROFFIX.',
    aumico_proffix_connect_modal_title: 'Connecter PROFFIX',
    aumico_proffix_step_welcome_intro:
        'Saisis l\'adresse de ta PxRestAPI PROFFIX, le mot de passe de l\'API REST ainsi que ton nom d\'utilisateur et ton mot de passe PROFFIX. La PxRestAPI doit être accessible en HTTPS (p.ex. via un reverse proxy). aumico lit uniquement les données comptables et n\'écrit rien dans ton PROFFIX.',
    aumico_proffix_step_config_displayname_help:
        'Champ obligatoire. T\'aide à distinguer plusieurs serveurs PROFFIX dans la vue d\'ensemble.',
    aumico_proffix_step_config_serverurl_label: 'URL du serveur',
    aumico_proffix_step_config_serverurl_help:
        'L\'adresse de ta PxRestAPI avec le port, p.ex. https://proffix.example.ch:11011 ou https://proffix.example.ch:11011/pxapi/V4',
    aumico_proffix_step_config_restapikey_label: 'Mot de passe de l\'API REST',
    aumico_proffix_step_config_restapikey_help:
        'Le mot de passe de la PxRestAPI (pas ton mot de passe utilisateur). Il est stocké chiffré et n\'est plus jamais affiché.',
    aumico_proffix_step_config_username_label: 'Nom d\'utilisateur',
    aumico_proffix_step_config_password_label: 'Mot de passe',
    aumico_proffix_step_config_password_help:
        'Le mot de passe de ton utilisateur PROFFIX. Il est stocké chiffré et n\'est plus jamais affiché.',
    aumico_proffix_step_config_password_show: 'Afficher',
    aumico_proffix_step_config_password_hide: 'Masquer',
    aumico_proffix_validation_serverurl_invalid:
        'Saisis uniquement l\'adresse du serveur avec le port, éventuellement avec /pxapi/V4, mais sans autre chemin comme /PRO/Info. Elle commence par https://.',
    aumico_proffix_validation_missing_fields: 'Encore à remplir :',
    aumico_proffix_manage_modal_title: 'Serveurs PROFFIX connectés',
    aumico_proffix_manage_empty: 'Aucun serveur PROFFIX connecté pour le moment.',
    aumico_proffix_manage_add_server: 'Connecter un nouveau serveur',
    aumico_proffix_manage_back_to_list: 'Retour aux serveurs',
    aumico_proffix_manage_status_reauth: 'Échec de la connexion',
    aumico_proffix_manage_loading_companies: 'Chargement des mandants ...',
    aumico_proffix_manage_companies_count: '{{count}} mandants',
    aumico_proffix_manage_no_mapping: '(non liée)',
    aumico_proffix_manage_company_column_proffix: 'Mandant PROFFIX',
    aumico_proffix_manage_search_empty: 'Aucun mandant trouvé.',
    aumico_proffix_manage_btn_unlink: 'Dissocier',
    aumico_proffix_manage_btn_disconnect: 'Déconnecter le serveur',
    aumico_proffix_manage_disconnect_confirm_title: 'Déconnecter vraiment ce serveur ?',
    aumico_proffix_manage_disconnect_confirm_text: 'Tous les mappings et les données en cache de ce serveur seront supprimés.',
    aumico_proffix_automatch_running: 'Détection automatique des liens ...',
    aumico_proffix_automatch_success: '{{autoMatched}} détectées automatiquement · {{notMapped}} non liées',
    aumico_proffix_automatch_partial_errors: '({{errors}} erreurs)',
    aumico_proffix_automatch_failed: 'Échec de l\'auto-détection. Veuillez lier les entreprises manuellement.',
    proffix_importing_title: 'Importation des données',
    proffix_importing_subtitle: 'Récupération de tes données comptables depuis PROFFIX',
    proffix_importing_hint: 'Cela ne prend qu\'un instant',
    proffix_summary_title: 'Résumé de l\'import',
    proffix_summary_overview: 'Aperçu',
    proffix_summary_company: 'Entreprise',
    proffix_summary_period: 'Période',
    proffix_summary_previous_period: 'Période précédente',
    proffix_summary_accounts: 'Comptes',
    proffix_summary_continue: 'Continuer vers la mise en correspondance',
    proffix_summary_discard: 'Annuler',
    proffix_summary_validation_title: 'Validation',
    proffix_summary_balance_check: 'Vérification de bilan',
    proffix_summary_current_year: 'Année en cours',
    proffix_summary_previous_year: 'Année précédente',
    proffix_summary_assets: 'Actifs',
    proffix_summary_liabilities: 'Passifs',
    proffix_import_failed_title: 'Échec de l’importation',
    proffix_import_failed_description: 'L’importation PROFFIX a échoué. Veuillez réessayer plus tard.',
    aumico_integration_abacus_displayname: 'Abacus',
    aumico_integration_abacus_description: 'Importe les données comptables via AbaReport directement depuis Abacus.',
    aumico_abacus_connect_modal_title: 'Connecter Abacus',
    aumico_abacus_step_welcome_intro: 'Saisis l\'URL de ton serveur Abacus et les identifiants OAuth2. aumico se connecte directement à ton Abacus via AbaReport.',
    aumico_abacus_step_config_displayname_help: 'Champ obligatoire. T\'aide à distinguer plusieurs serveurs Abacus dans la vue d\'ensemble.',
    aumico_abacus_step_config_serverurl_label: 'URL du serveur',
    aumico_abacus_step_config_serverurl_help: 'L\'URL de ton serveur Abacus, p.ex. https://abaweb.example.ch',
    aumico_abacus_step_config_clientid_label: 'Client ID',
    aumico_abacus_step_config_clientsecret_label: 'Client Secret',
    aumico_abacus_step_config_clientsecret_help: 'Le secret est stocké chiffré et ne sera plus jamais affiché.',
    aumico_abacus_step_config_clientsecret_show: 'Afficher',
    aumico_abacus_step_config_clientsecret_hide: 'Masquer',
    aumico_abacus_manage_modal_title: 'Serveurs Abacus connectés',
    aumico_abacus_manage_empty: 'Aucun serveur Abacus connecté.',
    aumico_abacus_manage_add_server: 'Connecter un nouveau serveur',
    aumico_abacus_manage_add_mapping: 'Ajouter une association',
    aumico_abacus_manage_back_to_list: 'Retour à la liste',
    aumico_abacus_manage_companies_section_title: 'Entreprises associées',
    aumico_abacus_manage_companies_empty: 'Aucune entreprise associée pour l\'instant.',
    aumico_abacus_manage_status_reauth: 'Identifiants invalides',
    aumico_abacus_manage_btn_disconnect: 'Déconnecter le serveur',
    aumico_abacus_manage_disconnect_confirm_title: 'Vraiment déconnecter ce serveur ?',
    aumico_abacus_manage_disconnect_confirm_text: 'Toutes les associations et données mises en cache pour ce serveur seront supprimées.',
    aumico_abacus_mapping_add_title: 'Associer un ID mandant',
    aumico_abacus_mapping_edit_title: 'Modifier l\'ID mandant',
    aumico_abacus_mapping_mandanten_id_placeholder: 'p.ex. 1001',
    aumico_abacus_mapping_mandanten_id_help: 'L\'identifiant numérique du mandant dans Abacus.',
    aumico_integration_setup_displayname_label: 'Nom d\'affichage',
    aumico_integration_setup_displayname_placeholder: 'ex. Fiduciaire X',
    aumico_integration_search_company_placeholder: 'Rechercher une entreprise ...',
    aumico_integration_status_error_title: 'Échec de la connexion',
    aumico_integration_status_testing: 'Test de la connexion ...',
    aumico_integration_status_connected: 'Connecté',
    aumico_integration_connect_button: 'Établir la connexion',
    aumico_integration_connect_already_exists_title: 'Serveur déjà connecté',
    aumico_integration_connect_already_exists_description: 'Ce serveur est déjà connecté dans ton organisation. Tu le trouves dans la vue d\'ensemble.',
    aumico_integration_aumico_company_label: 'Entreprise aumico',
    aumico_abacus_mandanten_id_label: 'ID mandant',
    aumico_button_ok: 'OK',
    aumico_integration_card_btn_info: 'Info',
    aumico_integration_card_status_action_required: 'Action requise',
    aumico_integration_card_beta: 'BÊTA',
    aumico_integration_card_beta_tooltip:
        'Bêta : nous validons encore cette intégration avec nos premiers clients. Tu peux déjà l’utiliser – ton feedback nous aide à l’améliorer.',
    aumico_company_integrations_section_connected: 'Connecté',
    aumico_company_integration_redirect_tenant_label: 'Tenant',
    aumico_company_integration_redirect_environment_label: 'Environnement',
    aumico_company_integration_redirect_external_company_label: 'Société liée',
    aumico_company_integration_redirect_broken: "La connexion liée n'est plus disponible. Merci de la vérifier dans les paramètres de l'organisation.",
    aumico_company_integration_redirect_managed_in_org: "Cette intégration est gérée dans les paramètres de l'organisation.",
    aumico_integration_managed_in_org_ask_admin: "Demande à un admin de configurer cette intégration dans les paramètres de l'organisation.",
    aumico_company_integration_redirect_goto_org_settings: "Aux paramètres de l'organisation",
    aumico_company_integration_bexio_modal_connected: 'Bexio est connecté à cette société. Tu peux déconnecter le lien ici.',
    aumico_company_integration_bexio_modal_disconnected: 'Connecte Bexio à cette société pour importer directement les données comptables et les écritures.',
    aumico_org_integration_redirect_managed_in_company: 'Bexio est géré par société. Merci de le connecter directement dans la société concernée.',
    aumico_editable_account_unlock_prior_year_tooltip: 'Déverrouiller la valeur de l\'année précédente',
    aumico_grouping_masking_reclass_legacy_banner: 'Les reclassements de ce rapport se gèrent dans l\'onglet existant. La nouvelle fonction est désactivée ici.',
    // ── REV-21964 · SharePoint sync report + upstream states ─────────────────────────────
    abcp_sync_run_status_pending: 'En attente',
    abcp_sync_run_status_running: 'En cours',
    abcp_sync_run_status_completed: 'Terminée',
    abcp_sync_run_status_failed: 'Échouée',
    abcp_sync_refused_closing_sealed: 'La clôture est scellée. Aucun document n’est plus accepté.',
    abcp_sync_refused_already_running: 'Une synchronisation est déjà en cours.',
    abcp_sync_refused_no_bound_folders: 'Aucun dossier n’est encore connecté.',
    abcp_sync_started: 'Synchronisation lancée. Vous pouvez continuer à travailler.',
    abcp_sync_new_documents: '{{count}} nouveau document',
    abcp_sync_new_documents_plural: '{{count}} nouveaux documents',
    abcp_sync_new_documents_none: 'Aucun nouveau document',
    abcp_sync_problem_files: '{{count}} fichier non importé',
    abcp_sync_problem_files_plural: '{{count}} fichiers non importés',
    abcp_sync_failed_folders: '{{count}} dossier illisible',
    abcp_sync_failed_folders_plural: '{{count}} dossiers illisibles',
    abcp_sync_skips_truncated: 'Les autres fichiers ne sont pas listés ici individuellement. Le nombre de nouveaux documents est complet.',
    abcp_sync_folder_failed: 'Dossier illisible : {{folderPath}}',
    abcp_sync_never_run: 'Cette clôture n’a jamais été synchronisée.',
    abcp_sync_skip_unsupported_type: 'Type de fichier non importé (uniquement PDF, Excel et Word)',
    abcp_sync_skip_already_imported: 'Déjà dans la clôture, inchangé',
    abcp_sync_skip_download_failed: 'Le fichier n’a pas pu être téléchargé',
    abcp_sync_skip_rejected_by_ingest: 'Refusé lors du téléversement',
    abcp_sync_skip_listing_capped: 'Le dossier contient plus de fichiers qu’une exécution n’en lit',
    abcp_sync_skip_too_large: 'Fichier de plus de 32 Mo',
    abcp_sync_skip_duplicate_content: 'Même contenu qu’un document existant. Le nom y est noté.',
    abcp_upstream_state_deleted: 'Supprimé dans SharePoint',
    abcp_upstream_state_moved_out: 'Déplacé hors du dossier connecté',
    abcp_upstream_state_replaced: 'Remplacé par une version plus récente',
    abcp_upstream_notice_assigned: 'Ce document justifie un compte et n’est plus à sa place dans SharePoint. Il reste dans la clôture — veuillez vérifier.',
    abcp_upstream_notice_unassigned: 'N’est plus à sa place dans SharePoint.',
    abcp_upstream_notice_replaced_assigned: 'SharePoint contient une version plus récente de ce fichier. Ce justificatif appuie un compte et reste inchangé dans le bouclement — la nouvelle version se trouve dans la boîte de réception et doit être attribuée par vos soins.',
    abcp_upstream_notice_replaced_unassigned: 'SharePoint contient une version plus récente de ce fichier. Elle se trouve dans la boîte de réception.',
    abcp_upstream_action_not_relevant: 'Marquer comme non pertinent',
    abcp_upstream_alias_names: 'Autres noms dans SharePoint : {{names}}',
    abcp_upstream_changed_at: 'Constaté le {{date}}',
    abcp_accounts_status_open: 'Ouvert',
    abcp_accounts_status_difference: 'Écart',
    abcp_accounts_status_reconciled: 'Rapproché',
    // What started a reconciliation run, as its first trail line names it.
    abcp_trail_trigger_document_assigned: 'justificatif attribué',
    abcp_trail_trigger_document_unassigned: 'attribution supprimée',
    abcp_trail_trigger_document_removed: 'justificatif retiré',
    abcp_trail_trigger_erp_sync: 'comptabilité synchronisée',
    abcp_accounts_col_number: 'N°',
    abcp_accounts_col_label: 'Désignation',
    abcp_accounts_col_status: 'Statut',
    abcp_accounts_error: 'Le chargement des comptes a échoué.',
    abcp_accounts_empty: 'Aucun compte disponible.',
    abcp_accounts_group_reconciled_tooltip: 'Tous les comptes de ce groupe sont rapprochés',
    abcp_accounts_group_status_tooltip: '{{reconciled}} rapproché(s), {{difference}} avec écart, {{open}} ouvert(s)',
    abcp_accounts_marked_tooltip: 'Marqué',
    abcp_ledger_col_date: 'Date',
    abcp_ledger_col_text: 'Libellé',
    abcp_ledger_col_account: 'Contrepartie',
    abcp_ledger_col_account_label: 'Désignation de la contrepartie',
    abcp_ledger_col_vat: 'TVA',
    abcp_ledger_col_debit: 'Débit',
    abcp_ledger_col_credit: 'Crédit',
    abcp_ledger_col_balance: 'Solde',
    abcp_ledger_row_opening: 'Solde reporté',
    abcp_ledger_row_closing: 'Solde final',
    abcp_ledger_empty: 'Aucune écriture disponible.',
    abcp_ledger_error: 'Les écritures n’ont pas pu être chargées.',
    abcp_ledger_foreign_rate: 'Cours',
    abcp_ledger_foreign_unavailable: 'non disponible',
    abcp_ledger_load_more: 'Afficher plus',
    abcp_ledger_mark_comment: 'Commenter',
    abcp_ledger_mark_todo: 'Saisir un point en suspens',
    abcp_ledger_line_missing_title: 'Écriture introuvable',
    abcp_ledger_line_missing_body: 'L’écriture ne figure plus dans le grand livre du compte. Elle a été modifiée ou supprimée dans l’ERP.',
    abcp_settings_open: 'Paramètres',
    abcp_closing_currency_missing: 'Aucune devise n’est encore définie pour cette clôture. Définis-la dans les paramètres pour afficher les montants.',
    abcp_settings_title: 'Paramètres de la clôture annuelle',
    abcp_settings_loading: 'Chargement des paramètres …',
    abcp_settings_year: 'Exercice en cours',
    abcp_settings_period_start: 'Début',
    abcp_settings_period_end: 'Fin',
    abcp_settings_currency: 'Devise',
    abcp_settings_save: 'Enregistrer',
    abcp_settings_cancel: 'Annuler',
    abcp_settings_reason_order: 'Le début doit précéder la fin.',
    abcp_settings_load_failed: 'Les paramètres n’ont pas pu être chargés.',
    abcp_settings_save_failed: 'Les paramètres n’ont pas pu être enregistrés.',

    // REV-21370 / REV-21364 / REV-21375 — Korrekturbuchungen (ADR-0015).
    //
    // FLAT keys, like `abcp_ledger_*` above: these are FE-owned and carry no dots. The nested
    // `abcp.*` form is for the DOTTED keys the backend supplies, which i18next can only resolve
    // out of an object (ADR-0015 §12).
    abcp_adjustments_filter_all: 'Toutes',
    abcp_adjustments_filter_released: 'Validé',
    abcp_adjustments_filter_transferred: 'Transféré',
    abcp_adjustments_filter_booked: 'Comptabilisées',
        abcp_adjustments_filter_discarded: 'Rejeté',
        abcp_adjustments_restore: 'Valider à nouveau',
        abcp_adjustments_restore_hint: 'La correction rejetée est validée à nouveau et réapparaît dans les listes de travail.',
        abcp_adjustments_discarded: 'Rejeté',
        abcp_adjustments_discarded_hint: 'Retiré — non supprimé. Conservé pour la traçabilité.',
        abcp_adjustments_edit_start: 'Modifier',
        abcp_adjustments_edit_save: 'Enregistrer',
        abcp_adjustments_edit_cancel: 'Annuler',
    abcp_adjustments_fiscal_year: 'Exercice',
    abcp_adjustments_fiscal_year_short: 'Ex.',
    abcp_adjustments_fiscal_year_current: 'en cours',
    abcp_adjustments_new: 'Nouvelle écriture',
    abcp_adjustments_transfer: 'Transférer',
    abcp_adjustments_row_actions: 'Actions',
    abcp_adjustments_edit: 'Modifier',
    abcp_adjustments_discard: 'Rejeter',
    abcp_adjustments_retry: 'Réessayer',
    abcp_adjustments_col_state: 'Statut',
    abcp_adjustments_col_text: 'Libellé',
    abcp_adjustments_col_debit: 'Débit',
    abcp_adjustments_col_credit: 'Crédit',
    abcp_adjustments_col_amount: 'Montant',
    abcp_adjustments_col_pnl: 'P&L',
    abcp_adjustments_effect_increase: 'Augmente le bénéfice',
    abcp_adjustments_effect_decrease: 'Diminue le bénéfice',
    abcp_adjustments_effect_none: 'Sans effet',
    abcp_adjustments_col_source: 'Source',
    abcp_adjustments_col_date: 'Date',
    abcp_adjustments_state_released: 'Validé',
        abcp_adjustments_state_proposed: 'Proposition',
        abcp_adjustments_state_proposed_hint: 'Proposé par un agent — pas encore validé.',
        abcp_adjustments_not_found: 'Introuvable',
        abcp_adjustments_not_found_hint: 'Introuvable dans le journal importé de l´ERP. Ce n´est pas une erreur — l´écriture peut encore suivre.',
        abcp_adjustments_result_excluded: 'Non classé',
        abcp_adjustments_result_excluded_hint: 'Un compte de cette écriture manque au plan comptable. L´écriture est exclue du résultat.',
        abcp_adjustments_field_date: 'Date de comptabilisation',
        abcp_adjustments_field_date_hint: 'Par défaut la date de clôture. Modifiable dans l´exercice.',
        abcp_adjustments_error_date_invalid: 'Veuillez indiquer une date valide.',
        abcp_adjustments_error_date_outside_year: 'La date de comptabilisation doit se situer dans l´exercice de la clôture.',
        abcp_adjustments_transfer_all_released: 'Transférer tous les validés',
    abcp_adjustments_state_released_hint: 'Saisi et validé — pas encore transféré à l´ERP.',
    abcp_adjustments_state_transferred: 'Transférée',
    abcp_adjustments_state_transferred_hint: 'Transférée à l’ERP — pas encore confirmée dans le journal.',
    abcp_adjustments_state_booked: 'Comptabilisée',
    abcp_adjustments_state_booked_hint: 'Retrouvée dans le journal importé de l’ERP.',
    abcp_adjustments_source_user: 'Utilisateur',
    abcp_adjustments_source_agent: 'Agent',
    abcp_adjustments_source_prior_year: 'EP',
    abcp_adjustments_ambiguous: 'Ambiguë',
    abcp_adjustments_ambiguous_hint: 'Plusieurs écritures du journal correspondent — rien n’est deviné. Choisissez la bonne dans la vue détaillée.',
    abcp_adjustments_ambiguity_title: 'Correspondance ambiguë dans le journal',
    abcp_adjustments_ambiguity_hint: 'Plusieurs écritures du journal concordent sur le débit, le crédit, le montant et l’exercice. Choisissez celle qui justifie cette écriture de correction — rien n’est deviné.',
    abcp_adjustments_ambiguity_confirm: 'Utiliser cette écriture comme justificatif',
    abcp_adjustments_transfer_erp: 'Envoyer directement à l’ERP',
    abcp_adjustments_transfer_erp_hint: 'Le logiciel de comptabilité dispose d’une interface d’écriture',
    abcp_adjustments_transfer_manual: 'Marquer comme comptabilisée manuellement',
    abcp_adjustments_transfer_manual_hint: 'Déjà saisie directement dans l’ERP',
    abcp_adjustments_transfer_reason_no_write_api: 'Le logiciel de comptabilité connecté n’a pas d’interface d’écriture. Utilisez l’export CSV.',
    abcp_adjustments_transfer_reason_not_connected: 'Aucun logiciel de comptabilité n’est connecté pour ce mandat. Utilisez l’export CSV.',
    abcp_adjustments_transfer_reason_reauth: 'La connexion au logiciel de comptabilité doit être renouvelée.',
    abcp_adjustments_transfer_reason_unavailable: 'Le logiciel de comptabilité est actuellement inaccessible.',
    abcp_adjustments_transfer_reason_no_caller_context: 'Le transfert vers l’ERP n’est pas possible par ce chemin. Utilisez l’export CSV.',
    abcp_adjustments_transfer_reason_vendor_rejected: 'Le logiciel de comptabilité a refusé cette écriture.',
    abcp_adjustments_result_provisional: 'Résultat provisoire de l’exercice',
    abcp_adjustments_result_provisional_hint: '· avant écritures de correction',
    abcp_adjustments_result_after: 'Résultat de l’exercice après écritures de correction',
    abcp_adjustments_result_impact: 'Effet des corrections sur le résultat',
    abcp_adjustments_total: 'Total des écritures de correction',
    abcp_adjustments_total_year: 'Total ex. {{year}}',
    abcp_adjustments_unclassified_note: '{{count}} écriture(s) de correction concernent un compte qui n’est pas encore rattaché à une position — elles comptent dans le total, mais pas dans l’effet sur le résultat.',
    abcp_adjustments_empty: 'Aucune écriture de correction disponible.',
    abcp_adjustments_empty_year: 'Aucune écriture de correction pour l’ex. {{year}}.',
    abcp_adjustments_no_hits: 'Aucune écriture de correction ne correspond à « {{term}} ».',
    abcp_adjustments_error: 'Les écritures de correction n’ont pas pu être chargées.',
    abcp_adjustments_search_hits: '{{count}} résultat(s) pour « {{term}} »',
    abcp_adjustments_search_reset: 'Réinitialiser la recherche',
    abcp_adjustments_modal_create_title: 'Nouvelle écriture de correction',
    abcp_adjustments_modal_edit_title: 'Modifier l’écriture de correction',
    abcp_adjustments_modal_account: 'Compte',
    abcp_adjustments_modal_submit: 'Saisir l’écriture',
    abcp_adjustments_modal_save: 'Enregistrer',
    abcp_adjustments_modal_cancel: 'Annuler',
    abcp_adjustments_modal_no_accounts: 'Ce bouclement n’a pas encore de plan comptable. Actualisez d’abord les données comptables.',
    abcp_adjustments_field_text: 'Libellé',
    abcp_adjustments_field_text_placeholder: 'p. ex. frais bancaires T4',
    abcp_adjustments_field_debit: 'Compte au débit',
    abcp_adjustments_field_credit: 'Compte au crédit',
    abcp_adjustments_field_amount: 'Montant',
    abcp_adjustments_field_owner: 'Affectation (compte)',
    abcp_adjustments_field_owner_auto: 'Automatique (débit)',
    abcp_adjustments_field_choose: 'Choisir',
    abcp_adjustments_field_remark: 'Remarques',
    abcp_adjustments_field_remark_placeholder: 'Remarque facultative sur l’écriture de correction.',
    abcp_adjustments_field_vat: 'TVA',
    abcp_adjustments_preview: 'Écriture',
    abcp_adjustments_preview_against: 'à',
    abcp_adjustments_detail_back: 'Retour',
    abcp_adjustments_transfer_progress_title: 'Transfert ERP',
    abcp_adjustments_transfer_progress_connection: 'Connexion à l’ERP',
    abcp_adjustments_transfer_progress_sending: 'Transfert de {{count}} correction(s)',
    abcp_adjustments_proof_pending: 'Le justificatif suivra avec « Actualiser l’ERP ».',
    abcp_adjustments_open_count: '{{count}} ouverte(s)',
    abcp_adjustments_account_empty: 'Aucune écriture de correction pour l’ex. {{year}}.',
    abcp_adjustments_error_same_accounts: 'Le compte au débit et au crédit ne doivent pas être identiques.',
    abcp_adjustments_error_not_open: 'Seules les écritures de correction ouvertes peuvent être modifiées ou supprimées.',
    abcp_adjustments_error_not_found: 'Cette écriture de correction n’est pas disponible.',
    abcp_adjustments_error_discarded: 'Cette écriture de correction a été supprimée.',
    abcp_adjustments_error_not_ambiguous: 'Aucun choix n’est en attente pour cette écriture de correction.',
    abcp_adjustments_error_candidate_unknown: 'Cette écriture du journal ne fait pas partie des candidates trouvées.',
    abcp_adjustments_error_proof_taken: 'Cette écriture du journal justifie déjà une autre correction.',
    abcp_adjustments_error_prior_year: 'Cet exercice ne peut pas être modifié.',
    abcp_adjustments_error_accounts_equal: 'Le compte au débit et au crédit ne doivent pas être identiques.',
    abcp_adjustments_error_account_unknown: 'Ce compte ne fait pas partie du plan comptable du bouclement.',
    abcp_adjustments_error_amount: 'Le montant doit être supérieur à zéro.',
    abcp_adjustments_error_text: 'Le libellé ne doit pas être vide.',
    abcp_adjustments_error_no_connection: 'Aucun logiciel de comptabilité n’est connecté pour ce mandat. Utilisez l’export CSV.',
    abcp_adjustments_error_connection_ambiguous: 'Plusieurs logiciels de comptabilité sont connectés pour ce mandat, le transfert direct n’est donc pas possible.',
    // REV-21367 — ABCP-Dokumentenhub (abcp-documents-hub).
    abcp_documents_filter_inbox: 'À classer',
    abcp_documents_filter_assigned: 'Classé',
    abcp_documents_filter_not_relevant: 'Non pertinent',
    abcp_documents_col_filename: 'Nom du document',
    abcp_documents_col_account: 'Compte',
    abcp_documents_col_confidence: 'Type de document',
    abcp_documents_col_confidence_hint: 'Le type de document détecté par l’IA – sans jugement sur le choix du compte.',
    abcp_documents_col_date: 'Date',
    abcp_documents_col_source: 'Source',
    abcp_documents_col_status: 'Statut',
    abcp_documents_status_open: 'Ouvert',
    abcp_documents_status_proposed: 'Proposition',
    abcp_documents_status_assigned: 'Attribué',
    abcp_documents_source_upload: 'Upload',
    abcp_documents_source_sharepoint: 'Sharepoint',
    abcp_documents_source_email: 'E-mail',
    abcp_documents_search_placeholder: 'Rechercher dans tous les documents…',
    abcp_documents_upload: 'Upload',
    abcp_documents_sync_now: 'Synchroniser maintenant',
    abcp_documents_sync_settings: 'Paramètres',
    abcp_documents_sync_disconnected: 'Non connecté',
    abcp_documents_account_select: 'Sélectionner un compte',
    abcp_documents_project_file: 'Dossier de projet',
    abcp_documents_picker_search_placeholder: 'N° de compte ou désignation…',
    abcp_documents_picker_project_file: 'Général · Dossier de projet',
    abcp_documents_picker_project_file_hint: 'Procès-verbaux, déclaration d’exhaustivité, contrats',
    abcp_documents_picker_empty: 'Aucun compte trouvé',
    abcp_documents_picker_assignment: 'Attribution',
    abcp_documents_picker_back: 'Retour',
    abcp_documents_validity_closing: 'Uniquement ce bouclement annuel',
    abcp_documents_validity_closing_hint: 'Le document ne concerne que l’exercice en cours',
    abcp_documents_validity_long_term_option: 'Valable à long terme',
    abcp_documents_validity_long_term_hint: 'Contrats, leasings, prêts — reste valable plusieurs années',
    abcp_documents_proposal_accept: 'Confirmer',
    abcp_documents_proposal_reject: 'Refuser',
    abcp_documents_not_relevant_mark: 'Non pertinent pour ce bouclement — le document est conservé',
    abcp_documents_not_relevant_restore: 'Marquer à nouveau comme pertinent pour ce bouclement',
    abcp_documents_drop_title: 'Déposer les documents ici',
    abcp_documents_drop_hint: 'PDF uniquement · plusieurs fichiers possibles',
    abcp_documents_validity_long_term: 'Dossier permanent — valable à long terme',
    abcp_documents_empty: 'Aucun document dans ce filtre.',
    abcp_documents_uploading: 'Téléversement en cours …',
    abcp_documents_error: 'Impossible de charger les documents.',
    abcp_documents_agent_notice_title: 'Attribué automatiquement.',
    abcp_documents_agent_filter: 'Attribué automatiquement dans cette vue',
    abcp_documents_proposal_error: 'Échec — veuillez réessayer.',
    abcp_documents_proposal_pending: 'Traitement en cours…',
    // REV-22302 — what the AI is doing with a document: the working indicator and its steps, the two
    // findings with their reasons, the picker action beside them, and the recognised Belegart.
    abcp_documents_ai_working: 'L’IA lit le justificatif …',
    abcp_documents_ai_step_reading: 'Lecture du texte',
    abcp_documents_ai_step_kind: 'Détection du type de document',
    abcp_documents_ai_step_scan: 'Vérification du fichier',
    abcp_documents_ai_step_value: 'Lecture du solde',
    abcp_documents_proposal_source_content: 'Proposé d\'après le contenu',
    abcp_documents_proposal_source_balance: 'Proposé d\'après le solde',
    abcp_documents_proposal_source_both: 'Le contenu et le solde concordent',
    abcp_documents_proposal_balance_matches: 'Le solde concorde',
    abcp_documents_proposal_balance_differs: 'Le solde ne concorde pas',
    abcp_documents_proposal_balance_not_checked: 'Solde non vérifié',
    abcp_documents_no_proposal: 'Aucune proposition',
    abcp_documents_not_readable: 'Illisible',
    abcp_documents_account_choose: 'Choisir un compte',
    abcp_documents_refusal_no_bound_account: 'Aucun compte du plan comptable n’est lié à ce type de document.',
    abcp_documents_refusal_accounts_unclassified: 'Les comptes correspondants ne sont pas encore classifiés.',
    abcp_documents_refusal_ambiguous: 'Plusieurs comptes sont possibles – veuillez choisir vous-même.',
    abcp_documents_refusal_no_candidate: 'Aucun compte ne correspond au nom figurant sur le justificatif – veuillez choisir vous-même.',
    abcp_documents_refusal_name_out_of_cut: 'Le nom figurant sur le justificatif renvoie à un compte hors des comptes possibles – veuillez choisir vous-même.',
    abcp_documents_refusal_name_unavailable: 'La comparaison des noms n’a pas pu être effectuée – veuillez choisir vous-même.',
    abcp_documents_refusal_unclassified: 'L’IA n’a pas pu reconnaître le type de document.',
    abcp_documents_refusal_no_text: 'Aucun texte lisible n’a été trouvé dans le justificatif.',
    abcp_documents_refusal_model_unparseable: 'La réponse de l’IA n’a pas pu être exploitée.',
    abcp_documents_refusal_integrity_fail: 'Le justificatif n’a pas pu être lu sans erreur.',
    abcp_documents_refusal_not_extracted: 'Le justificatif n’était pas encore lu lorsque l’IA a cherché un compte.',
    abcp_documents_refusal_unknown: 'L’IA n’a proposé aucun compte.',
    abcp_documents_refusal_rejected: 'La proposition de l’IA a été refusée.',
    abcp_documents_kind_bank_statement: 'Relevé bancaire',
    abcp_documents_kind_securities_depot_statement: 'Relevé de dépôt de titres',
    abcp_documents_kind_open_items_list: 'Liste des postes ouverts',
    // Kinds the classifier no longer returns keep their labels above, unused.
    abcp_documents_kind_bank_interest_capital_statement: 'Attestation d’intérêts / de capital',
    abcp_documents_kind_bank_confirmation: 'Confirmation bancaire',
    abcp_documents_kind_bank_other: 'Autre justificatif bancaire',
    abcp_documents_kind_cash_closing: 'Clôture de caisse',
    abcp_documents_kind_cash_in_transit_other: 'Justificatif de fonds en transit',
    abcp_documents_kind_securities_other: 'Autre justificatif de titres',
    abcp_documents_kind_customer_balance_confirmation: 'Confirmation de solde client',
    abcp_documents_kind_receivables_other: 'Autre justificatif débiteurs',
    abcp_documents_kind_allowance_calculation: 'Calcul du ducroire',
    abcp_documents_date_warning: 'Attention : justificatif au {{balanceDate}}, clôture au {{balanceSheetDate}}',
    // REV-21368 — ABCP-Einzeldokument (abcp-document-detail). Flache Keys wie beim
    // Schwester-Pure-View abcp_documents_*. Bewusst EIGENE Keys statt Wiederverwendung, wo der
    // Prototyp der Einzelseite anders beschriftet als der Hub: 'Akzeptieren' statt 'Bestätigen',
    // 'Klasse' statt 'Kl.', 'Nur dieser Abschluss' statt 'Nur dieser Jahresabschluss'.
    // Umkehrbar geteilt bleiben abcp_documents_not_relevant_mark/_restore und _proposal_reject.
    abcp_document_detail_close: 'Retour',
    abcp_document_detail_not_relevant_mark: 'Non pertinent',
    abcp_document_detail_not_relevant_restore: 'Marquer comme pertinent',
    abcp_document_detail_not_relevant_title: 'Ce document n’est pas pertinent.',
    abcp_document_detail_not_relevant_body: 'Marque-le comme pertinent pour pouvoir l’attribuer à un compte.',
    abcp_document_detail_write_error: 'Cela n’a pas fonctionné. Réessaie.',
    abcp_documents_dialog_close: 'Fermer',
    abcp_document_detail_proposal_title: 'Proposition de l’agent',
    abcp_document_detail_proposal_accept: 'Accepter',
    abcp_document_detail_assigned_title: 'Attribué',
    abcp_document_detail_assigned_remove: "Retirer l'attribution",
    abcp_document_detail_picker_title: 'Attribuer un compte',
    abcp_document_detail_picker_counter: '{{matched}} sur {{total}}',
    abcp_document_detail_picker_search_placeholder: 'N° de compte, désignation ou groupe de comptes…',
    abcp_document_detail_picker_empty: 'Aucun compte trouvé.',
    abcp_document_detail_project_file: 'Dossier de projet',
    abcp_document_detail_project_file_hint: 'Documents généraux du projet',
    abcp_document_detail_validity_title: 'Validité',
    abcp_document_detail_validity_closing: 'Uniquement ce bouclement',
    abcp_document_detail_validity_long_term: 'Long terme',
    abcp_document_detail_interpretation_title: 'Valeur du document',
    abcp_document_interpretation_reason_quote_not_in_document: 'La ligne citée ne figure pas dans le document.',
    abcp_document_quote: '« {{quote}} »',
    abcp_document_quote_line: 'page {{page}}, ligne {{line}}',
    abcp_document_detail_interpretation_sentence: '{{amount}} au {{asOfDate}} — dérivé de la ligne {{asOfDate}}',
    abcp_document_detail_interpretation_sentence_neutral: '{{amount}} au {{asOfDate}}',
    abcp_document_detail_interpretation_interpreting: 'Interprétation en cours',
    abcp_document_detail_interpretation_no_value: 'Interprété, sans montant',
    abcp_document_detail_interpretation_none: 'Non interprété',
    abcp_document_detail_interpretation_disabled: 'Interprétation désactivée pour cette organisation',
    abcp_document_detail_value_balance: 'Solde',
    abcp_document_detail_value_market_value: 'Valeur de marché',
    abcp_document_detail_value_cost: 'Valeur d’acquisition',
    abcp_document_detail_value_as_of: 'au {{date}}',
    abcp_document_detail_document_date: 'Date du justificatif : {{date}}',
    // REV-22010 — the AI pipeline's document feedback: reading state, interpretation reason, proposal refusal, hub banner.
    abcp_document_reading_title: 'Lecture IA',
    abcp_document_reading_read: 'Lu par l\'IA',
    abcp_document_reading_state_pending: 'Pas encore lu par l\'IA',
    abcp_document_reading_state_reading: 'En cours de lecture par l\'IA',
    abcp_document_reading_state_deferred_daily_cap: 'Limite journalière atteinte – sera lu demain',
    abcp_document_reading_state_failed: 'L\'IA n\'a pas pu lire ce justificatif',
    abcp_document_reading_state_not_supported: 'Format non lu par l\'IA (PDF uniquement)',
    abcp_document_reading_quality_structure_fail: 'Structure des pages pas entièrement saisie',
    abcp_document_reading_quality_findings: '{{count}} anomalie(s) lors de la lecture',
    abcp_document_detail_interpretation_limit_reached: 'Interprétation en pause',
    abcp_document_interpretation_reason_not_enabled: 'L\'interprétation des justificatifs n\'est pas activée dans les paramètres IA.',
    abcp_document_interpretation_reason_limit_reached: 'La limite de jetons IA de l\'organisation est atteinte.',
    abcp_document_interpretation_reason_closing_has_no_balance_sheet_date: 'La clôture n\'a pas encore de date de bilan.',
    abcp_document_interpretation_reason_reading_unusable: 'La version lue du justificatif est incomplète.',
    abcp_document_interpretation_reason_model_answer_unusable: 'La réponse de l\'IA n\'a pas passé les contrôles.',
    abcp_document_interpretation_reason_kind_not_supported: 'Il n\'existe pas de règle d\'interprétation pour ce type de justificatif.',
    abcp_document_interpretation_reason_no_booking_owner: 'Le justificatif n\'est attribué à aucun compte.',
    abcp_document_interpretation_reason_statement_dates_unreadable: 'Les dates de l\'extrait (solde initial/final) sont illisibles.',
    abcp_document_interpretation_reason_statement_ends_before_balance_sheet_date: 'L\'extrait se termine avant la date du bilan.',
    abcp_document_interpretation_reason_amount_unreadable: 'Le montant ou la devise ne sont pas lisibles sans ambiguïté.',
    abcp_document_proposal_refusal_title: 'Aucune proposition de compte',
    abcp_document_proposal_refusal_no_account_for_kind: 'Aucun compte du plan comptable n\'est associé à ce type de justificatif.',
    abcp_document_proposal_refusal_accounts_not_classified: 'Les comptes correspondants ne sont pas encore classés.',
    abcp_document_proposal_refusal_several_accounts_match: 'Plusieurs comptes sont possibles – veuillez choisir vous-même.',
    abcp_documents_ai_disabled_mapping: 'L\'attribution des justificatifs par l\'IA n\'est pas activée pour votre organisation. Les justificatifs ne reçoivent pas de proposition de compte.',
    abcp_documents_ai_disabled_interpretation: 'L\'interprétation des justificatifs par l\'IA n\'est pas activée pour votre organisation. Les justificatifs ne reçoivent pas de valeur.',
    abcp_documents_ai_disabled_both: 'L\'attribution et l\'interprétation des justificatifs par l\'IA ne sont pas activées pour votre organisation.',
    abcp_documents_ai_disabled_action: 'Ouvrir les paramètres IA',
    abcp_documents_ai_disabled_contact_admin: 'Votre administrateur peut activer l’IA dans les paramètres de l’organisation.',
    abcp_document_preview_unsupported: 'Aucun aperçu n’est disponible pour ce format de fichier.',
    abcp_document_preview_unsupported_hint: 'Le document est classé tel quel dans le bouclement.',
    abcp_document_preview_missing: 'Aperçu pas encore disponible.',
    abcp_document_preview_missing_hint: 'Le document est en cours de vérification et s’affichera ensuite ici.',
    abcp_document_detail_error: 'Impossible de charger le document.',    // REV-21361 — enveloppe du détail du compte (abcp-account-workspace)
    // REV-21363 — geteilte Vorschau (abcp-document-preview), Konto-Dokumentbereich
    // (abcp-account-documents) und geteiltes Upload-Modal (abcp-upload-modal). Flache Keys wie bei
    // den Schwester-Pure-Views. Der Augen-Tooltip des Konto-Bereichs ist bewusst KEIN eigener Key:
    // er teilt sich abcp_documents_not_relevant_mark mit Hub und Einzelseite — gleiche Handlung,
    // gleicher Satz. ⚠️ Die Modal-Copy sagt PDF, nicht "PDF oder Bild": der Ingest ist PDF-only
    // (ADR-0009 §12), der Prototyp ist an dieser Stelle überholt.
    abcp_document_preview_error: 'L’aperçu n’a pas pu être chargé.',
    abcp_account_documents_error: 'Les documents n’ont pas pu être chargés.',
    abcp_account_documents_upload: 'Téléverser un document',
    abcp_account_documents_dropzone_title: 'Glissez les fichiers ici',
    abcp_account_documents_dropzone_or: 'ou',
    abcp_account_documents_dropzone_pick: 'Sélectionner des fichiers',
    abcp_upload_modal_title: 'Téléverser des documents',
    abcp_upload_modal_close: 'Fermer',
    abcp_upload_modal_dropzone: 'Glissez les fichiers ici',
    abcp_upload_modal_hint: 'PDF uniquement · max. {{max}}',
    abcp_upload_modal_pick: 'Sélectionner des fichiers',
    abcp_upload_modal_selected: 'Fichiers sélectionnés',
    abcp_upload_modal_remove: 'Retirer de la sélection',
    abcp_upload_modal_rejected_type: 'Ce n’est pas un PDF — ne sera pas téléversé.',
    abcp_upload_modal_rejected_size: 'Trop volumineux (max. {{max}}) — ne sera pas téléversé.',
    abcp_upload_modal_failures: 'Non téléversé',
    abcp_upload_modal_progress: 'Téléversement des documents…',
    abcp_upload_modal_cancel: 'Annuler',
    abcp_upload_modal_submit: 'Téléverser des documents',
    abcp_workspace_pane_kind_ledger: 'Grand livre du compte',
    abcp_workspace_pane_kind_documents: 'Documents',
    abcp_workspace_pane_kind_comments: 'Commentaires',
    abcp_workspace_pane_kind_todos: 'En suspens',
    abcp_workspace_pane_kind_adjustments: 'Écritures de correction',
    abcp_workspace_pane_kind_activity_log: 'Journal d\'activité',
    abcp_workspace_document_balance: 'Justificatif',
    abcp_workspace_ai_as_of: 'au {{date}}',
    abcp_workspace_ai_refused: 'Aucune valeur lue',
    abcp_workspace_ai_open: 'Pas encore de valeur',
    abcp_workspace_ai_reconciling: 'Rapprochement en cours …',
    abcp_workspace_ai_reconciling_step: 'Le contrôle de clôture vérifie le compte',
    abcp_workspace_ai_not_used: 'Justificatif lu, mais non utilisé pour la clôture',
    abcp_workspace_ai_open_missing: 'Justificatif manquant : {{kind}}',
    abcp_workspace_ai_open_date_mismatch: 'Date du justificatif non conforme : {{kind}}',
    abcp_workspace_ai_open_value_pending: 'Valeur pas encore lue : {{kind}}',
    // The line under the status chip on the account card.
    abcp_workspace_reason_document_missing: 'Justificatif manquant : {{kind}}',
    abcp_workspace_reason_document_being_read: 'Lecture du justificatif …',
    abcp_workspace_reason_document_unreadable: 'La valeur n’a pas pu être lue, veuillez la saisir manuellement',
    abcp_workspace_reason_document_date_mismatch: 'Date du justificatif non conforme : {{date}} au lieu du {{balanceSheetDate}} (justificatif {{amount}})',
    abcp_workspace_reason_proofs_contradict: 'Les justificatifs se contredisent : {{list}}',
    abcp_workspace_reason_transit_not_balanced: 'Fonds en transit non soldés : {{amount}}',
    abcp_workspace_reason_reconciled_with_document: 'Rapproché avec {{kind}} au {{date}}',
    abcp_workspace_reason_reconciled_with_document_market_value: 'Rapproché avec {{kind}} au {{date}} (valeur de marché)',
    abcp_workspace_reason_reconciled_with_document_cost: 'Rapproché avec {{kind}} au {{date}} (valeur d’acquisition)',
    // REV-22005 — the hand-entered document balance and the account-state write refusals. TOP-level
    // on purpose: the account page translates the backend messageKey with a bare `t(key)`.
    abcp_workspace_document_balance_manual: 'saisi manuellement',
    abcp_error_review_flag_invalid: 'Veuillez indiquer un motif (500 caractères au maximum).',
    abcp_error_document_balance_invalid: 'La valeur du justificatif est invalide.',
    abcp_error_document_balance_currency_mismatch: 'La valeur du justificatif doit être saisie dans la devise de la clôture.',
    abcp_error_closing_currency_missing: 'Aucune devise n’est définie pour cette clôture. Définis-la d’abord dans les paramètres.',
    abcp_error_account_state_unknown_account: 'Ce compte ne fait pas partie de cette clôture.',
    abcp_error_account_state_write_failed: 'La modification n\'a pas pu être enregistrée. Veuillez réessayer plus tard.',
    abcp_workspace_pane_add: 'Ajouter une zone',
    abcp_workspace_pane_empty: 'Il n\'y a pas encore de contenu pour cette zone.',
    abcp_workspace_review_mark: 'Marquer pour révision',
    abcp_workspace_review_marked: 'Marqué pour révision',
    abcp_workspace_back: 'Retour',
    abcp_workspace_amount: 'Montant',
    abcp_workspace_reference: 'Référence',
    abcp_workspace_confirm: 'Confirmer',
    abcp_workspace_cancel: 'Annuler',
    abcp_workspace_error: 'Les détails du compte n\'ont pas pu être chargés.',
    abcp_workspace_review_dialog_title: 'Marquer pour révision',
    abcp_workspace_review_dialog_account: 'Compte {{number}} · {{name}}',
    abcp_workspace_review_dialog_question: 'Que doit vérifier le réviseur ?',
    abcp_workspace_review_dialog_placeholder:
        'p. ex. justificatif manquant — à demander en externe ou acceptable ? Merci de contresigner la position.',
    abcp_workspace_review_dialog_hint:
        'Le commentaire apparaît directement sur le compte pour le réviseur. Le statut de traitement reste inchangé.',
    abcp_workspace_review_dialog_confirm: 'Marquer',
    // REV-21366 — ABCP activity log (pure view)
    abcp_activity_count: 'Activité',
    abcp_activity_count_plural: 'Activités',
    abcp_activity_actor_unknown: 'Inconnu',
    abcp_activity_load_more: 'Afficher plus',
    abcp_activity_empty: 'Aucune activité disponible.',
    abcp_activity_error: 'Les activités n\'ont pas pu être chargées.',
    // REV-21360 — ABCP closing workspace header (pure view)
    aumico_abcp_header_erp_refresh: 'Actualiser l’ERP',
    aumico_abcp_header_tab_accounts: 'Comptes',
    aumico_abcp_header_tab_documents: 'Documents',
    aumico_abcp_header_tab_adjustments: 'Écritures de correction',
    aumico_abcp_header_tab_open_items: 'En suspens',
    aumico_abcp_header_tab_comments: 'Commentaires',
    aumico_abcp_header_crumb_account: 'Compte {{number}}',
    aumico_abcp_header_search_accounts: 'Rechercher dans tous les comptes…',
    aumico_abcp_header_search_documents: 'Rechercher dans tous les documents…',
    aumico_abcp_header_search_adjustments: 'Rechercher dans toutes les écritures…',
    aumico_abcp_header_search_open_items: 'Rechercher dans tous les éléments en suspens…',
    aumico_abcp_header_search_comments: 'Rechercher dans tous les commentaires…',
    aumico_abcp_header_error: 'Les données du bouclement n’ont pas pu être chargées.',    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    aumico_integration_sharepoint_title: 'Ajouter un dossier',
    aumico_integration_sharepoint_description:
        'Connecte ton compte Microsoft 365 pour sélectionner des dossiers depuis SharePoint ou OneDrive pour le bouclement. aumico obtient un accès en lecture seule.',
    aumico_integration_sharepoint_connect: 'Se connecter avec Microsoft 365',
    aumico_integration_sharepoint_connecting: 'Connexion en cours …',
    aumico_integration_sharepoint_connected_banner: 'Connecté',
    aumico_integration_sharepoint_read_only: 'accès en lecture seule',
    aumico_integration_sharepoint_include_subfolders: 'sous-dossiers inclus',
    aumico_integration_sharepoint_add_folder: 'Ajouter un dossier',
    aumico_integration_sharepoint_add_folder_hint: 'Ajoute le dossier qui contient les justificatifs de cette clôture.',
    aumico_integration_sharepoint_remove: 'Supprimer',
    aumico_integration_sharepoint_error: 'La connexion à Microsoft 365 a échoué. Veuillez réessayer.',
    aumico_integration_sharepoint_no_site: 'Aucun SharePoint n\'a été trouvé pour ce compte Microsoft. Vérifiez que le compte dispose d\'une licence SharePoint ou connectez un autre compte.',
    aumico_integration_sharepoint_expired: 'La connexion à Microsoft 365 a expiré. Veuillez vous reconnecter.',
    aumico_integration_sharepoint_provider_sharepoint_label: 'SharePoint',
    aumico_integration_sharepoint_provider_sharepoint_desc: 'Dossiers depuis SharePoint / OneDrive',
    aumico_integration_sharepoint_provider_google_drive_label: 'Google Drive',
    aumico_integration_sharepoint_provider_google_drive_desc: 'Dossiers depuis Google Drive',
    aumico_integration_sharepoint_provider_manual_upload_label: 'Téléversement manuel',
    aumico_integration_sharepoint_provider_manual_upload_desc: 'Téléverser des fichiers directement',
    // REV-21057 — in-app pre-consent card (aumico-rendered, shown before the Microsoft popup)
    // TODO i18n review
    aumico_integration_sharepoint_consent_heading: 'aumico souhaite accéder à Microsoft 365',
    aumico_integration_sharepoint_consent_permissions_label: 'Autorisation demandée',
    aumico_integration_sharepoint_consent_permission_files_read: 'Lire les fichiers',
    aumico_integration_sharepoint_consent_permission_files_read_desc:
        'aumico se contente de lire. Rien n’est jamais réécrit, modifié ou supprimé dans Microsoft 365.',
    aumico_integration_sharepoint_consent_permission_sites_read: 'Lire les sites et dossiers SharePoint',
    aumico_integration_sharepoint_consent_footnote:
        'Vous vous connecterez à Microsoft à l’étape suivante. Seuls les dossiers auxquels votre compte a déjà accès seront visibles.',
    aumico_integration_sharepoint_consent_allow: 'Autoriser l’accès',
    aumico_integration_sharepoint_consent_cancel: 'Annuler',
    // REV-21860 — SharePoint as an integration card in Org Settings -> Integrations.
    aumico_integration_sharepoint_displayname: 'SharePoint',
    aumico_integration_sharepoint_card_description: 'Utiliser les documents SharePoint et OneDrive dans vos clôtures.',
    aumico_integration_sharepoint_displayname_help: 'Facultatif. Sans indication, aumico nomme la connexion d’après le tenant Microsoft.',
    aumico_integration_sharepoint_connect_modal_title: 'Connecter SharePoint',
    aumico_integration_sharepoint_connect_intro: 'Connectez-vous avec un compte professionnel Microsoft pour donner à aumico un accès en lecture à SharePoint et OneDrive.',
    aumico_integration_sharepoint_connect_button: 'Se connecter avec Microsoft 365',
    aumico_integration_sharepoint_awaiting_consent: 'En attente de la confirmation dans la fenêtre Microsoft …',
    aumico_integration_sharepoint_manage_modal_title: 'Connexions SharePoint',
    aumico_integration_sharepoint_manage_empty: 'Aucune connexion SharePoint.',
    aumico_integration_sharepoint_manage_add_button: 'Ajouter une connexion',
    aumico_integration_sharepoint_manage_disconnect_button: 'Déconnecter',
    aumico_integration_sharepoint_manage_connected_at: 'Connecté depuis',
    aumico_integration_sharepoint_manage_disconnect_confirm_title: 'Vraiment déconnecter SharePoint ?',
    aumico_integration_sharepoint_manage_disconnect_confirm_text: 'La connexion sera supprimée. Les clôtures dont les dossiers renvoient à cette connexion ne pourront plus synchroniser de documents.',

    /**
     * REV-21960 / REV-21357 / REV-21378 — les clés ABCP, IMBRIQUÉES.
     *
     * Imbriquées et non plates (`aumico_abcp_…`) parce que le backend stocke des clés POINTÉES :
     * une entrée du journal porte `titleKey: 'abcp.trail.previewStatus'`. i18next tourne avec
     * `keySeparator: '.'` par défaut — seul un objet imbriqué résout ces clés.
     *
     * ⚠️ **AJOUTÉ LE 16.09.2026 (revue 4, constat R4-1) — À FAIRE RELIRE PAR UN TRADUCTEUR.**
     * Jusqu’ici ce fichier ne contenait aucune clé `abcp.*`, et comme `fallbackLng` vaut `de-CH`,
     * chacune de ces lignes affichait de la prose ALLEMANDE dans une interface française. Les textes
     * ci-dessous lèvent ce défaut ; ils sont rédigés par l’équipe de développement et n’ont pas
     * encore été relus par un traducteur professionnel.
     *
     * ⚠️ **`accountSurface.position` est ABSENT, volontairement.** Ces 30 clés sont les postes du
     * bilan et du compte de résultat selon l’**art. 959a CO**. Le français est une langue officielle
     * du Code des obligations : le libellé correct EXISTE dans le texte français de la loi et ne se
     * traduit pas — le reprendre d’ailleurs serait une faute professionnelle, pas une approximation
     * linguistique. Tant qu’il n’est pas repris du texte officiel, ces clés retombent sur `de-CH`
     * comme auparavant : aucune régression, une lacune nommée. Le garde
     * `activity-keys.unit.spec.ts` ne couvre pas ces clés — il couvre `abcp.activity.*` et
     * `abcp.trail.*`, qui sont tous présents ci-dessous.
     */
    abcp: {
        // Lignes de structure du bilan et du compte de résultat : titres de groupe, totaux, sous-totaux.
        statementLayout: {
            section: '{{heading}} en {{currency}}',
            incomeStatement: 'Compte de résultat',
            incomeStatementSection: 'Compte de résultat en {{currency}}',
            assets: 'Actifs',
            assetsTotal: 'Total des actifs',
            currentAssetsTotal: 'Total de l’actif circulant',
            nonCurrentAssetsTotal: 'Total de l’actif immobilisé',
            liabilitiesAndEquity: 'Passifs',
            liabilitiesAndEquityTotal: 'Total des passifs',
            liabilitiesTotal: 'Total des capitaux étrangers',
            currentLiabilitiesTotal: 'Total des capitaux étrangers à court terme',
            nonCurrentLiabilitiesTotal: 'Total des capitaux étrangers à long terme',
            equityTotal: 'Total des capitaux propres',
            operatingRevenueTotal: 'Total des produits d’exploitation',
            materialExpenseTotal: 'Total des charges de matériel et de marchandises',
            grossProfit: 'Bénéfice brut',
            personnelExpenseTotal: 'Total des charges de personnel',
            otherOperatingExpenseTotal: 'Total des autres charges d’exploitation',
            ebitda: 'Résultat d’exploitation avant amortissements, résultat financier et impôts (EBITDA)',
            ebit: 'Résultat d’exploitation avant résultat financier et impôts (EBIT)',
            financialResultTotal: 'Total du résultat financier',
            ancillaryResultTotal: 'Total du résultat accessoire d’exploitation',
            operatingResult: 'Résultat d’exploitation',
            nonOperatingResultTotal: 'Total du résultat hors exploitation et exceptionnel',
            resultBeforeTaxes: 'Résultat de l’exercice avant impôts',
            result: 'Résultat de l’exercice',
        },
        accountSurface: {
            // ⚠️ `position: { … }` — voir l’avertissement ci-dessus : art. 959a CO, texte officiel requis.
            // Les postes du compte de résultat (plan comptable PME). Les postes du bilan manquent toujours, voir ci-dessus.
            position: {
                INCOME_STATEMENT_PRODUCTION_REVENUE: 'Ventes de produits fabriqués',
                INCOME_STATEMENT_TRADE_REVENUE: 'Ventes de marchandises',
                INCOME_STATEMENT_SERVICE_REVENUE: 'Ventes de prestations de services',
                INCOME_STATEMENT_OTHER_REVENUE: 'Autres produits des ventes et des prestations de services',
                INCOME_STATEMENT_OWN_WORK_CAPITALISED: 'Prestations propres et consommation propre',
                INCOME_STATEMENT_REVENUE_DEDUCTIONS: 'Diminutions de produits',
                INCOME_STATEMENT_INVENTORY_CHANGES: 'Variations des stocks de produits semi-finis et finis et des prestations de services non facturées',
                INCOME_STATEMENT_MATERIAL_EXPENSE: 'Charges de matériel',
                INCOME_STATEMENT_GOODS_EXPENSE: 'Charges de marchandises',
                INCOME_STATEMENT_THIRD_PARTY_SERVICES: 'Charges de prestations de tiers',
                INCOME_STATEMENT_PRODUCTION_ENERGY: 'Charges d’énergie pour la production',
                INCOME_STATEMENT_PURCHASE_DEDUCTIONS: 'Diminutions de charges',
                INCOME_STATEMENT_WAGES: 'Charges salariales',
                INCOME_STATEMENT_SOCIAL_SECURITY: 'Charges sociales',
                INCOME_STATEMENT_OTHER_PERSONNEL: 'Autres charges de personnel',
                INCOME_STATEMENT_TEMPORARY_STAFF: 'Prestations de travail de tiers',
                INCOME_STATEMENT_PREMISES: 'Charges de locaux',
                INCOME_STATEMENT_MAINTENANCE: 'Entretien, réparations, remplacements et leasing d’immobilisations corporelles meubles',
                INCOME_STATEMENT_VEHICLES: 'Charges de véhicules et de transport',
                INCOME_STATEMENT_INSURANCE_FEES: 'Assurances choses, droits, taxes et autorisations',
                INCOME_STATEMENT_ENERGY_DISPOSAL: 'Charges d’énergie et d’évacuation des déchets',
                INCOME_STATEMENT_ADMINISTRATION: 'Charges d’administration',
                INCOME_STATEMENT_IT: 'Charges informatiques',
                INCOME_STATEMENT_ADVERTISING: 'Charges de publicité',
                INCOME_STATEMENT_OTHER_OPERATING: 'Charges d’exploitation diverses',
                INCOME_STATEMENT_DEPRECIATION: 'Amortissements et corrections de valeur sur les postes de l’actif immobilisé',
                INCOME_STATEMENT_FINANCIAL_EXPENSE: 'Charges financières',
                INCOME_STATEMENT_FINANCIAL_INCOME: 'Produits financiers',
                INCOME_STATEMENT_ANCILLARY_OPERATIONS: 'Résultat des activités annexes',
                INCOME_STATEMENT_OPERATING_PROPERTY: 'Résultat des immeubles d’exploitation',
                INCOME_STATEMENT_NON_OPERATING: 'Charges et produits hors exploitation',
                INCOME_STATEMENT_EXTRAORDINARY: 'Charges et produits exceptionnels, uniques ou hors période',
                INCOME_STATEMENT_DIRECT_TAXES: 'Impôts directs',
                // Anciennes clés de classe, encore envoyées par un backend sans les postes détaillés.
                INCOME_STATEMENT_OPERATING_REVENUE: 'Produits d’exploitation',
                INCOME_STATEMENT_COST_OF_MATERIALS: 'Charges de matériel et de marchandises',
                INCOME_STATEMENT_PERSONNEL_EXPENSE: 'Charges de personnel',
                INCOME_STATEMENT_OTHER_OPERATING_EXPENSE: 'Autres charges d’exploitation',
                INCOME_STATEMENT_ANCILLARY_RESULT: 'Résultat des activités annexes d’exploitation',
                INCOME_STATEMENT_NON_OPERATING_AND_TAX: 'Résultat hors exploitation et exceptionnel, impôts',
                INCOME_STATEMENT_CLOSING: 'Comptes de bouclement',
            },
            navBalanceSheet: 'Rapprocher les comptes de bilan',
            navIncomeStatement: 'Plausibiliser le compte de résultat',
            syncCompaniesNotLoaded: 'Les données de l’entreprise ne sont pas encore chargées. Veuillez patienter un instant et réessayer.',
            syncNoConnection: 'Aucune connexion ERP active n’est enregistrée pour ce mandat.',
            syncNoContext: 'Aucun mandat ou aucun projet dans le contexte — la récupération ERP ne peut pas démarrer.',
            PROJECT_PERIOD_MISSING: 'Le projet n’a ni période ni date de clôture dont elle pourrait découler.',
            PROJECT_NOT_FOUND: 'Ce projet est introuvable.',
            CONNECTION_REQUIRED: 'Pour ce fournisseur, la connexion et l’entreprise fournisseur sont manquantes.',
            VENDOR_PERIOD_NOT_FOUND: 'Le fournisseur ne connaît aucun exercice pour cette période.',
            erpRightsMissing: "L'ERP refuse l'accès aux données de devises ou de TVA. Veuillez vérifier les droits de lecture de l'application aumico dans l'ERP — la connexion ERP elle-même reste active.",
            abcp_error_mandate_data_unavailable: 'La récupération a échoué. Veuillez réessayer plus tard.',
            abcp_error_account_binding_invalid: 'L’affectation a été refusée.',
            abcp_error_mandate_not_found: 'Cette clôture est introuvable.',
            columnPercent: '%',
            columnDeltaAbsolute: 'Δ absolu',
            chip: {
                zeroAccounts: 'Comptes à zéro',
                all: 'Tous',
                open: 'Ouverts',
                marked: 'Marqués',
                reconciled: 'Rapprochés',
                difference: 'Écart',
            },
            columnCurrentPlain: 'Solde',
            columnPriorPlain: 'Exercice précédent',
            syncRunningTitle: 'Récupération des données',
            syncRunningSubtitle: 'Les écritures et les comptes sont chargés depuis l’ERP.',
            syncRunningHint: 'Cela peut prendre un moment si plusieurs périodes sont concernées. Veuillez laisser la fenêtre ouverte.',
            syncDoneTitle: 'Synchronisation terminée',
            syncDoneAll: 'Terminé — toutes les périodes demandées ont été récupérées.',
            syncDonePartly: 'Terminé, mais une période de comparaison n’a pas pu être récupérée.',
            syncDoneClose: 'Fermer',
            syncDonePeriod: 'Période',
            syncDoneAccounts: 'Comptes dans l’ERP',
            syncDoneJournalOnly: 'Uniquement dans le journal',
            syncDoneStatesCreated: 'Nouvellement créés',
            syncDoneVatUnreadable: "Le code TVA manque pour {{count}} pièce(s) : l'ERP ne les a pas transmises (supprimées ou non lisibles pour l'application aumico). Toutes les autres données sont chargées.",
            syncDoneComparisons: 'Périodes de comparaison',
            syncTitle: 'Synchronisation ERP',
            syncIntro: 'Récupère les écritures de cette clôture depuis l’ERP.',
            syncOwnHeading: 'Période en cours',
            syncOwnPeriod: 'Cet exercice : {{range}}',
            syncHeldHeading: 'Déjà disponibles',
            syncHeldHint:
                'Ces périodes sont déjà enregistrées et ne seront pas récupérées à nouveau — elles peuvent appartenir à un projet clôturé.',
            syncFetchHeading: 'Charger les années précédentes',
            syncTagWillFetch: 'sera mise à jour',
            syncTagHeld: 'disponible',
            syncMaxPeriodsReached:
                'Cinq périodes sont enregistrées — le compte de résultat n’en affiche pas davantage. Il n’y a rien à recharger.',
            syncNothingHeldYet:
                'Lors de la première synchronisation, seule la période en cours est récupérée. Les périodes de comparaison peuvent être ajoutées ensuite.',
            syncNoRowsChosen: 'Aucune période de comparaison sélectionnée.',
            syncFrom: 'Du',
            syncTo: 'Au',
            syncAddPeriod: 'Ajouter une période',
            syncMaxRowsReached: 'Au maximum cinq exercices sont possibles, celui-ci compris.',
            syncRemovePeriod: 'Supprimer',
            syncIncompleteRow: 'Veuillez indiquer une date de début et de fin pour chaque période.',
            syncStart: 'Démarrer la synchronisation',
            syncCancel: 'Annuler',
            syncOutcome: {
                FILLED: 'récupérée',
                ALREADY_PRESENT: 'était déjà disponible',
                FAILED: 'échec',
            },
            comparisonYears: 'Autres exercices :',
            comparisonPeriodMissing:
                'Aucun journal n’est encore disponible pour {{periods}}. Démarrez la synchronisation ERP pour charger la période.',
            unpositionedNotice:
                'Ces comptes n’ont pas encore de position et ne sont pas affichés : {{accounts}}. Attribuez-les dans le plan comptable pour les afficher.',
            zeroAccountsLocked: 'Attribuez d’abord les {{n}} comptes à solde nul dans le plan comptable.',
            toggle: {
                percentOfRevenue: '% du produit d’exploitation',
                priorYearComparison: 'Comparaison avec l’exercice précédent',
            },
            unassignedGroup: 'Sans poste',
            unassignedBanner: '{{count}} comptes ne sont affectés à aucun poste',
            classificationRunning: 'L’IA affecte les comptes de cette clôture — {{open}} sur {{total}} encore en cours',
            classificationOverdue:
                'L’affectation est en attente depuis plus de dix minutes. Veuillez relancer la synchronisation ERP.',
            classificationDone: 'Affectation terminée — tous les comptes sont affectés à un poste',
            unassignedBannerAction: 'Affecter maintenant',
            assignTitle: 'Affecter le compte',
            assignPositionLabel: 'Poste',
            assignPositionPlaceholder: 'Choisir un poste',
            assignSkip: 'Ignorer',
            assignSave: 'Enregistrer',
            assignProgress: 'Compte {{index}} sur {{total}}',
            assignDone: 'Tous les comptes sont affectés.',
            columnCurrent: 'Solde {{year}}',
            columnPrior: 'Solde {{year}}',
            columnDelta: 'Δ%',
        },
        /** REV-21378 — la moitié HUMAINE du journal d’activité (`abcp_closing_activity`). */
        activity: {
            // REV-22005 — review flag and hand-entered document balance (N-2.2, N-3.5).
            reviewFlagged: 'Marqué pour révision',
            reviewUnflagged: 'Marque de révision retirée',
            documentBalanceEntered: 'Valeur du justificatif saisie manuellement',
            documentBalanceCleared: 'Valeur du justificatif supprimée',
            documentBalanceConflict: 'Valeur du justificatif saisie manuellement conservée – l\'exécution IA ne l\'a pas écrasée',
            evidenceAssigned: '{{count}} justificatif(s) affecté(s)',
            evidenceAssignedDetail: 'Affectation effectuée par une personne',
            evidenceUnassigned: 'Affectation annulée',
            classificationChanged: 'Affectation du compte modifiée',
            classificationChangedDetail: 'Nouveau groupe : {{group}}',
            statusChanged: 'Statut modifié',
            statusChangedDetail: 'Nouveau statut : {{to}}',
            erpSynced: 'La synchronisation ERP a touché ce compte',
            adjustmentBooked: 'Écriture de correction saisie',
            adjustmentDiscarded: 'Écriture de correction annulée',
            adjustmentTransferred: 'Écriture de correction transmise à l’ERP',
            adjustmentEdited: 'Écriture de correction modifiée',
            orComplianceChecked: 'Conformité au CO vérifiée',
        },
        trail: {
            // The lines a per-account run writes.
            runStarted: 'Rapprochement démarré : {{trigger}}',
            documentRead: '{{kind}} lu : {{amount}} au {{date}}',
            documentUnreadable: '{{kind}} : la valeur n’a pas pu être lue',
            compared: 'Comparé avec la comptabilité : {{outcome}}',
            runFailed: 'Le rapprochement a échoué, rien n’a été modifié',
            // REV-22005 — a run found hand-entered document balances and kept them (N-3.5).
            manualDocumentBalanceKept: '{{count}} valeur(s) de justificatif saisie(s) manuellement conservée(s)',
            runPlanned: '{{units}} unités de travail planifiées sur {{positions}} poste(s)',
            unitBlocked: 'Étape bloquée : {{code}}',
            fixtureMode: 'ATTENTION mode fixture ({{mode}}) : le traitement calcule sur des données de test fictives, et non sur des données de mandat',
            positionStarted: 'Poste {{positionId}} démarré (jeu de règles {{rulePackId}} {{version}})',
            journalAnalysed: 'Grand livre analysé : {{accounts}} comptes lus',
            evidenceAssigned: '{{documents}} justificatifs affectés ({{perAccount}} par compte)',
            engineDispatched: 'Moteur {{entry}} appelé',
            differenceDetected: 'Écart constaté sur {{accountName}}',
            findingIdentified: 'Cause identifiée sur {{accountName}}',
            proposalsGenerated: '{{proposals}} proposition(s) d’écriture créée(s) pour {{accountName}}',
            previewStatus: 'Aperçu pour {{accountName}}',
            reconciled: 'Justificatif rapproché du solde : {{accountName}}',
            baseCurrencyDefaulted: 'Monnaie de base retenue par défaut ({{currency}})',
            accountStateWriteFailed: 'Le statut du compte n’a pas pu être réenregistré',
            runAborted: 'Traitement interrompu : {{reason}}',
            trusteeAsked: 'Question adressée à la fiduciaire',
            orComplianceChecked: 'Conformité au CO vérifiée',
            statusChanged: 'Statut modifié : {{status}}',
            positionNotImplemented: 'Il n’existe pas encore de jeu de règles pour le poste {{positionId}}',
            entryRefused: 'Une entrée du journal n’a pas pu être enregistrée à cet endroit',
            detail: {
                unbookedBankCharges: 'Frais bancaires non comptabilisés',
            },
        },
        block: {
            unresolvedAccountGroup: 'Aucun compte ne peut être résolu pour le poste {{positionId}} — la surface des comptes ABCP n’existe pas encore',
            fixtureRunBlocked: 'Le traitement fixture a été bloqué ({{code}})',
            noFixturePosition: 'Il n’existe aucun jeu fixture pour le poste {{positionId}}',
        },
        catalog: {
            engineReconciliation: 'Rapprochement',
            engineValuation: 'Évaluation',
            toolBalanceAggregation: 'Agrégation des soldes',
            toolOpenItemMatching: 'Lettrage des postes ouverts',
            toolMateriality: 'Importance relative',
            toolFxBazg: 'Cours des devises (OFDF)',
            toolAgingBuckets: 'Classes d’échéance',
            toolDerivationBuilder: 'Dérivation',
            toolBookingProposalBuilder: 'Proposition d’écriture',
            genaiAccountGroupClassifier: 'Classification des groupes de comptes',
            genaiRootCauseAnalysis: 'Analyse des causes',
            gateFinal: 'Contrôle final',
        },
    },
    // Outbound Partner-API clients (REV-21638)
    aumico_outbound_api_section_title: 'Outbound API Integration',
    aumico_outbound_api_section_description: 'Crée des identifiants permettant à des outils externes de récupérer des données d\'aumico. Le secret ne s\'affiche qu\'une seule fois — conserve-le en lieu sûr.',
    aumico_outbound_api_create_button: 'Créer de nouveaux identifiants',
    aumico_outbound_api_status_revoked: 'Révoqué',
    aumico_outbound_api_scopes_label_long: 'Autorisations (scopes)',
    aumico_outbound_api_scope_read_organization: 'Lire l\'organisation et les utilisateurs',
    aumico_outbound_api_scope_read_companies: 'Lire les sociétés',
    aumico_outbound_api_scope_read_financials: 'Lire les bilans et comptes de résultat',
    aumico_outbound_api_scope_write_mappings: 'Écrire les correspondances de mandats',
    aumico_outbound_api_create_modal_title: 'Nouveaux identifiants API',
    aumico_outbound_api_name_label: 'Nom',
    aumico_outbound_api_name_placeholder: 'p. ex. export PowerBI',
    aumico_outbound_api_create_submit: 'Créer',
    aumico_outbound_api_secret_modal_title: 'Tes identifiants',
    aumico_outbound_api_secret_warning: 'Le client secret ne s\'affiche que maintenant et ne pourra plus être récupéré. Copie-le et conserve-le en lieu sûr.',
    aumico_outbound_api_client_id_label: 'Client ID',
    aumico_outbound_api_client_secret_label: 'Client secret',
    aumico_outbound_api_copy: 'Copier',
    aumico_outbound_api_copied: 'Copié',
    aumico_outbound_api_done: 'Terminé',
    aumico_outbound_api_created_label: 'Créé le',
    aumico_outbound_api_rotated_label: 'Secret renouvelé le',
    aumico_outbound_api_rotate_button: 'Renouveler le secret',
    aumico_outbound_api_revoke_button: 'Révoquer',
    aumico_outbound_api_revoke_confirm_title: 'Révoquer les identifiants ?',
    aumico_outbound_api_revoke_confirm_text: 'L\'accès prend fin immédiatement : tous les tokens émis avec ces identifiants deviennent invalides. Cette action est irréversible.',
    aumico_outbound_api_revoke_confirm_button: 'Révoquer définitivement',
    aumico_outbound_api_error_generic: 'Ça n\'a pas fonctionné. Réessaie.',
    aumico_partner_connect_section_title: 'Applications partenaires',
    aumico_partner_connect_section_description:
        "Connecte aumico aux applications partenaires. La connexion vaut pour toute l'organisation et peut être coupée ici à tout moment.",
    aumico_partner_connect_status_connected: 'Connecté',
    aumico_partner_connect_status_not_connected: 'Non connecté',
    aumico_partner_connect_connect_button: 'Connecter {{partner}}',
    aumico_partner_connect_disconnect_button: 'Déconnecter',
    aumico_partner_connect_disconnect_confirm_text:
        "L'accès prend fin immédiatement : tous les jetons de cette connexion deviennent invalides. Les attributions de mandats existantes sont conservées.",
    aumico_partner_connect_disconnect_confirm_button: 'Déconnecter définitivement',
    aumico_oauth_authorize_loading: 'Vérification de la demande …',
    aumico_oauth_authorize_redirecting: 'Redirection en cours …',
    aumico_oauth_authorize_consent_title: 'Connecter {{clientName}}',
    aumico_oauth_authorize_consent_extension_title: '{{clientName}} demande des autorisations supplémentaires',
    aumico_oauth_authorize_consent_text: "{{clientName}} obtiendra pour toute ton organisation l'accès à :",
    aumico_oauth_authorize_approve_button: 'Autoriser',
    aumico_oauth_authorize_deny_button: 'Refuser',
    aumico_oauth_authorize_not_admin_title: "Droits d'administrateur requis",
    aumico_oauth_authorize_not_admin_text:
        "Seul un administrateur de ton organisation peut connecter {{clientName}}. Demande à ton administrateur d'établir la connexion.",
    aumico_oauth_authorize_error_title: 'Connexion impossible',
    aumico_oauth_authorize_error_invalid_request: "La demande est incomplète ou invalide. Relance la connexion depuis l'application partenaire.",
    aumico_oauth_authorize_error_unknown_client: "aumico ne connaît pas cette application. Aucune connexion n'a été établie.",
    aumico_oauth_authorize_error_redirect_uri: "L'adresse de retour de l'application n'est pas enregistrée. Aucune connexion n'a été établie.",
    aumico_oauth_authorize_error_invalid_scope: "L'application demande des autorisations auxquelles elle n'a pas droit. Aucune connexion n'a été établie.",
    aumico_oauth_authorize_error_generic: "Cela n'a malheureusement pas fonctionné. Relance la connexion depuis l'application partenaire.",
    aumico_oauth_authorize_footnote: "Après confirmation, tu seras redirigé vers l'application partenaire. La connexion peut être coupée à tout moment sous Paramètres de l'organisation → Intégrations.",
    aumico_partner_connect_card_description: "Application partenaire avec accès à toute l'organisation via l'aumico Partner API.",
    aumico_partner_connect_card_description_aprivo:
        "Aprivo synchronise les mandats avec aumico et récupère bilans et comptes de résultat directement depuis tes clôtures annuelles.",
    aumico_partner_connect_modal_status_label: 'Statut',
    aumico_partner_connect_modal_text:
        "{{partner}} obtient l'accès à ton organisation via la Partner API — dans la limite des autorisations ci-dessous. La connexion peut être coupée ici à tout moment.",
    aumico_partner_connect_modal_text_aprivo:
        "Aprivo accède à ton organisation pour synchroniser les mandats avec aumico et récupérer bilans et comptes de résultat directement depuis tes clôtures annuelles — dans la limite des autorisations ci-dessous. La connexion peut être coupée ici à tout moment.",
    aumico_partner_connect_disconnect_confirm_title: 'Couper la connexion ?',
    aumico_outbound_api_card_description: "Identifiants API qu'un outil externe utilise pour lire des données d'aumico.",
};
